import { apiConfigSlice as api } from './api-config.slice';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getActivitiesLatest: build.query<GetActivitiesLatestApiResponse, GetActivitiesLatestApiArg>({
      query: () => ({ url: `/activities/latest` }),
    }),
    getAgreementParties: build.query<GetAgreementPartiesApiResponse, GetAgreementPartiesApiArg>({
      query: (queryArg) => ({
        url: `/agreement-parties`,
        params: {
          'spaceId.Equal': queryArg['spaceId.Equal'],
          'spaceAncestorPath.Equal': queryArg['spaceAncestorPath.Equal'],
          'status.Contains': queryArg['status.Contains'],
          'active.Equal': queryArg['active.Equal'],
          'type.Contains': queryArg['type.Contains'],
          'at.Equal.Start': queryArg['at.Equal.Start'],
          'at.Equal.End': queryArg['at.Equal.End'],
          'sort.Property': queryArg['sort.Property'],
          'sort.Order': queryArg['sort.Order'],
          'pagination.Offset': queryArg['pagination.Offset'],
          'pagination.Limit': queryArg['pagination.Limit'],
          search: queryArg.search,
        },
      }),
    }),
    postAgreementImportsBySessionIdAbandon: build.mutation<
      PostAgreementImportsBySessionIdAbandonApiResponse,
      PostAgreementImportsBySessionIdAbandonApiArg
    >({
      query: (queryArg) => ({ url: `/agreement-imports/${queryArg.sessionId}/abandon`, method: 'POST' }),
    }),
    postAgreementImportsBySessionIdContractsAndContractIdApprove: build.mutation<
      PostAgreementImportsBySessionIdContractsAndContractIdApproveApiResponse,
      PostAgreementImportsBySessionIdContractsAndContractIdApproveApiArg
    >({
      query: (queryArg) => ({
        url: `/agreement-imports/${queryArg.sessionId}/contracts/${queryArg.contractId}/approve`,
        method: 'POST',
      }),
    }),
    postAgreementImportsBySessionIdComplete: build.mutation<
      PostAgreementImportsBySessionIdCompleteApiResponse,
      PostAgreementImportsBySessionIdCompleteApiArg
    >({
      query: (queryArg) => ({ url: `/agreement-imports/${queryArg.sessionId}/complete`, method: 'POST' }),
    }),
    patchAgreementImportsBySessionIdContractsAndContractId: build.mutation<
      PatchAgreementImportsBySessionIdContractsAndContractIdApiResponse,
      PatchAgreementImportsBySessionIdContractsAndContractIdApiArg
    >({
      query: (queryArg) => ({
        url: `/agreement-imports/${queryArg.sessionId}/contracts/${queryArg.contractId}`,
        method: 'PATCH',
        body: queryArg.body,
      }),
    }),
    postAgreementImports: build.mutation<PostAgreementImportsApiResponse, PostAgreementImportsApiArg>({
      query: (queryArg) => ({ url: `/agreement-imports`, method: 'POST', body: queryArg.body }),
    }),
    getAgreementImports: build.query<GetAgreementImportsApiResponse, GetAgreementImportsApiArg>({
      query: (queryArg) => ({ url: `/agreement-imports`, params: { buildingSpaceId: queryArg.buildingSpaceId } }),
    }),
    getAgreementImportsBySessionIdContracts: build.query<
      GetAgreementImportsBySessionIdContractsApiResponse,
      GetAgreementImportsBySessionIdContractsApiArg
    >({
      query: (queryArg) => ({ url: `/agreement-imports/${queryArg.sessionId}/contracts` }),
    }),
    getAgreementImportsBySessionIdContractsAndContractIdValidation: build.query<
      GetAgreementImportsBySessionIdContractsAndContractIdValidationApiResponse,
      GetAgreementImportsBySessionIdContractsAndContractIdValidationApiArg
    >({
      query: (queryArg) => ({
        url: `/agreement-imports/${queryArg.sessionId}/contracts/${queryArg.contractId}/validation`,
      }),
    }),
    postAgreementImportsBySessionIdRows: build.mutation<
      PostAgreementImportsBySessionIdRowsApiResponse,
      PostAgreementImportsBySessionIdRowsApiArg
    >({
      query: (queryArg) => ({
        url: `/agreement-imports/${queryArg.sessionId}/rows`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    postAgreementImportsBySessionIdContractsAndContractIdReject: build.mutation<
      PostAgreementImportsBySessionIdContractsAndContractIdRejectApiResponse,
      PostAgreementImportsBySessionIdContractsAndContractIdRejectApiArg
    >({
      query: (queryArg) => ({
        url: `/agreement-imports/${queryArg.sessionId}/contracts/${queryArg.contractId}/reject`,
        method: 'POST',
      }),
    }),
    postAgreementImportsBySessionIdContractsAndContractIdLinesLineIdReject: build.mutation<
      PostAgreementImportsBySessionIdContractsAndContractIdLinesLineIdRejectApiResponse,
      PostAgreementImportsBySessionIdContractsAndContractIdLinesLineIdRejectApiArg
    >({
      query: (queryArg) => ({
        url: `/agreement-imports/${queryArg.sessionId}/contracts/${queryArg.contractId}/lines/${queryArg.lineId}/reject`,
        method: 'POST',
      }),
    }),
    postAgreements: build.mutation<PostAgreementsApiResponse, PostAgreementsApiArg>({
      query: (queryArg) => ({ url: `/agreements`, method: 'POST', body: queryArg.body }),
    }),
    getAgreements: build.query<GetAgreementsApiResponse, GetAgreementsApiArg>({
      query: (queryArg) => ({
        url: `/agreements`,
        params: {
          'userId.Equal': queryArg['userId.Equal'],
          'spaceId.Equal': queryArg['spaceId.Equal'],
          'spaceAncestorPath.Equal': queryArg['spaceAncestorPath.Equal'],
          'at.Equal.Start': queryArg['at.Equal.Start'],
          'at.Equal.End': queryArg['at.Equal.End'],
          'buildingId.Equal': queryArg['buildingId.Equal'],
          'hasNoBuilding.Equal': queryArg['hasNoBuilding.Equal'],
          'companyId.Equal': queryArg['companyId.Equal'],
          'productId.Equal': queryArg['productId.Equal'],
          'status.Equal': queryArg['status.Equal'],
          'sort.Property': queryArg['sort.Property'],
          'sort.Order': queryArg['sort.Order'],
          'pagination.Offset': queryArg['pagination.Offset'],
          'pagination.Limit': queryArg['pagination.Limit'],
          search: queryArg.search,
        },
      }),
    }),
    deleteAgreementsById: build.mutation<DeleteAgreementsByIdApiResponse, DeleteAgreementsByIdApiArg>({
      query: (queryArg) => ({ url: `/agreements/${queryArg.id}`, method: 'DELETE' }),
    }),
    getAgreementsById: build.query<GetAgreementsByIdApiResponse, GetAgreementsByIdApiArg>({
      query: (queryArg) => ({ url: `/agreements/${queryArg.id}` }),
    }),
    putAgreementsById: build.mutation<PutAgreementsByIdApiResponse, PutAgreementsByIdApiArg>({
      query: (queryArg) => ({ url: `/agreements/${queryArg.id}`, method: 'PUT', body: queryArg.body }),
    }),
    getAgreementsBuildings: build.query<GetAgreementsBuildingsApiResponse, GetAgreementsBuildingsApiArg>({
      query: (queryArg) => ({
        url: `/agreements/buildings`,
        params: {
          'pagination.Offset': queryArg['pagination.Offset'],
          'pagination.Limit': queryArg['pagination.Limit'],
          search: queryArg.search,
        },
      }),
    }),
    getAgreementsReportToInvoice: build.query<
      GetAgreementsReportToInvoiceApiResponse,
      GetAgreementsReportToInvoiceApiArg
    >({
      query: (queryArg) => ({
        url: `/agreements/report/to-invoice`,
        params: {
          periodFrom: queryArg.periodFrom,
          periodTo: queryArg.periodTo,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          'pagination.Offset': queryArg['pagination.Offset'],
          'pagination.Limit': queryArg['pagination.Limit'],
          search: queryArg.search,
        },
      }),
    }),
    postAgreementsByIdRestore: build.mutation<PostAgreementsByIdRestoreApiResponse, PostAgreementsByIdRestoreApiArg>({
      query: (queryArg) => ({ url: `/agreements/${queryArg.id}/restore`, method: 'POST' }),
    }),
    postAgreementsByIdSyncTripletex: build.mutation<
      PostAgreementsByIdSyncTripletexApiResponse,
      PostAgreementsByIdSyncTripletexApiArg
    >({
      query: (queryArg) => ({ url: `/agreements/${queryArg.id}/sync-tripletex`, method: 'POST' }),
    }),
    postAgreementsByAgreementIdIndexAdjustments: build.mutation<
      PostAgreementsByAgreementIdIndexAdjustmentsApiResponse,
      PostAgreementsByAgreementIdIndexAdjustmentsApiArg
    >({
      query: (queryArg) => ({
        url: `/agreements/${queryArg.agreementId}/index-adjustments`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    getAgreementsByAgreementIdIndexAdjustments: build.query<
      GetAgreementsByAgreementIdIndexAdjustmentsApiResponse,
      GetAgreementsByAgreementIdIndexAdjustmentsApiArg
    >({
      query: (queryArg) => ({ url: `/agreements/${queryArg.agreementId}/index-adjustments` }),
    }),
    getAgreementsStakeholders: build.query<GetAgreementsStakeholdersApiResponse, GetAgreementsStakeholdersApiArg>({
      query: (queryArg) => ({
        url: `/agreements/stakeholders`,
        params: {
          'pagination.Offset': queryArg['pagination.Offset'],
          'pagination.Limit': queryArg['pagination.Limit'],
          search: queryArg.search,
        },
      }),
    }),
    putAgreementsByAgreementIdSpaces: build.mutation<
      PutAgreementsByAgreementIdSpacesApiResponse,
      PutAgreementsByAgreementIdSpacesApiArg
    >({
      query: (queryArg) => ({ url: `/agreements/${queryArg.agreementId}/spaces`, method: 'PUT', body: queryArg.body }),
    }),
    postAgreementsByAgreementIdProducts: build.mutation<
      PostAgreementsByAgreementIdProductsApiResponse,
      PostAgreementsByAgreementIdProductsApiArg
    >({
      query: (queryArg) => ({
        url: `/agreements/${queryArg.agreementId}/products`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    putAgreementsByAgreementIdProducts: build.mutation<
      PutAgreementsByAgreementIdProductsApiResponse,
      PutAgreementsByAgreementIdProductsApiArg
    >({
      query: (queryArg) => ({
        url: `/agreements/${queryArg.agreementId}/products`,
        method: 'PUT',
        body: queryArg.body,
      }),
    }),
    deleteAgreementsByAgreementIdProductsAndPriceId: build.mutation<
      DeleteAgreementsByAgreementIdProductsAndPriceIdApiResponse,
      DeleteAgreementsByAgreementIdProductsAndPriceIdApiArg
    >({
      query: (queryArg) => ({
        url: `/agreements/${queryArg.agreementId}/products/${queryArg.priceId}`,
        method: 'DELETE',
      }),
    }),
    putAgreementsByAgreementIdProductsAndPriceId: build.mutation<
      PutAgreementsByAgreementIdProductsAndPriceIdApiResponse,
      PutAgreementsByAgreementIdProductsAndPriceIdApiArg
    >({
      query: (queryArg) => ({
        url: `/agreements/${queryArg.agreementId}/products/${queryArg.priceId}`,
        method: 'PUT',
        body: queryArg.body,
      }),
    }),
    postAgreementsByAgreementIdParties: build.mutation<
      PostAgreementsByAgreementIdPartiesApiResponse,
      PostAgreementsByAgreementIdPartiesApiArg
    >({
      query: (queryArg) => ({
        url: `/agreements/${queryArg.agreementId}/parties`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    putAgreementsByAgreementIdParties: build.mutation<
      PutAgreementsByAgreementIdPartiesApiResponse,
      PutAgreementsByAgreementIdPartiesApiArg
    >({
      query: (queryArg) => ({ url: `/agreements/${queryArg.agreementId}/parties`, method: 'PUT', body: queryArg.body }),
    }),
    deleteAgreementsByAgreementIdPartiesAndLegalPersonId: build.mutation<
      DeleteAgreementsByAgreementIdPartiesAndLegalPersonIdApiResponse,
      DeleteAgreementsByAgreementIdPartiesAndLegalPersonIdApiArg
    >({
      query: (queryArg) => ({
        url: `/agreements/${queryArg.agreementId}/parties/${queryArg.legalPersonId}`,
        method: 'DELETE',
      }),
    }),
    getAgreementsByAgreementIdPartiesAndPartyIdAvailableContacts: build.query<
      GetAgreementsByAgreementIdPartiesAndPartyIdAvailableContactsApiResponse,
      GetAgreementsByAgreementIdPartiesAndPartyIdAvailableContactsApiArg
    >({
      query: (queryArg) => ({
        url: `/agreements/${queryArg.agreementId}/parties/${queryArg.partyId}/available-contacts`,
      }),
    }),
    getAgreementsByAgreementIdInvoiceHistory: build.query<
      GetAgreementsByAgreementIdInvoiceHistoryApiResponse,
      GetAgreementsByAgreementIdInvoiceHistoryApiArg
    >({
      query: (queryArg) => ({ url: `/agreements/${queryArg.agreementId}/invoice-history` }),
    }),
    postAgreementsByAgreementIdFiles: build.mutation<
      PostAgreementsByAgreementIdFilesApiResponse,
      PostAgreementsByAgreementIdFilesApiArg
    >({
      query: (queryArg) => ({ url: `/agreements/${queryArg.agreementId}/files`, method: 'POST', body: queryArg.body }),
    }),
    getAgreementsByAgreementIdFiles: build.query<
      GetAgreementsByAgreementIdFilesApiResponse,
      GetAgreementsByAgreementIdFilesApiArg
    >({
      query: (queryArg) => ({
        url: `/agreements/${queryArg.agreementId}/files`,
        params: {
          'agreementId.Equal': queryArg['agreementId.Equal'],
          'pagination.Offset': queryArg['pagination.Offset'],
          'pagination.Limit': queryArg['pagination.Limit'],
          search: queryArg.search,
        },
      }),
    }),
    deleteAgreementsByAgreementIdFilesAndFileId: build.mutation<
      DeleteAgreementsByAgreementIdFilesAndFileIdApiResponse,
      DeleteAgreementsByAgreementIdFilesAndFileIdApiArg
    >({
      query: (queryArg) => ({ url: `/agreements/${queryArg.agreementId}/files/${queryArg.fileId}`, method: 'DELETE' }),
    }),
    getAgreementsByAgreementIdFilesAndFileIdDownload: build.query<
      GetAgreementsByAgreementIdFilesAndFileIdDownloadApiResponse,
      GetAgreementsByAgreementIdFilesAndFileIdDownloadApiArg
    >({
      query: (queryArg) => ({ url: `/agreements/${queryArg.agreementId}/files/${queryArg.fileId}/download` }),
    }),
    getAgreementsByAgreementIdActivityLogs: build.query<
      GetAgreementsByAgreementIdActivityLogsApiResponse,
      GetAgreementsByAgreementIdActivityLogsApiArg
    >({
      query: (queryArg) => ({
        url: `/agreements/${queryArg.agreementId}/activity-logs`,
        params: { orderBy: queryArg.orderBy, page: queryArg.page, pageSize: queryArg.pageSize },
      }),
    }),
    postAuthFinishInvitation: build.mutation<PostAuthFinishInvitationApiResponse, PostAuthFinishInvitationApiArg>({
      query: (queryArg) => ({ url: `/auth/finish-invitation`, method: 'POST', body: queryArg.body }),
    }),
    getAuthSession: build.query<GetAuthSessionApiResponse, GetAuthSessionApiArg>({
      query: () => ({ url: `/auth/session` }),
    }),
    getAuthSessionUser: build.query<GetAuthSessionUserApiResponse, GetAuthSessionUserApiArg>({
      query: () => ({ url: `/auth/session/user` }),
    }),
    postBranches: build.mutation<PostBranchesApiResponse, PostBranchesApiArg>({
      query: (queryArg) => ({ url: `/branches`, method: 'POST', body: queryArg.body }),
    }),
    deleteBranchesById: build.mutation<DeleteBranchesByIdApiResponse, DeleteBranchesByIdApiArg>({
      query: (queryArg) => ({ url: `/branches/${queryArg.id}`, method: 'DELETE' }),
    }),
    putBranchesById: build.mutation<PutBranchesByIdApiResponse, PutBranchesByIdApiArg>({
      query: (queryArg) => ({ url: `/branches/${queryArg.id}`, method: 'PUT', body: queryArg.body }),
    }),
    postBuildings: build.mutation<PostBuildingsApiResponse, PostBuildingsApiArg>({
      query: (queryArg) => ({ url: `/buildings`, method: 'POST', body: queryArg.body }),
    }),
    getBuildings: build.query<GetBuildingsApiResponse, GetBuildingsApiArg>({
      query: (queryArg) => ({
        url: `/buildings`,
        params: {
          'type.Contains': queryArg['type.Contains'],
          'energyLabel.Contains': queryArg['energyLabel.Contains'],
          'country.Equal': queryArg['country.Equal'],
          'constructionYear.From': queryArg['constructionYear.From'],
          'constructionYear.To': queryArg['constructionYear.To'],
          'location.From.Longitude': queryArg['location.From.Longitude'],
          'location.From.Latitude': queryArg['location.From.Latitude'],
          'location.RadiusMetric': queryArg['location.RadiusMetric'],
          'availableAreaMetric.From': queryArg['availableAreaMetric.From'],
          'availableAreaMetric.To': queryArg['availableAreaMetric.To'],
          'parentId.Equal': queryArg['parentId.Equal'],
          'rootId.Equal': queryArg['rootId.Equal'],
          'ancestorPath.Equal': queryArg['ancestorPath.Equal'],
          'discriminator.Contains': queryArg['discriminator.Contains'],
          'usageType.Contains': queryArg['usageType.Contains'],
          'standard.Contains': queryArg['standard.Contains'],
          'totalAreaMetric.From': queryArg['totalAreaMetric.From'],
          'totalAreaMetric.To': queryArg['totalAreaMetric.To'],
          'available.Equal.Start': queryArg['available.Equal.Start'],
          'available.Equal.End': queryArg['available.Equal.End'],
          'vacant.Equal.Start': queryArg['vacant.Equal.Start'],
          'vacant.Equal.End': queryArg['vacant.Equal.End'],
          'hasRent.Equal': queryArg['hasRent.Equal'],
          'bedroomCount.From': queryArg['bedroomCount.From'],
          'bedroomCount.To': queryArg['bedroomCount.To'],
          'bathroomCount.From': queryArg['bathroomCount.From'],
          'bathroomCount.To': queryArg['bathroomCount.To'],
          'tags.Contains': queryArg['tags.Contains'],
          'requiredPackage.Equal': queryArg['requiredPackage.Equal'],
          'sort.Property': queryArg['sort.Property'],
          'sort.Order': queryArg['sort.Order'],
          'pagination.Offset': queryArg['pagination.Offset'],
          'pagination.Limit': queryArg['pagination.Limit'],
          search: queryArg.search,
        },
      }),
    }),
    createBuildingsForTenant: build.mutation<CreateBuildingsForTenantApiResponse, CreateBuildingsForTenantApiArg>({
      query: (queryArg) => ({ url: `/buildings/bulk`, method: 'POST', body: queryArg.body }),
    }),
    getBuildingsByBuildingIdAvailableBidAreas: build.query<
      GetBuildingsByBuildingIdAvailableBidAreasApiResponse,
      GetBuildingsByBuildingIdAvailableBidAreasApiArg
    >({
      query: (queryArg) => ({ url: `/buildings/${queryArg.buildingId}/available-bid-areas` }),
    }),
    getBuildingsByBuildingIdBidArea: build.query<
      GetBuildingsByBuildingIdBidAreaApiResponse,
      GetBuildingsByBuildingIdBidAreaApiArg
    >({
      query: (queryArg) => ({ url: `/buildings/${queryArg.buildingId}/bid-area` }),
    }),
    putBuildingsByBuildingIdBidArea: build.mutation<
      PutBuildingsByBuildingIdBidAreaApiResponse,
      PutBuildingsByBuildingIdBidAreaApiArg
    >({
      query: (queryArg) => ({ url: `/buildings/${queryArg.buildingId}/bid-area`, method: 'PUT', body: queryArg.body }),
    }),
    getBuildingsById: build.query<GetBuildingsByIdApiResponse, GetBuildingsByIdApiArg>({
      query: (queryArg) => ({ url: `/buildings/${queryArg.id}` }),
    }),
    putBuildingsById: build.mutation<PutBuildingsByIdApiResponse, PutBuildingsByIdApiArg>({
      query: (queryArg) => ({ url: `/buildings/${queryArg.id}`, method: 'PUT', body: queryArg.body }),
    }),
    getBuildingsByBuildingIdEnergySettings: build.query<
      GetBuildingsByBuildingIdEnergySettingsApiResponse,
      GetBuildingsByBuildingIdEnergySettingsApiArg
    >({
      query: (queryArg) => ({ url: `/buildings/${queryArg.buildingId}/energy-settings` }),
    }),
    putBuildingsByBuildingIdEnergySettings: build.mutation<
      PutBuildingsByBuildingIdEnergySettingsApiResponse,
      PutBuildingsByBuildingIdEnergySettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/buildings/${queryArg.buildingId}/energy-settings`,
        method: 'PUT',
        body: queryArg.body,
      }),
    }),
    getBuildingsByIdInvestor: build.query<GetBuildingsByIdInvestorApiResponse, GetBuildingsByIdInvestorApiArg>({
      query: (queryArg) => ({ url: `/buildings/${queryArg.id}/investor` }),
    }),
    getBuildingsByIdManager: build.query<GetBuildingsByIdManagerApiResponse, GetBuildingsByIdManagerApiArg>({
      query: (queryArg) => ({ url: `/buildings/${queryArg.id}/manager` }),
    }),
    getBuildingsByIdOwner: build.query<GetBuildingsByIdOwnerApiResponse, GetBuildingsByIdOwnerApiArg>({
      query: (queryArg) => ({ url: `/buildings/${queryArg.id}/owner` }),
    }),
    getCompaniesAtBuildingAddress: build.query<
      GetCompaniesAtBuildingAddressApiResponse,
      GetCompaniesAtBuildingAddressApiArg
    >({
      query: (queryArg) => ({ url: `/buildings/${queryArg.id}/companies-at-address` }),
    }),
    getCommercialSpacesById: build.query<GetCommercialSpacesByIdApiResponse, GetCommercialSpacesByIdApiArg>({
      query: (queryArg) => ({ url: `/commercial-spaces/${queryArg.id}` }),
    }),
    getCommercialSpaces: build.query<GetCommercialSpacesApiResponse, GetCommercialSpacesApiArg>({
      query: (queryArg) => ({
        url: `/commercial-spaces`,
        params: {
          'parentId.Equal': queryArg['parentId.Equal'],
          'rootId.Equal': queryArg['rootId.Equal'],
          'ancestorPath.Equal': queryArg['ancestorPath.Equal'],
          'discriminator.Contains': queryArg['discriminator.Contains'],
          'usageType.Contains': queryArg['usageType.Contains'],
          'standard.Contains': queryArg['standard.Contains'],
          'totalAreaMetric.From': queryArg['totalAreaMetric.From'],
          'totalAreaMetric.To': queryArg['totalAreaMetric.To'],
          'available.Equal.Start': queryArg['available.Equal.Start'],
          'available.Equal.End': queryArg['available.Equal.End'],
          'vacant.Equal.Start': queryArg['vacant.Equal.Start'],
          'vacant.Equal.End': queryArg['vacant.Equal.End'],
          'hasRent.Equal': queryArg['hasRent.Equal'],
          'bedroomCount.From': queryArg['bedroomCount.From'],
          'bedroomCount.To': queryArg['bedroomCount.To'],
          'bathroomCount.From': queryArg['bathroomCount.From'],
          'bathroomCount.To': queryArg['bathroomCount.To'],
          'tags.Contains': queryArg['tags.Contains'],
          'requiredPackage.Equal': queryArg['requiredPackage.Equal'],
          'sort.Property': queryArg['sort.Property'],
          'sort.Order': queryArg['sort.Order'],
          'pagination.Offset': queryArg['pagination.Offset'],
          'pagination.Limit': queryArg['pagination.Limit'],
          search: queryArg.search,
        },
      }),
    }),
    postCommonAreas: build.mutation<PostCommonAreasApiResponse, PostCommonAreasApiArg>({
      query: (queryArg) => ({ url: `/common-areas`, method: 'POST', body: queryArg.body }),
    }),
    getCommonAreas: build.query<GetCommonAreasApiResponse, GetCommonAreasApiArg>({
      query: (queryArg) => ({
        url: `/common-areas`,
        params: {
          'parentId.Equal': queryArg['parentId.Equal'],
          'rootId.Equal': queryArg['rootId.Equal'],
          'ancestorPath.Equal': queryArg['ancestorPath.Equal'],
          'discriminator.Contains': queryArg['discriminator.Contains'],
          'usageType.Contains': queryArg['usageType.Contains'],
          'standard.Contains': queryArg['standard.Contains'],
          'totalAreaMetric.From': queryArg['totalAreaMetric.From'],
          'totalAreaMetric.To': queryArg['totalAreaMetric.To'],
          'available.Equal.Start': queryArg['available.Equal.Start'],
          'available.Equal.End': queryArg['available.Equal.End'],
          'vacant.Equal.Start': queryArg['vacant.Equal.Start'],
          'vacant.Equal.End': queryArg['vacant.Equal.End'],
          'hasRent.Equal': queryArg['hasRent.Equal'],
          'bedroomCount.From': queryArg['bedroomCount.From'],
          'bedroomCount.To': queryArg['bedroomCount.To'],
          'bathroomCount.From': queryArg['bathroomCount.From'],
          'bathroomCount.To': queryArg['bathroomCount.To'],
          'tags.Contains': queryArg['tags.Contains'],
          'requiredPackage.Equal': queryArg['requiredPackage.Equal'],
          'sort.Property': queryArg['sort.Property'],
          'sort.Order': queryArg['sort.Order'],
          'pagination.Offset': queryArg['pagination.Offset'],
          'pagination.Limit': queryArg['pagination.Limit'],
          search: queryArg.search,
        },
      }),
    }),
    getCommonAreasById: build.query<GetCommonAreasByIdApiResponse, GetCommonAreasByIdApiArg>({
      query: (queryArg) => ({ url: `/common-areas/${queryArg.id}` }),
    }),
    putCommonAreasById: build.mutation<PutCommonAreasByIdApiResponse, PutCommonAreasByIdApiArg>({
      query: (queryArg) => ({ url: `/common-areas/${queryArg.id}`, method: 'PUT', body: queryArg.body }),
    }),
    postCompanies: build.mutation<PostCompaniesApiResponse, PostCompaniesApiArg>({
      query: (queryArg) => ({ url: `/companies`, method: 'POST', body: queryArg.body }),
    }),
    getCompanies: build.query<GetCompaniesApiResponse, GetCompaniesApiArg>({
      query: (queryArg) => ({
        url: `/companies`,
        params: {
          'sort.Property': queryArg['sort.Property'],
          'sort.Order': queryArg['sort.Order'],
          'pagination.Offset': queryArg['pagination.Offset'],
          'pagination.Limit': queryArg['pagination.Limit'],
          search: queryArg.search,
          role: queryArg.role,
        },
      }),
    }),
    deleteCompaniesById: build.mutation<DeleteCompaniesByIdApiResponse, DeleteCompaniesByIdApiArg>({
      query: (queryArg) => ({ url: `/companies/${queryArg.id}`, method: 'DELETE' }),
    }),
    getCompaniesById: build.query<GetCompaniesByIdApiResponse, GetCompaniesByIdApiArg>({
      query: (queryArg) => ({ url: `/companies/${queryArg.id}` }),
    }),
    putCompaniesById: build.mutation<PutCompaniesByIdApiResponse, PutCompaniesByIdApiArg>({
      query: (queryArg) => ({ url: `/companies/${queryArg.id}`, method: 'PUT', body: queryArg.body }),
    }),
    deleteCompaniesByCompanyIdMembersInviteAndInvitationId: build.mutation<
      DeleteCompaniesByCompanyIdMembersInviteAndInvitationIdApiResponse,
      DeleteCompaniesByCompanyIdMembersInviteAndInvitationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/members/invite/${queryArg.invitationId}`,
        method: 'DELETE',
      }),
    }),
    getCompaniesByCompanyIdContactPersonAssignments: build.query<
      GetCompaniesByCompanyIdContactPersonAssignmentsApiResponse,
      GetCompaniesByCompanyIdContactPersonAssignmentsApiArg
    >({
      query: (queryArg) => ({ url: `/companies/${queryArg.companyId}/contact-person-assignments` }),
    }),
    getCompaniesByIdDepartments: build.query<GetCompaniesByIdDepartmentsApiResponse, GetCompaniesByIdDepartmentsApiArg>(
      {
        query: (queryArg) => ({ url: `/companies/${queryArg.id}/departments` }),
      },
    ),
    getCompaniesByCompanyIdMembers: build.query<
      GetCompaniesByCompanyIdMembersApiResponse,
      GetCompaniesByCompanyIdMembersApiArg
    >({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/members`,
        params: {
          'pagination.Offset': queryArg['pagination.Offset'],
          'pagination.Limit': queryArg['pagination.Limit'],
          search: queryArg.search,
          includeInactive: queryArg.includeInactive,
        },
      }),
    }),
    getCompaniesRoleCounts: build.query<GetCompaniesRoleCountsApiResponse, GetCompaniesRoleCountsApiArg>({
      query: () => ({ url: `/companies/role-counts` }),
    }),
    postCompaniesByCompanyIdMembersInviteAndInvitationIdResend: build.mutation<
      PostCompaniesByCompanyIdMembersInviteAndInvitationIdResendApiResponse,
      PostCompaniesByCompanyIdMembersInviteAndInvitationIdResendApiArg
    >({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/members/invite/${queryArg.invitationId}/resend`,
        method: 'POST',
      }),
    }),
    deleteCompaniesByCompanyIdPersonsAndUserId: build.mutation<
      DeleteCompaniesByCompanyIdPersonsAndUserIdApiResponse,
      DeleteCompaniesByCompanyIdPersonsAndUserIdApiArg
    >({
      query: (queryArg) => ({ url: `/companies/${queryArg.companyId}/persons/${queryArg.userId}`, method: 'DELETE' }),
    }),
    getCompaniesByCompanyIdPersons: build.query<
      GetCompaniesByCompanyIdPersonsApiResponse,
      GetCompaniesByCompanyIdPersonsApiArg
    >({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/persons`,
        params: {
          'sort.Property': queryArg['sort.Property'],
          'sort.Order': queryArg['sort.Order'],
          'pagination.Offset': queryArg['pagination.Offset'],
          'pagination.Limit': queryArg['pagination.Limit'],
          search: queryArg.search,
        },
      }),
    }),
    postCompaniesByCompanyIdPersonsAndUserIdReactivate: build.mutation<
      PostCompaniesByCompanyIdPersonsAndUserIdReactivateApiResponse,
      PostCompaniesByCompanyIdPersonsAndUserIdReactivateApiArg
    >({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/persons/${queryArg.userId}/reactivate`,
        method: 'POST',
      }),
    }),
    deleteContractsByIdSigning: build.mutation<DeleteContractsByIdSigningApiResponse, DeleteContractsByIdSigningApiArg>(
      {
        query: (queryArg) => ({ url: `/contracts/${queryArg.id}/signing`, method: 'DELETE', body: queryArg.body }),
      },
    ),
    postContractsByIdSigning: build.mutation<PostContractsByIdSigningApiResponse, PostContractsByIdSigningApiArg>({
      query: (queryArg) => ({ url: `/contracts/${queryArg.id}/signing`, method: 'POST' }),
    }),
    postContracts: build.mutation<PostContractsApiResponse, PostContractsApiArg>({
      query: (queryArg) => ({ url: `/contracts`, method: 'POST', body: queryArg.body }),
    }),
    getContracts: build.query<GetContractsApiResponse, GetContractsApiArg>({
      query: (queryArg) => ({
        url: `/contracts`,
        params: {
          'agreementId.Equal': queryArg['agreementId.Equal'],
          'pagination.Offset': queryArg['pagination.Offset'],
          'pagination.Limit': queryArg['pagination.Limit'],
          search: queryArg.search,
        },
      }),
    }),
    deleteContractsById: build.mutation<DeleteContractsByIdApiResponse, DeleteContractsByIdApiArg>({
      query: (queryArg) => ({ url: `/contracts/${queryArg.id}`, method: 'DELETE' }),
    }),
    getContractsExpirationExportDetails: build.query<
      GetContractsExpirationExportDetailsApiResponse,
      GetContractsExpirationExportDetailsApiArg
    >({
      query: (queryArg) => ({
        url: `/contracts/expiration-export-details`,
        params: {
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
          orderBy: queryArg.orderBy,
          page: queryArg.page,
          pageSize: queryArg.pageSize,
        },
      }),
    }),
    getContractsExportDetails: build.query<GetContractsExportDetailsApiResponse, GetContractsExportDetailsApiArg>({
      query: (queryArg) => ({
        url: `/contracts/export-details`,
        params: {
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
          orderBy: queryArg.orderBy,
          page: queryArg.page,
          pageSize: queryArg.pageSize,
        },
      }),
    }),
    getContractsVatPercentageExportDetails: build.query<
      GetContractsVatPercentageExportDetailsApiResponse,
      GetContractsVatPercentageExportDetailsApiArg
    >({
      query: (queryArg) => ({
        url: `/contracts/vat-percentage-export-details`,
        params: {
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
          orderBy: queryArg.orderBy,
          page: queryArg.page,
          pageSize: queryArg.pageSize,
        },
      }),
    }),
    postContractsAverageLengthDashboard: build.mutation<
      PostContractsAverageLengthDashboardApiResponse,
      PostContractsAverageLengthDashboardApiArg
    >({
      query: (queryArg) => ({
        url: `/contracts/average-length-dashboard`,
        method: 'POST',
        body: queryArg.body,
        params: { startDate: queryArg.startDate, endDate: queryArg.endDate },
      }),
    }),
    getContractsAverageLength: build.query<GetContractsAverageLengthApiResponse, GetContractsAverageLengthApiArg>({
      query: (queryArg) => ({
        url: `/contracts/average-length`,
        params: { startDate: queryArg.startDate, endDate: queryArg.endDate },
      }),
    }),
    postContractsExpirationDashboard: build.mutation<
      PostContractsExpirationDashboardApiResponse,
      PostContractsExpirationDashboardApiArg
    >({
      query: (queryArg) => ({
        url: `/contracts/expiration-dashboard`,
        method: 'POST',
        body: queryArg.body,
        params: { startDate: queryArg.startDate, endDate: queryArg.endDate },
      }),
    }),
    getContractsExpirationDetails: build.query<
      GetContractsExpirationDetailsApiResponse,
      GetContractsExpirationDetailsApiArg
    >({
      query: (queryArg) => ({
        url: `/contracts/expiration-details`,
        params: {
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
          orderBy: queryArg.orderBy,
          page: queryArg.page,
          pageSize: queryArg.pageSize,
        },
      }),
    }),
    getContractsExpirationSummary: build.query<
      GetContractsExpirationSummaryApiResponse,
      GetContractsExpirationSummaryApiArg
    >({
      query: (queryArg) => ({
        url: `/contracts/expiration-summary`,
        params: { startDate: queryArg.startDate, endDate: queryArg.endDate },
      }),
    }),
    getContractsDetails: build.query<GetContractsDetailsApiResponse, GetContractsDetailsApiArg>({
      query: (queryArg) => ({
        url: `/contracts/details`,
        params: {
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
          orderBy: queryArg.orderBy,
          page: queryArg.page,
          pageSize: queryArg.pageSize,
        },
      }),
    }),
    getContractsVatPercentageDetails: build.query<
      GetContractsVatPercentageDetailsApiResponse,
      GetContractsVatPercentageDetailsApiArg
    >({
      query: (queryArg) => ({
        url: `/contracts/vat-percentage-details`,
        params: {
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
          orderBy: queryArg.orderBy,
          page: queryArg.page,
          pageSize: queryArg.pageSize,
        },
      }),
    }),
    getContractsVatPercentageSummary: build.query<
      GetContractsVatPercentageSummaryApiResponse,
      GetContractsVatPercentageSummaryApiArg
    >({
      query: (queryArg) => ({
        url: `/contracts/vat-percentage-summary`,
        params: { startDate: queryArg.startDate, endDate: queryArg.endDate },
      }),
    }),
    postContractsByIdSignatures: build.mutation<
      PostContractsByIdSignaturesApiResponse,
      PostContractsByIdSignaturesApiArg
    >({
      query: (queryArg) => ({ url: `/contracts/${queryArg.id}/signatures`, method: 'POST', body: queryArg.body }),
    }),
    deleteContractsByIdSignatures: build.mutation<
      DeleteContractsByIdSignaturesApiResponse,
      DeleteContractsByIdSignaturesApiArg
    >({
      query: (queryArg) => ({ url: `/contracts/${queryArg.id}/signatures`, method: 'DELETE', body: queryArg.body }),
    }),
    putContractsByIdSignatures: build.mutation<PutContractsByIdSignaturesApiResponse, PutContractsByIdSignaturesApiArg>(
      {
        query: (queryArg) => ({ url: `/contracts/${queryArg.id}/signatures`, method: 'PUT', body: queryArg.body }),
      },
    ),
    getDataPortfolio: build.query<GetDataPortfolioApiResponse, GetDataPortfolioApiArg>({
      query: () => ({ url: `/data/portfolio` }),
    }),
    postDataPortfolio: build.mutation<PostDataPortfolioApiResponse, PostDataPortfolioApiArg>({
      query: (queryArg) => ({ url: `/data/portfolio`, method: 'POST', body: queryArg.body }),
    }),
    postDataPortfolioValidate: build.mutation<PostDataPortfolioValidateApiResponse, PostDataPortfolioValidateApiArg>({
      query: (queryArg) => ({ url: `/data/portfolio/validate`, method: 'POST', body: queryArg.body }),
    }),
    postDebugFixtures: build.mutation<PostDebugFixturesApiResponse, PostDebugFixturesApiArg>({
      query: () => ({ url: `/debug/fixtures`, method: 'POST' }),
    }),
    deleteDebugConsumptionsByBuildingId: build.mutation<
      DeleteDebugConsumptionsByBuildingIdApiResponse,
      DeleteDebugConsumptionsByBuildingIdApiArg
    >({
      query: (queryArg) => ({
        url: `/debug/consumptions/${queryArg.buildingId}`,
        method: 'DELETE',
        params: { consumptionIntegration: queryArg.consumptionIntegration },
      }),
    }),
    postDebugConsumptionsByBuildingId: build.mutation<
      PostDebugConsumptionsByBuildingIdApiResponse,
      PostDebugConsumptionsByBuildingIdApiArg
    >({
      query: (queryArg) => ({
        url: `/debug/consumptions/${queryArg.buildingId}`,
        method: 'POST',
        params: { consumptionIntegration: queryArg.consumptionIntegration, from: queryArg['from'], to: queryArg.to },
      }),
    }),
    getEconomySettingsChartOfAccounts: build.query<
      GetEconomySettingsChartOfAccountsApiResponse,
      GetEconomySettingsChartOfAccountsApiArg
    >({
      query: () => ({ url: `/economy/settings/chart-of-accounts` }),
    }),
    getEconomySettingsOverview: build.query<GetEconomySettingsOverviewApiResponse, GetEconomySettingsOverviewApiArg>({
      query: () => ({ url: `/economy/settings/overview` }),
    }),
    getEconomySettingsSharedCosts: build.query<
      GetEconomySettingsSharedCostsApiResponse,
      GetEconomySettingsSharedCostsApiArg
    >({
      query: () => ({ url: `/economy/settings/shared-costs` }),
    }),
    getEosAirQuality: build.query<GetEosAirQualityApiResponse, GetEosAirQualityApiArg>({
      query: (queryArg) => ({
        url: `/eos/air-quality`,
        params: { from: queryArg['from'], to: queryArg.to, spaceIds: queryArg.spaceIds, sources: queryArg.sources },
      }),
    }),
    getEosConsumptionByDevice: build.query<GetEosConsumptionByDeviceApiResponse, GetEosConsumptionByDeviceApiArg>({
      query: (queryArg) => ({
        url: `/eos/consumption-by-device`,
        params: {
          from: queryArg['from'],
          to: queryArg.to,
          resolution: queryArg.resolution,
          spaceIds: queryArg.spaceIds,
        },
      }),
    }),
    getEosConsumptionByEnergyCost: build.query<
      GetEosConsumptionByEnergyCostApiResponse,
      GetEosConsumptionByEnergyCostApiArg
    >({
      query: (queryArg) => ({
        url: `/eos/consumption-by-energy-cost`,
        params: { from: queryArg['from'], to: queryArg.to, spaceIds: queryArg.spaceIds, sources: queryArg.sources },
      }),
    }),
    getEosConsumptionByEnergyType: build.query<
      GetEosConsumptionByEnergyTypeApiResponse,
      GetEosConsumptionByEnergyTypeApiArg
    >({
      query: (queryArg) => ({
        url: `/eos/consumption-by-energy-type`,
        params: { from: queryArg['from'], to: queryArg.to, spaceIds: queryArg.spaceIds, sources: queryArg.sources },
      }),
    }),
    getEosConsumptionBySource: build.query<GetEosConsumptionBySourceApiResponse, GetEosConsumptionBySourceApiArg>({
      query: (queryArg) => ({
        url: `/eos/consumption-by-source`,
        params: { from: queryArg['from'], to: queryArg.to, spaceIds: queryArg.spaceIds, sources: queryArg.sources },
      }),
    }),
    getEosConsumptionSpaces: build.query<GetEosConsumptionSpacesApiResponse, GetEosConsumptionSpacesApiArg>({
      query: (queryArg) => ({
        url: `/eos/consumption-spaces`,
        params: { type: queryArg['type'], from: queryArg['from'], to: queryArg.to, spaceIds: queryArg.spaceIds },
      }),
    }),
    getEosConsumptionVsAverage: build.query<GetEosConsumptionVsAverageApiResponse, GetEosConsumptionVsAverageApiArg>({
      query: (queryArg) => ({
        url: `/eos/consumption-vs-average`,
        params: { from: queryArg['from'], to: queryArg.to, spaceIds: queryArg.spaceIds },
      }),
    }),
    getEosCorrelation: build.query<GetEosCorrelationApiResponse, GetEosCorrelationApiArg>({
      query: (queryArg) => ({
        url: `/eos/correlation`,
        params: {
          from: queryArg['from'],
          to: queryArg.to,
          resolution: queryArg.resolution,
          spaceIds: queryArg.spaceIds,
        },
      }),
    }),
    getEosEstimatedEnergyCost: build.query<GetEosEstimatedEnergyCostApiResponse, GetEosEstimatedEnergyCostApiArg>({
      query: (queryArg) => ({
        url: `/eos/estimated-energy-cost`,
        params: { from: queryArg['from'], to: queryArg.to, spaceIds: queryArg.spaceIds, sources: queryArg.sources },
      }),
    }),
    getEosEstimatedEnergyCostSpaces: build.query<
      GetEosEstimatedEnergyCostSpacesApiResponse,
      GetEosEstimatedEnergyCostSpacesApiArg
    >({
      query: (queryArg) => ({
        url: `/eos/estimated-energy-cost-spaces`,
        params: { type: queryArg['type'], from: queryArg['from'], to: queryArg.to, spaceIds: queryArg.spaceIds },
      }),
    }),
    getEosTotalConsumption: build.query<GetEosTotalConsumptionApiResponse, GetEosTotalConsumptionApiArg>({
      query: (queryArg) => ({
        url: `/eos/total-consumption`,
        params: { from: queryArg['from'], to: queryArg.to, spaceIds: queryArg.spaceIds, sources: queryArg.sources },
      }),
    }),
    getEosConsumptionSquareMeter: build.query<
      GetEosConsumptionSquareMeterApiResponse,
      GetEosConsumptionSquareMeterApiArg
    >({
      query: (queryArg) => ({
        url: `/eos/consumption-square-meter`,
        params: { from: queryArg['from'], to: queryArg.to, spaceIds: queryArg.spaceIds },
      }),
    }),
    getEosTotalEnergyCost: build.query<GetEosTotalEnergyCostApiResponse, GetEosTotalEnergyCostApiArg>({
      query: (queryArg) => ({
        url: `/eos/total-energy-cost`,
        params: { from: queryArg['from'], to: queryArg.to, spaceIds: queryArg.spaceIds, sources: queryArg.sources },
      }),
    }),
    postInvestments: build.mutation<PostInvestmentsApiResponse, PostInvestmentsApiArg>({
      query: (queryArg) => ({ url: `/investments`, method: 'POST', body: queryArg.body }),
    }),
    getInvestments: build.query<GetInvestmentsApiResponse, GetInvestmentsApiArg>({
      query: (queryArg) => ({
        url: `/investments`,
        params: {
          'spaceId.Equal': queryArg['spaceId.Equal'],
          'spaceAncestorPath.Equal': queryArg['spaceAncestorPath.Equal'],
          'sort.Property': queryArg['sort.Property'],
          'sort.Order': queryArg['sort.Order'],
          'pagination.Offset': queryArg['pagination.Offset'],
          'pagination.Limit': queryArg['pagination.Limit'],
          search: queryArg.search,
        },
      }),
    }),
    deleteInvestmentsById: build.mutation<DeleteInvestmentsByIdApiResponse, DeleteInvestmentsByIdApiArg>({
      query: (queryArg) => ({ url: `/investments/${queryArg.id}`, method: 'DELETE' }),
    }),
    getInvestmentsById: build.query<GetInvestmentsByIdApiResponse, GetInvestmentsByIdApiArg>({
      query: (queryArg) => ({ url: `/investments/${queryArg.id}` }),
    }),
    putInvestmentsById: build.mutation<PutInvestmentsByIdApiResponse, PutInvestmentsByIdApiArg>({
      query: (queryArg) => ({ url: `/investments/${queryArg.id}`, method: 'PUT', body: queryArg.body }),
    }),
    putInvestmentsByInvestmentIdSpaces: build.mutation<
      PutInvestmentsByInvestmentIdSpacesApiResponse,
      PutInvestmentsByInvestmentIdSpacesApiArg
    >({
      query: (queryArg) => ({
        url: `/investments/${queryArg.investmentId}/spaces`,
        method: 'PUT',
        body: queryArg.body,
      }),
    }),
    getInvoicesExportOverdueDetails: build.query<
      GetInvoicesExportOverdueDetailsApiResponse,
      GetInvoicesExportOverdueDetailsApiArg
    >({
      query: (queryArg) => ({
        url: `/invoices/export-overdue-details`,
        params: {
          buildingIds: queryArg.buildingIds,
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
          orderBy: queryArg.orderBy,
          page: queryArg.page,
          pageSize: queryArg.pageSize,
        },
      }),
    }),
    getInvoicesExportReceivableDetails: build.query<
      GetInvoicesExportReceivableDetailsApiResponse,
      GetInvoicesExportReceivableDetailsApiArg
    >({
      query: (queryArg) => ({
        url: `/invoices/export-receivable-details`,
        params: {
          buildingIds: queryArg.buildingIds,
          companyId: queryArg.companyId,
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
          orderBy: queryArg.orderBy,
          page: queryArg.page,
          pageSize: queryArg.pageSize,
        },
      }),
    }),
    postInvoicesDashboard: build.mutation<PostInvoicesDashboardApiResponse, PostInvoicesDashboardApiArg>({
      query: (queryArg) => ({
        url: `/invoices/dashboard`,
        method: 'POST',
        body: queryArg.body,
        params: { startDate: queryArg.startDate, endDate: queryArg.endDate },
      }),
    }),
    getInvoicesByIdDocument: build.query<GetInvoicesByIdDocumentApiResponse, GetInvoicesByIdDocumentApiArg>({
      query: (queryArg) => ({ url: `/invoices/${queryArg.id}/document` }),
    }),
    getInvoicesOverdueDetails: build.query<GetInvoicesOverdueDetailsApiResponse, GetInvoicesOverdueDetailsApiArg>({
      query: (queryArg) => ({
        url: `/invoices/overdue-details`,
        params: {
          buildingIds: queryArg.buildingIds,
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
          orderBy: queryArg.orderBy,
          page: queryArg.page,
          pageSize: queryArg.pageSize,
        },
      }),
    }),
    getInvoicesOverdueSummary: build.query<GetInvoicesOverdueSummaryApiResponse, GetInvoicesOverdueSummaryApiArg>({
      query: () => ({ url: `/invoices/overdue-summary` }),
    }),
    getInvoicesReceivableDetails: build.query<
      GetInvoicesReceivableDetailsApiResponse,
      GetInvoicesReceivableDetailsApiArg
    >({
      query: (queryArg) => ({
        url: `/invoices/receivable-details`,
        params: {
          buildingIds: queryArg.buildingIds,
          companyId: queryArg.companyId,
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
          orderBy: queryArg.orderBy,
          page: queryArg.page,
          pageSize: queryArg.pageSize,
        },
      }),
    }),
    getInvoicesReceivablesSummary: build.query<
      GetInvoicesReceivablesSummaryApiResponse,
      GetInvoicesReceivablesSummaryApiArg
    >({
      query: (queryArg) => ({
        url: `/invoices/receivables-summary`,
        params: { startDate: queryArg.startDate, endDate: queryArg.endDate },
      }),
    }),
    getKpi: build.query<GetKpiApiResponse, GetKpiApiArg>({
      query: (queryArg) => ({ url: `/kpi`, params: { year: queryArg.year, month: queryArg.month } }),
    }),
    getLegalPersonsById: build.query<GetLegalPersonsByIdApiResponse, GetLegalPersonsByIdApiArg>({
      query: (queryArg) => ({ url: `/legal-persons/${queryArg.id}` }),
    }),
    getLegalPersons: build.query<GetLegalPersonsApiResponse, GetLegalPersonsApiArg>({
      query: (queryArg) => ({
        url: `/legal-persons`,
        params: {
          'sort.Property': queryArg['sort.Property'],
          'sort.Order': queryArg['sort.Order'],
          'pagination.Offset': queryArg['pagination.Offset'],
          'pagination.Limit': queryArg['pagination.Limit'],
          search: queryArg.search,
        },
      }),
    }),
    postLegalPersonsByLegalPersonIdRepresentatives: build.mutation<
      PostLegalPersonsByLegalPersonIdRepresentativesApiResponse,
      PostLegalPersonsByLegalPersonIdRepresentativesApiArg
    >({
      query: (queryArg) => ({
        url: `/legal-persons/${queryArg.legalPersonId}/representatives`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    getLegalPersonsByLegalPersonIdRepresentatives: build.query<
      GetLegalPersonsByLegalPersonIdRepresentativesApiResponse,
      GetLegalPersonsByLegalPersonIdRepresentativesApiArg
    >({
      query: (queryArg) => ({
        url: `/legal-persons/${queryArg.legalPersonId}/representatives`,
        params: {
          'sort.Property': queryArg['sort.Property'],
          'sort.Order': queryArg['sort.Order'],
          'pagination.Offset': queryArg['pagination.Offset'],
          'pagination.Limit': queryArg['pagination.Limit'],
          search: queryArg.search,
        },
      }),
    }),
    deleteLegalPersonsByLegalPersonIdRepresentativesAndRepresentativeId: build.mutation<
      DeleteLegalPersonsByLegalPersonIdRepresentativesAndRepresentativeIdApiResponse,
      DeleteLegalPersonsByLegalPersonIdRepresentativesAndRepresentativeIdApiArg
    >({
      query: (queryArg) => ({
        url: `/legal-persons/${queryArg.legalPersonId}/representatives/${queryArg.representativeId}`,
        method: 'DELETE',
      }),
    }),
    getMeterData: build.query<GetMeterDataApiResponse, GetMeterDataApiArg>({
      query: (queryArg) => ({
        url: `/meter-data`,
        params: {
          'meterId.Equal': queryArg['meterId.Equal'],
          'resolution.Equal': queryArg['resolution.Equal'],
          'rollup.Equal': queryArg['rollup.Equal'],
          'interval.Equal.Start': queryArg['interval.Equal.Start'],
          'interval.Equal.End': queryArg['interval.Equal.End'],
          'pagination.Offset': queryArg['pagination.Offset'],
          'pagination.Limit': queryArg['pagination.Limit'],
          search: queryArg.search,
        },
      }),
    }),
    getMeters: build.query<GetMetersApiResponse, GetMetersApiArg>({
      query: (queryArg) => ({
        url: `/meters`,
        params: {
          'spaceId.Equal': queryArg['spaceId.Equal'],
          'measureType.Equal': queryArg['measureType.Equal'],
          'energyCarrier.Equal': queryArg['energyCarrier.Equal'],
          'pagination.Offset': queryArg['pagination.Offset'],
          'pagination.Limit': queryArg['pagination.Limit'],
          search: queryArg.search,
        },
      }),
    }),
    getOccupancyRatesExportDetails: build.query<
      GetOccupancyRatesExportDetailsApiResponse,
      GetOccupancyRatesExportDetailsApiArg
    >({
      query: (queryArg) => ({
        url: `/occupancy-rates/export-details`,
        params: {
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
          orderBy: queryArg.orderBy,
          page: queryArg.page,
          pageSize: queryArg.pageSize,
        },
      }),
    }),
    postOccupancyRatesDashboard: build.mutation<
      PostOccupancyRatesDashboardApiResponse,
      PostOccupancyRatesDashboardApiArg
    >({
      query: (queryArg) => ({
        url: `/occupancy-rates/dashboard`,
        method: 'POST',
        body: queryArg.body,
        params: { startDate: queryArg.startDate, endDate: queryArg.endDate },
      }),
    }),
    getOccupancyRatesDetails: build.query<GetOccupancyRatesDetailsApiResponse, GetOccupancyRatesDetailsApiArg>({
      query: (queryArg) => ({
        url: `/occupancy-rates/details`,
        params: {
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
          orderBy: queryArg.orderBy,
          page: queryArg.page,
          pageSize: queryArg.pageSize,
        },
      }),
    }),
    getOccupancyRatesSummary: build.query<GetOccupancyRatesSummaryApiResponse, GetOccupancyRatesSummaryApiArg>({
      query: (queryArg) => ({
        url: `/occupancy-rates/summary`,
        params: { startDate: queryArg.startDate, endDate: queryArg.endDate },
      }),
    }),
    getOrganizations: build.query<GetOrganizationsApiResponse, GetOrganizationsApiArg>({
      query: (queryArg) => ({
        url: `/organizations`,
        params: {
          'parentId.Equal': queryArg['parentId.Equal'],
          'sort.Property': queryArg['sort.Property'],
          'sort.Order': queryArg['sort.Order'],
          'pagination.Offset': queryArg['pagination.Offset'],
          'pagination.Limit': queryArg['pagination.Limit'],
          search: queryArg.search,
        },
      }),
    }),
    putOrganizationsByOrganizationIdChildren: build.mutation<
      PutOrganizationsByOrganizationIdChildrenApiResponse,
      PutOrganizationsByOrganizationIdChildrenApiArg
    >({
      query: (queryArg) => ({
        url: `/organizations/${queryArg.organizationId}/children`,
        method: 'PUT',
        body: queryArg.body,
      }),
    }),
    postOrganizationsByOrganizationIdPersons: build.mutation<
      PostOrganizationsByOrganizationIdPersonsApiResponse,
      PostOrganizationsByOrganizationIdPersonsApiArg
    >({
      query: (queryArg) => ({
        url: `/organizations/${queryArg.organizationId}/persons`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    getOrganizationsByOrganizationIdPersons: build.query<
      GetOrganizationsByOrganizationIdPersonsApiResponse,
      GetOrganizationsByOrganizationIdPersonsApiArg
    >({
      query: (queryArg) => ({
        url: `/organizations/${queryArg.organizationId}/persons`,
        params: {
          'sort.Property': queryArg['sort.Property'],
          'sort.Order': queryArg['sort.Order'],
          'pagination.Offset': queryArg['pagination.Offset'],
          'pagination.Limit': queryArg['pagination.Limit'],
          search: queryArg.search,
        },
      }),
    }),
    putOrganizationsByOrganizationIdPersons: build.mutation<
      PutOrganizationsByOrganizationIdPersonsApiResponse,
      PutOrganizationsByOrganizationIdPersonsApiArg
    >({
      query: (queryArg) => ({
        url: `/organizations/${queryArg.organizationId}/persons`,
        method: 'PUT',
        body: queryArg.body,
      }),
    }),
    deleteOrganizationsByOrganizationIdPersonsAndPersonId: build.mutation<
      DeleteOrganizationsByOrganizationIdPersonsAndPersonIdApiResponse,
      DeleteOrganizationsByOrganizationIdPersonsAndPersonIdApiArg
    >({
      query: (queryArg) => ({
        url: `/organizations/${queryArg.organizationId}/persons/${queryArg.personId}`,
        method: 'DELETE',
      }),
    }),
    postParkingSpots: build.mutation<PostParkingSpotsApiResponse, PostParkingSpotsApiArg>({
      query: (queryArg) => ({ url: `/parking-spots`, method: 'POST', body: queryArg.body }),
    }),
    getParkingSpots: build.query<GetParkingSpotsApiResponse, GetParkingSpotsApiArg>({
      query: (queryArg) => ({
        url: `/parking-spots`,
        params: {
          'parentId.Equal': queryArg['parentId.Equal'],
          'rootId.Equal': queryArg['rootId.Equal'],
          'ancestorPath.Equal': queryArg['ancestorPath.Equal'],
          'discriminator.Contains': queryArg['discriminator.Contains'],
          'usageType.Contains': queryArg['usageType.Contains'],
          'standard.Contains': queryArg['standard.Contains'],
          'totalAreaMetric.From': queryArg['totalAreaMetric.From'],
          'totalAreaMetric.To': queryArg['totalAreaMetric.To'],
          'available.Equal.Start': queryArg['available.Equal.Start'],
          'available.Equal.End': queryArg['available.Equal.End'],
          'vacant.Equal.Start': queryArg['vacant.Equal.Start'],
          'vacant.Equal.End': queryArg['vacant.Equal.End'],
          'hasRent.Equal': queryArg['hasRent.Equal'],
          'bedroomCount.From': queryArg['bedroomCount.From'],
          'bedroomCount.To': queryArg['bedroomCount.To'],
          'bathroomCount.From': queryArg['bathroomCount.From'],
          'bathroomCount.To': queryArg['bathroomCount.To'],
          'tags.Contains': queryArg['tags.Contains'],
          'requiredPackage.Equal': queryArg['requiredPackage.Equal'],
          'sort.Property': queryArg['sort.Property'],
          'sort.Order': queryArg['sort.Order'],
          'pagination.Offset': queryArg['pagination.Offset'],
          'pagination.Limit': queryArg['pagination.Limit'],
          search: queryArg.search,
        },
      }),
    }),
    getParkingSpotsById: build.query<GetParkingSpotsByIdApiResponse, GetParkingSpotsByIdApiArg>({
      query: (queryArg) => ({ url: `/parking-spots/${queryArg.id}` }),
    }),
    putParkingSpotsById: build.mutation<PutParkingSpotsByIdApiResponse, PutParkingSpotsByIdApiArg>({
      query: (queryArg) => ({ url: `/parking-spots/${queryArg.id}`, method: 'PUT', body: queryArg.body }),
    }),
    postPersons: build.mutation<PostPersonsApiResponse, PostPersonsApiArg>({
      query: (queryArg) => ({ url: `/persons`, method: 'POST', body: queryArg.body }),
    }),
    getPersons: build.query<GetPersonsApiResponse, GetPersonsApiArg>({
      query: (queryArg) => ({
        url: `/persons`,
        params: {
          'sort.Property': queryArg['sort.Property'],
          'sort.Order': queryArg['sort.Order'],
          'pagination.Offset': queryArg['pagination.Offset'],
          'pagination.Limit': queryArg['pagination.Limit'],
          search: queryArg.search,
        },
      }),
    }),
    deletePersonsById: build.mutation<DeletePersonsByIdApiResponse, DeletePersonsByIdApiArg>({
      query: (queryArg) => ({ url: `/persons/${queryArg.id}`, method: 'DELETE' }),
    }),
    getPersonsById: build.query<GetPersonsByIdApiResponse, GetPersonsByIdApiArg>({
      query: (queryArg) => ({ url: `/persons/${queryArg.id}` }),
    }),
    putPersonsById: build.mutation<PutPersonsByIdApiResponse, PutPersonsByIdApiArg>({
      query: (queryArg) => ({ url: `/persons/${queryArg.id}`, method: 'PUT', body: queryArg.body }),
    }),
    deletePersonsInviteByInvitationId: build.mutation<
      DeletePersonsInviteByInvitationIdApiResponse,
      DeletePersonsInviteByInvitationIdApiArg
    >({
      query: (queryArg) => ({ url: `/persons/invite/${queryArg.invitationId}`, method: 'DELETE' }),
    }),
    putPersonsAdminInvite: build.mutation<PutPersonsAdminInviteApiResponse, PutPersonsAdminInviteApiArg>({
      query: (queryArg) => ({ url: `/persons/admin/invite`, method: 'PUT', body: queryArg.body }),
    }),
    putPersonsCompanyUserInvite: build.mutation<
      PutPersonsCompanyUserInviteApiResponse,
      PutPersonsCompanyUserInviteApiArg
    >({
      query: (queryArg) => ({ url: `/persons/company-user/invite`, method: 'PUT', body: queryArg.body }),
    }),
    putPersonsByIdInvite: build.mutation<PutPersonsByIdInviteApiResponse, PutPersonsByIdInviteApiArg>({
      query: (queryArg) => ({ url: `/persons/${queryArg.id}/invite`, method: 'PUT' }),
    }),
    putPersonsTenantUserInvite: build.mutation<PutPersonsTenantUserInviteApiResponse, PutPersonsTenantUserInviteApiArg>(
      {
        query: (queryArg) => ({ url: `/persons/tenant-user/invite`, method: 'PUT', body: queryArg.body }),
      },
    ),
    putPersonsUserInvite: build.mutation<PutPersonsUserInviteApiResponse, PutPersonsUserInviteApiArg>({
      query: (queryArg) => ({ url: `/persons/user/invite`, method: 'PUT', body: queryArg.body }),
    }),
    postPersonsByIdReactivate: build.mutation<PostPersonsByIdReactivateApiResponse, PostPersonsByIdReactivateApiArg>({
      query: (queryArg) => ({ url: `/persons/${queryArg.id}/reactivate`, method: 'POST' }),
    }),
    postPersonsInviteByInvitationIdResend: build.mutation<
      PostPersonsInviteByInvitationIdResendApiResponse,
      PostPersonsInviteByInvitationIdResendApiArg
    >({
      query: (queryArg) => ({ url: `/persons/invite/${queryArg.invitationId}/resend`, method: 'POST' }),
    }),
    completePortfolioOnboarding: build.mutation<
      CompletePortfolioOnboardingApiResponse,
      CompletePortfolioOnboardingApiArg
    >({
      query: (queryArg) => ({ url: `/onboarding/complete`, method: 'POST', body: queryArg.body }),
    }),
    createPortfolioOnboardingInvitation: build.mutation<
      CreatePortfolioOnboardingInvitationApiResponse,
      CreatePortfolioOnboardingInvitationApiArg
    >({
      query: (queryArg) => ({ url: `/portfolio/admin/invite`, method: 'POST', body: queryArg.body }),
    }),
    getCompaniesAtAddress: build.query<GetCompaniesAtAddressApiResponse, GetCompaniesAtAddressApiArg>({
      query: (queryArg) => ({
        url: `/onboarding/companies-at-address`,
        params: { postalCode: queryArg.postalCode, address: queryArg.address },
      }),
    }),
    getPendingPortfolioInvitation: build.query<
      GetPendingPortfolioInvitationApiResponse,
      GetPendingPortfolioInvitationApiArg
    >({
      query: () => ({ url: `/onboarding/invitation` }),
    }),
    searchBuildings: build.query<SearchBuildingsApiResponse, SearchBuildingsApiArg>({
      query: (queryArg) => ({
        url: `/portfolio/buildings/search`,
        params: { query: queryArg.query, searchType: queryArg.searchType },
      }),
    }),
    getPricesById: build.query<GetPricesByIdApiResponse, GetPricesByIdApiArg>({
      query: (queryArg) => ({ url: `/prices/${queryArg.id}` }),
    }),
    getPrices: build.query<GetPricesApiResponse, GetPricesApiArg>({
      query: (queryArg) => ({
        url: `/prices`,
        params: {
          'productId.Equal': queryArg['productId.Equal'],
          'recurring.Equal': queryArg['recurring.Equal'],
          'sort.Property': queryArg['sort.Property'],
          'sort.Order': queryArg['sort.Order'],
          'pagination.Offset': queryArg['pagination.Offset'],
          'pagination.Limit': queryArg['pagination.Limit'],
          search: queryArg.search,
        },
      }),
    }),
    postProducts: build.mutation<PostProductsApiResponse, PostProductsApiArg>({
      query: (queryArg) => ({ url: `/products`, method: 'POST', body: queryArg.body }),
    }),
    getProducts: build.query<GetProductsApiResponse, GetProductsApiArg>({
      query: (queryArg) => ({
        url: `/products`,
        params: {
          'sort.Property': queryArg['sort.Property'],
          'sort.Order': queryArg['sort.Order'],
          'pagination.Offset': queryArg['pagination.Offset'],
          'pagination.Limit': queryArg['pagination.Limit'],
          search: queryArg.search,
        },
      }),
    }),
    postProductsByIdChildren: build.mutation<PostProductsByIdChildrenApiResponse, PostProductsByIdChildrenApiArg>({
      query: (queryArg) => ({ url: `/products/${queryArg.id}/children`, method: 'POST', body: queryArg.body }),
    }),
    getProductsByIdChildren: build.query<GetProductsByIdChildrenApiResponse, GetProductsByIdChildrenApiArg>({
      query: (queryArg) => ({ url: `/products/${queryArg.id}/children` }),
    }),
    deleteProductsById: build.mutation<DeleteProductsByIdApiResponse, DeleteProductsByIdApiArg>({
      query: (queryArg) => ({ url: `/products/${queryArg.id}`, method: 'DELETE' }),
    }),
    getProductsById: build.query<GetProductsByIdApiResponse, GetProductsByIdApiArg>({
      query: (queryArg) => ({ url: `/products/${queryArg.id}` }),
    }),
    putProductsById: build.mutation<PutProductsByIdApiResponse, PutProductsByIdApiArg>({
      query: (queryArg) => ({ url: `/products/${queryArg.id}`, method: 'PUT', body: queryArg.body }),
    }),
    deleteProductsByIdChildrenAndChildId: build.mutation<
      DeleteProductsByIdChildrenAndChildIdApiResponse,
      DeleteProductsByIdChildrenAndChildIdApiArg
    >({
      query: (queryArg) => ({ url: `/products/${queryArg.id}/children/${queryArg.childId}`, method: 'DELETE' }),
    }),
    putProductsByIdChildrenAndChildId: build.mutation<
      PutProductsByIdChildrenAndChildIdApiResponse,
      PutProductsByIdChildrenAndChildIdApiArg
    >({
      query: (queryArg) => ({
        url: `/products/${queryArg.id}/children/${queryArg.childId}`,
        method: 'PUT',
        body: queryArg.body,
      }),
    }),
    getProductsSubProductTemplates: build.query<
      GetProductsSubProductTemplatesApiResponse,
      GetProductsSubProductTemplatesApiArg
    >({
      query: (queryArg) => ({ url: `/products/sub-product-templates`, params: { countryCode: queryArg.countryCode } }),
    }),
    getProductsTripletex: build.query<GetProductsTripletexApiResponse, GetProductsTripletexApiArg>({
      query: () => ({ url: `/products/tripletex` }),
    }),
    getRentalIncomesExportDetails: build.query<
      GetRentalIncomesExportDetailsApiResponse,
      GetRentalIncomesExportDetailsApiArg
    >({
      query: (queryArg) => ({
        url: `/rental-incomes/export-details`,
        params: {
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
          orderBy: queryArg.orderBy,
          page: queryArg.page,
          pageSize: queryArg.pageSize,
        },
      }),
    }),
    postRentalIncomesDashboard: build.mutation<PostRentalIncomesDashboardApiResponse, PostRentalIncomesDashboardApiArg>(
      {
        query: (queryArg) => ({
          url: `/rental-incomes/dashboard`,
          method: 'POST',
          body: queryArg.body,
          params: { startDate: queryArg.startDate, endDate: queryArg.endDate, companyId: queryArg.companyId },
        }),
      },
    ),
    getRentalIncomesDetails: build.query<GetRentalIncomesDetailsApiResponse, GetRentalIncomesDetailsApiArg>({
      query: (queryArg) => ({
        url: `/rental-incomes/details`,
        params: {
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
          orderBy: queryArg.orderBy,
          page: queryArg.page,
          pageSize: queryArg.pageSize,
        },
      }),
    }),
    getRentalIncomesSummary: build.query<GetRentalIncomesSummaryApiResponse, GetRentalIncomesSummaryApiArg>({
      query: (queryArg) => ({
        url: `/rental-incomes/summary`,
        params: { startDate: queryArg.startDate, endDate: queryArg.endDate },
      }),
    }),
    getReportingFinancing: build.query<GetReportingFinancingApiResponse, GetReportingFinancingApiArg>({
      query: (queryArg) => ({
        url: `/reporting/financing`,
        params: { startDate: queryArg.startDate, endDate: queryArg.endDate },
      }),
    }),
    getReportingPortfolioDiversification: build.query<
      GetReportingPortfolioDiversificationApiResponse,
      GetReportingPortfolioDiversificationApiArg
    >({
      query: (queryArg) => ({
        url: `/reporting/portfolio-diversification`,
        params: { startDate: queryArg.startDate, endDate: queryArg.endDate },
      }),
    }),
    getReportingPortfolioOverview: build.query<
      GetReportingPortfolioOverviewApiResponse,
      GetReportingPortfolioOverviewApiArg
    >({
      query: (queryArg) => ({
        url: `/reporting/portfolio-overview`,
        params: { startDate: queryArg.startDate, endDate: queryArg.endDate },
      }),
    }),
    getResidentialUnitsById: build.query<GetResidentialUnitsByIdApiResponse, GetResidentialUnitsByIdApiArg>({
      query: (queryArg) => ({ url: `/residential-units/${queryArg.id}` }),
    }),
    getResidentialUnits: build.query<GetResidentialUnitsApiResponse, GetResidentialUnitsApiArg>({
      query: (queryArg) => ({
        url: `/residential-units`,
        params: {
          'parentId.Equal': queryArg['parentId.Equal'],
          'rootId.Equal': queryArg['rootId.Equal'],
          'ancestorPath.Equal': queryArg['ancestorPath.Equal'],
          'discriminator.Contains': queryArg['discriminator.Contains'],
          'usageType.Contains': queryArg['usageType.Contains'],
          'standard.Contains': queryArg['standard.Contains'],
          'totalAreaMetric.From': queryArg['totalAreaMetric.From'],
          'totalAreaMetric.To': queryArg['totalAreaMetric.To'],
          'available.Equal.Start': queryArg['available.Equal.Start'],
          'available.Equal.End': queryArg['available.Equal.End'],
          'vacant.Equal.Start': queryArg['vacant.Equal.Start'],
          'vacant.Equal.End': queryArg['vacant.Equal.End'],
          'hasRent.Equal': queryArg['hasRent.Equal'],
          'bedroomCount.From': queryArg['bedroomCount.From'],
          'bedroomCount.To': queryArg['bedroomCount.To'],
          'bathroomCount.From': queryArg['bathroomCount.From'],
          'bathroomCount.To': queryArg['bathroomCount.To'],
          'tags.Contains': queryArg['tags.Contains'],
          'requiredPackage.Equal': queryArg['requiredPackage.Equal'],
          'sort.Property': queryArg['sort.Property'],
          'sort.Order': queryArg['sort.Order'],
          'pagination.Offset': queryArg['pagination.Offset'],
          'pagination.Limit': queryArg['pagination.Limit'],
          search: queryArg.search,
        },
      }),
    }),
    putResidentialUnitsByIdRooms: build.mutation<
      PutResidentialUnitsByIdRoomsApiResponse,
      PutResidentialUnitsByIdRoomsApiArg
    >({
      query: (queryArg) => ({ url: `/residential-units/${queryArg.id}/rooms`, method: 'PUT', body: queryArg.body }),
    }),
    postRooms: build.mutation<PostRoomsApiResponse, PostRoomsApiArg>({
      query: (queryArg) => ({ url: `/rooms`, method: 'POST', body: queryArg.body }),
    }),
    getRooms: build.query<GetRoomsApiResponse, GetRoomsApiArg>({
      query: (queryArg) => ({
        url: `/rooms`,
        params: {
          'parentId.Equal': queryArg['parentId.Equal'],
          'rootId.Equal': queryArg['rootId.Equal'],
          'ancestorPath.Equal': queryArg['ancestorPath.Equal'],
          'discriminator.Contains': queryArg['discriminator.Contains'],
          'usageType.Contains': queryArg['usageType.Contains'],
          'standard.Contains': queryArg['standard.Contains'],
          'totalAreaMetric.From': queryArg['totalAreaMetric.From'],
          'totalAreaMetric.To': queryArg['totalAreaMetric.To'],
          'available.Equal.Start': queryArg['available.Equal.Start'],
          'available.Equal.End': queryArg['available.Equal.End'],
          'vacant.Equal.Start': queryArg['vacant.Equal.Start'],
          'vacant.Equal.End': queryArg['vacant.Equal.End'],
          'hasRent.Equal': queryArg['hasRent.Equal'],
          'bedroomCount.From': queryArg['bedroomCount.From'],
          'bedroomCount.To': queryArg['bedroomCount.To'],
          'bathroomCount.From': queryArg['bathroomCount.From'],
          'bathroomCount.To': queryArg['bathroomCount.To'],
          'tags.Contains': queryArg['tags.Contains'],
          'requiredPackage.Equal': queryArg['requiredPackage.Equal'],
          'sort.Property': queryArg['sort.Property'],
          'sort.Order': queryArg['sort.Order'],
          'pagination.Offset': queryArg['pagination.Offset'],
          'pagination.Limit': queryArg['pagination.Limit'],
          search: queryArg.search,
        },
      }),
    }),
    getRoomsById: build.query<GetRoomsByIdApiResponse, GetRoomsByIdApiArg>({
      query: (queryArg) => ({ url: `/rooms/${queryArg.id}` }),
    }),
    putRoomsById: build.mutation<PutRoomsByIdApiResponse, PutRoomsByIdApiArg>({
      query: (queryArg) => ({ url: `/rooms/${queryArg.id}`, method: 'PUT', body: queryArg.body }),
    }),
    getSourcesAddressesFilter: build.query<GetSourcesAddressesFilterApiResponse, GetSourcesAddressesFilterApiArg>({
      query: (queryArg) => ({
        url: `/sources/addresses/filter`,
        params: {
          streetName: queryArg.streetName,
          streetNumber: queryArg.streetNumber,
          zipCode: queryArg.zipCode,
          zipPlace: queryArg.zipPlace,
          countryThreeLetterCode: queryArg.countryThreeLetterCode,
        },
      }),
    }),
    getSourcesBuildingsByIntegrationAndIdentifier: build.query<
      GetSourcesBuildingsByIntegrationAndIdentifierApiResponse,
      GetSourcesBuildingsByIntegrationAndIdentifierApiArg
    >({
      query: (queryArg) => ({ url: `/sources/buildings/${queryArg.integration}/${queryArg.identifier}` }),
    }),
    getSourcesAddressesSearch: build.query<GetSourcesAddressesSearchApiResponse, GetSourcesAddressesSearchApiArg>({
      query: (queryArg) => ({ url: `/sources/addresses/search`, params: { query: queryArg.query } }),
    }),
    postSpacesByIdLoans: build.mutation<PostSpacesByIdLoansApiResponse, PostSpacesByIdLoansApiArg>({
      query: (queryArg) => ({ url: `/spaces/${queryArg.id}/loans`, method: 'POST', body: queryArg.body }),
    }),
    getSpacesByIdLoans: build.query<GetSpacesByIdLoansApiResponse, GetSpacesByIdLoansApiArg>({
      query: (queryArg) => ({ url: `/spaces/${queryArg.id}/loans` }),
    }),
    postSpacesByIdPortfolioTenants: build.mutation<
      PostSpacesByIdPortfolioTenantsApiResponse,
      PostSpacesByIdPortfolioTenantsApiArg
    >({
      query: (queryArg) => ({ url: `/spaces/${queryArg.id}/portfolio-tenants`, method: 'POST', body: queryArg.body }),
    }),
    getSpacesByIdPortfolioTenants: build.query<
      GetSpacesByIdPortfolioTenantsApiResponse,
      GetSpacesByIdPortfolioTenantsApiArg
    >({
      query: (queryArg) => ({ url: `/spaces/${queryArg.id}/portfolio-tenants` }),
    }),
    postSpaces: build.mutation<PostSpacesApiResponse, PostSpacesApiArg>({
      query: (queryArg) => ({ url: `/spaces`, method: 'POST', body: queryArg.body }),
    }),
    getSpaces: build.query<GetSpacesApiResponse, GetSpacesApiArg>({
      query: (queryArg) => ({
        url: `/spaces`,
        params: {
          'parentId.Equal': queryArg['parentId.Equal'],
          'rootId.Equal': queryArg['rootId.Equal'],
          'ancestorPath.Equal': queryArg['ancestorPath.Equal'],
          'discriminator.Contains': queryArg['discriminator.Contains'],
          'usageType.Contains': queryArg['usageType.Contains'],
          'standard.Contains': queryArg['standard.Contains'],
          'totalAreaMetric.From': queryArg['totalAreaMetric.From'],
          'totalAreaMetric.To': queryArg['totalAreaMetric.To'],
          'available.Equal.Start': queryArg['available.Equal.Start'],
          'available.Equal.End': queryArg['available.Equal.End'],
          'vacant.Equal.Start': queryArg['vacant.Equal.Start'],
          'vacant.Equal.End': queryArg['vacant.Equal.End'],
          'hasRent.Equal': queryArg['hasRent.Equal'],
          'bedroomCount.From': queryArg['bedroomCount.From'],
          'bedroomCount.To': queryArg['bedroomCount.To'],
          'bathroomCount.From': queryArg['bathroomCount.From'],
          'bathroomCount.To': queryArg['bathroomCount.To'],
          'tags.Contains': queryArg['tags.Contains'],
          'requiredPackage.Equal': queryArg['requiredPackage.Equal'],
          'sort.Property': queryArg['sort.Property'],
          'sort.Order': queryArg['sort.Order'],
          'pagination.Offset': queryArg['pagination.Offset'],
          'pagination.Limit': queryArg['pagination.Limit'],
          search: queryArg.search,
        },
      }),
    }),
    postSpacesByIdOccupancies: build.mutation<PostSpacesByIdOccupanciesApiResponse, PostSpacesByIdOccupanciesApiArg>({
      query: (queryArg) => ({ url: `/spaces/${queryArg.id}/occupancies`, method: 'POST', body: queryArg.body }),
    }),
    getSpacesByIdOccupancies: build.query<GetSpacesByIdOccupanciesApiResponse, GetSpacesByIdOccupanciesApiArg>({
      query: (queryArg) => ({ url: `/spaces/${queryArg.id}/occupancies` }),
    }),
    deleteSpacesByIdBudgetsAndYear: build.mutation<
      DeleteSpacesByIdBudgetsAndYearApiResponse,
      DeleteSpacesByIdBudgetsAndYearApiArg
    >({
      query: (queryArg) => ({ url: `/spaces/${queryArg.id}/budgets/${queryArg.year}`, method: 'DELETE' }),
    }),
    getSpacesByIdBudgetsAndYear: build.query<GetSpacesByIdBudgetsAndYearApiResponse, GetSpacesByIdBudgetsAndYearApiArg>(
      {
        query: (queryArg) => ({ url: `/spaces/${queryArg.id}/budgets/${queryArg.year}` }),
      },
    ),
    putSpacesByIdBudgetsAndYear: build.mutation<
      PutSpacesByIdBudgetsAndYearApiResponse,
      PutSpacesByIdBudgetsAndYearApiArg
    >({
      query: (queryArg) => ({
        url: `/spaces/${queryArg.id}/budgets/${queryArg.year}`,
        method: 'PUT',
        body: queryArg.body,
      }),
    }),
    deleteSpacesByIdLoansAndLoanId: build.mutation<
      DeleteSpacesByIdLoansAndLoanIdApiResponse,
      DeleteSpacesByIdLoansAndLoanIdApiArg
    >({
      query: (queryArg) => ({ url: `/spaces/${queryArg.id}/loans/${queryArg.loanId}`, method: 'DELETE' }),
    }),
    putSpacesByIdLoansAndLoanId: build.mutation<
      PutSpacesByIdLoansAndLoanIdApiResponse,
      PutSpacesByIdLoansAndLoanIdApiArg
    >({
      query: (queryArg) => ({
        url: `/spaces/${queryArg.id}/loans/${queryArg.loanId}`,
        method: 'PUT',
        body: queryArg.body,
      }),
    }),
    deleteSpacesByIdPortfolioTenantsAndTenantId: build.mutation<
      DeleteSpacesByIdPortfolioTenantsAndTenantIdApiResponse,
      DeleteSpacesByIdPortfolioTenantsAndTenantIdApiArg
    >({
      query: (queryArg) => ({ url: `/spaces/${queryArg.id}/portfolio-tenants/${queryArg.tenantId}`, method: 'DELETE' }),
    }),
    putSpacesByIdPortfolioTenantsAndTenantId: build.mutation<
      PutSpacesByIdPortfolioTenantsAndTenantIdApiResponse,
      PutSpacesByIdPortfolioTenantsAndTenantIdApiArg
    >({
      query: (queryArg) => ({
        url: `/spaces/${queryArg.id}/portfolio-tenants/${queryArg.tenantId}`,
        method: 'PUT',
        body: queryArg.body,
      }),
    }),
    deleteSpacesById: build.mutation<DeleteSpacesByIdApiResponse, DeleteSpacesByIdApiArg>({
      query: (queryArg) => ({ url: `/spaces/${queryArg.id}`, method: 'DELETE' }),
    }),
    getSpacesById: build.query<GetSpacesByIdApiResponse, GetSpacesByIdApiArg>({
      query: (queryArg) => ({ url: `/spaces/${queryArg.id}` }),
    }),
    putSpacesById: build.mutation<PutSpacesByIdApiResponse, PutSpacesByIdApiArg>({
      query: (queryArg) => ({ url: `/spaces/${queryArg.id}`, method: 'PUT', body: queryArg.body }),
    }),
    deleteSpacesByIdOccupanciesAndOccupancyId: build.mutation<
      DeleteSpacesByIdOccupanciesAndOccupancyIdApiResponse,
      DeleteSpacesByIdOccupanciesAndOccupancyIdApiArg
    >({
      query: (queryArg) => ({ url: `/spaces/${queryArg.id}/occupancies/${queryArg.occupancyId}`, method: 'DELETE' }),
    }),
    putSpacesByIdOccupanciesAndOccupancyId: build.mutation<
      PutSpacesByIdOccupanciesAndOccupancyIdApiResponse,
      PutSpacesByIdOccupanciesAndOccupancyIdApiArg
    >({
      query: (queryArg) => ({
        url: `/spaces/${queryArg.id}/occupancies/${queryArg.occupancyId}`,
        method: 'PUT',
        body: queryArg.body,
      }),
    }),
    getSpacesByIdFinancialReports: build.query<
      GetSpacesByIdFinancialReportsApiResponse,
      GetSpacesByIdFinancialReportsApiArg
    >({
      query: (queryArg) => ({ url: `/spaces/${queryArg.id}/financial-reports` }),
    }),
    postSpacesByIdFinancialReportsAndYear: build.mutation<
      PostSpacesByIdFinancialReportsAndYearApiResponse,
      PostSpacesByIdFinancialReportsAndYearApiArg
    >({
      query: (queryArg) => ({
        url: `/spaces/${queryArg.id}/financial-reports/${queryArg.year}`,
        method: 'POST',
        body: queryArg.body,
        params: { quarter: queryArg.quarter, accumulated: queryArg.accumulated },
      }),
    }),
    deleteSpacesByIdFinancialReportsAndYear: build.mutation<
      DeleteSpacesByIdFinancialReportsAndYearApiResponse,
      DeleteSpacesByIdFinancialReportsAndYearApiArg
    >({
      query: (queryArg) => ({
        url: `/spaces/${queryArg.id}/financial-reports/${queryArg.year}`,
        method: 'DELETE',
        params: { quarter: queryArg.quarter },
      }),
    }),
    getSpacesByIdFinancialReportsAndYearFile: build.query<
      GetSpacesByIdFinancialReportsAndYearFileApiResponse,
      GetSpacesByIdFinancialReportsAndYearFileApiArg
    >({
      query: (queryArg) => ({
        url: `/spaces/${queryArg.id}/financial-reports/${queryArg.year}/file`,
        params: { quarter: queryArg.quarter },
      }),
    }),
    getSpacesByIdBudgets: build.query<GetSpacesByIdBudgetsApiResponse, GetSpacesByIdBudgetsApiArg>({
      query: (queryArg) => ({ url: `/spaces/${queryArg.id}/budgets` }),
    }),
    getSpacesByIdConsumption: build.query<GetSpacesByIdConsumptionApiResponse, GetSpacesByIdConsumptionApiArg>({
      query: (queryArg) => ({
        url: `/spaces/${queryArg.id}/consumption`,
        params: {
          tenantId: queryArg.tenantId,
          resolution: queryArg.resolution,
          rollup: queryArg.rollup,
          'interval.Start': queryArg['interval.Start'],
          'interval.End': queryArg['interval.End'],
        },
      }),
    }),
    getSpacesByIdConsumptionEnergy: build.query<
      GetSpacesByIdConsumptionEnergyApiResponse,
      GetSpacesByIdConsumptionEnergyApiArg
    >({
      query: (queryArg) => ({
        url: `/spaces/${queryArg.id}/consumption/energy`,
        params: {
          tenantId: queryArg.tenantId,
          resolution: queryArg.resolution,
          rollup: queryArg.rollup,
          'interval.Start': queryArg['interval.Start'],
          'interval.End': queryArg['interval.End'],
        },
      }),
    }),
    getSpacesByIdConsumptionOccupancy: build.query<
      GetSpacesByIdConsumptionOccupancyApiResponse,
      GetSpacesByIdConsumptionOccupancyApiArg
    >({
      query: (queryArg) => ({
        url: `/spaces/${queryArg.id}/consumption/occupancy`,
        params: {
          tenantId: queryArg.tenantId,
          resolution: queryArg.resolution,
          rollup: queryArg.rollup,
          'interval.Start': queryArg['interval.Start'],
          'interval.End': queryArg['interval.End'],
        },
      }),
    }),
    getSpacesByIdConsumptionTenants: build.query<
      GetSpacesByIdConsumptionTenantsApiResponse,
      GetSpacesByIdConsumptionTenantsApiArg
    >({
      query: (queryArg) => ({
        url: `/spaces/${queryArg.id}/consumption/tenants`,
        params: {
          tenantId: queryArg.tenantId,
          resolution: queryArg.resolution,
          rollup: queryArg.rollup,
          'interval.Start': queryArg['interval.Start'],
          'interval.End': queryArg['interval.End'],
        },
      }),
    }),
    getSpacesByIdPortfolioFinancials: build.query<
      GetSpacesByIdPortfolioFinancialsApiResponse,
      GetSpacesByIdPortfolioFinancialsApiArg
    >({
      query: (queryArg) => ({ url: `/spaces/${queryArg.id}/portfolio-financials` }),
    }),
    putSpacesByIdPortfolioFinancials: build.mutation<
      PutSpacesByIdPortfolioFinancialsApiResponse,
      PutSpacesByIdPortfolioFinancialsApiArg
    >({
      query: (queryArg) => ({ url: `/spaces/${queryArg.id}/portfolio-financials`, method: 'PUT', body: queryArg.body }),
    }),
    getSpacesByIdAreaChanges: build.query<GetSpacesByIdAreaChangesApiResponse, GetSpacesByIdAreaChangesApiArg>({
      query: (queryArg) => ({ url: `/spaces/${queryArg.id}/area-changes` }),
    }),
    getSpacesByBuildingIdAssociationMatrix: build.query<
      GetSpacesByBuildingIdAssociationMatrixApiResponse,
      GetSpacesByBuildingIdAssociationMatrixApiArg
    >({
      query: (queryArg) => ({ url: `/spaces/${queryArg.buildingId}/association-matrix` }),
    }),
    putSpacesByBuildingIdAssociationMatrix: build.mutation<
      PutSpacesByBuildingIdAssociationMatrixApiResponse,
      PutSpacesByBuildingIdAssociationMatrixApiArg
    >({
      query: (queryArg) => ({
        url: `/spaces/${queryArg.buildingId}/association-matrix`,
        method: 'PUT',
        body: queryArg.body,
      }),
    }),
    getSpacesByIdAssociations: build.query<GetSpacesByIdAssociationsApiResponse, GetSpacesByIdAssociationsApiArg>({
      query: (queryArg) => ({ url: `/spaces/${queryArg.id}/associations` }),
    }),
    putSpacesByIdAssociations: build.mutation<PutSpacesByIdAssociationsApiResponse, PutSpacesByIdAssociationsApiArg>({
      query: (queryArg) => ({ url: `/spaces/${queryArg.id}/associations`, method: 'PUT', body: queryArg.body }),
    }),
    getSpacesByIdHierarchy: build.query<GetSpacesByIdHierarchyApiResponse, GetSpacesByIdHierarchyApiArg>({
      query: (queryArg) => ({ url: `/spaces/${queryArg.id}/hierarchy` }),
    }),
    putSpacesByIdAreaChangesAndChangeIdTag: build.mutation<
      PutSpacesByIdAreaChangesAndChangeIdTagApiResponse,
      PutSpacesByIdAreaChangesAndChangeIdTagApiArg
    >({
      query: (queryArg) => ({
        url: `/spaces/${queryArg.id}/area-changes/${queryArg.changeId}/tag`,
        method: 'PUT',
        body: queryArg.body,
      }),
    }),
    putSpacesByIdChildren: build.mutation<PutSpacesByIdChildrenApiResponse, PutSpacesByIdChildrenApiArg>({
      query: (queryArg) => ({ url: `/spaces/${queryArg.id}/children`, method: 'PUT', body: queryArg.body }),
    }),
    putSpacesByIdTags: build.mutation<PutSpacesByIdTagsApiResponse, PutSpacesByIdTagsApiArg>({
      query: (queryArg) => ({ url: `/spaces/${queryArg.id}/tags`, method: 'PUT', body: queryArg.body }),
    }),
    putSpacesByIdInvestor: build.mutation<PutSpacesByIdInvestorApiResponse, PutSpacesByIdInvestorApiArg>({
      query: (queryArg) => ({ url: `/spaces/${queryArg.id}/investor`, method: 'PUT', body: queryArg.body }),
    }),
    putSpacesByIdManager: build.mutation<PutSpacesByIdManagerApiResponse, PutSpacesByIdManagerApiArg>({
      query: (queryArg) => ({ url: `/spaces/${queryArg.id}/manager`, method: 'PUT', body: queryArg.body }),
    }),
    putSpacesByIdOwner: build.mutation<PutSpacesByIdOwnerApiResponse, PutSpacesByIdOwnerApiArg>({
      query: (queryArg) => ({ url: `/spaces/${queryArg.id}/owner`, method: 'PUT', body: queryArg.body }),
    }),
    putSpacesByIdFinancials: build.mutation<PutSpacesByIdFinancialsApiResponse, PutSpacesByIdFinancialsApiArg>({
      query: (queryArg) => ({ url: `/spaces/${queryArg.id}/financials`, method: 'PUT', body: queryArg.body }),
    }),
    postSpacesByIdPortfolioFinancialsValuationReports: build.mutation<
      PostSpacesByIdPortfolioFinancialsValuationReportsApiResponse,
      PostSpacesByIdPortfolioFinancialsValuationReportsApiArg
    >({
      query: (queryArg) => ({
        url: `/spaces/${queryArg.id}/portfolio-financials/valuation-reports`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    getSpacesByIdPortfolioFinancialsValuationReportsAndReportId: build.query<
      GetSpacesByIdPortfolioFinancialsValuationReportsAndReportIdApiResponse,
      GetSpacesByIdPortfolioFinancialsValuationReportsAndReportIdApiArg
    >({
      query: (queryArg) => ({
        url: `/spaces/${queryArg.id}/portfolio-financials/valuation-reports/${queryArg.reportId}`,
      }),
    }),
    deleteSpacesByIdPortfolioFinancialsValuationReportsAndReportId: build.mutation<
      DeleteSpacesByIdPortfolioFinancialsValuationReportsAndReportIdApiResponse,
      DeleteSpacesByIdPortfolioFinancialsValuationReportsAndReportIdApiArg
    >({
      query: (queryArg) => ({
        url: `/spaces/${queryArg.id}/portfolio-financials/valuation-reports/${queryArg.reportId}`,
        method: 'DELETE',
      }),
    }),
    getSpacesStakeholders: build.query<GetSpacesStakeholdersApiResponse, GetSpacesStakeholdersApiArg>({
      query: (queryArg) => ({
        url: `/spaces/stakeholders`,
        params: {
          'pagination.Offset': queryArg['pagination.Offset'],
          'pagination.Limit': queryArg['pagination.Limit'],
          search: queryArg.search,
        },
      }),
    }),
    postSpacesBySpaceIdFiles: build.mutation<PostSpacesBySpaceIdFilesApiResponse, PostSpacesBySpaceIdFilesApiArg>({
      query: (queryArg) => ({ url: `/spaces/${queryArg.spaceId}/files`, method: 'POST', body: queryArg.body }),
    }),
    getSpacesBySpaceIdFiles: build.query<GetSpacesBySpaceIdFilesApiResponse, GetSpacesBySpaceIdFilesApiArg>({
      query: (queryArg) => ({
        url: `/spaces/${queryArg.spaceId}/files`,
        params: {
          'spaceId.Equal': queryArg['spaceId.Equal'],
          'pagination.Offset': queryArg['pagination.Offset'],
          'pagination.Limit': queryArg['pagination.Limit'],
          search: queryArg.search,
        },
      }),
    }),
    deleteSpacesBySpaceIdFilesAndFileId: build.mutation<
      DeleteSpacesBySpaceIdFilesAndFileIdApiResponse,
      DeleteSpacesBySpaceIdFilesAndFileIdApiArg
    >({
      query: (queryArg) => ({ url: `/spaces/${queryArg.spaceId}/files/${queryArg.fileId}`, method: 'DELETE' }),
    }),
    getStatisticsNetYieldBuildingsExport: build.query<
      GetStatisticsNetYieldBuildingsExportApiResponse,
      GetStatisticsNetYieldBuildingsExportApiArg
    >({
      query: (queryArg) => ({
        url: `/statistics/net-yield/buildings/export`,
        params: { startDate: queryArg.startDate, endDate: queryArg.endDate },
      }),
    }),
    getStatisticsCitiesVacancy: build.query<GetStatisticsCitiesVacancyApiResponse, GetStatisticsCitiesVacancyApiArg>({
      query: (queryArg) => ({ url: `/statistics/cities/vacancy`, params: { sortOrder: queryArg.sortOrder } }),
    }),
    getStatisticsSpacesEndingContract: build.query<
      GetStatisticsSpacesEndingContractApiResponse,
      GetStatisticsSpacesEndingContractApiArg
    >({
      query: (queryArg) => ({
        url: `/statistics/spaces/ending-contract`,
        params: { endingBy: queryArg.endingBy, offset: queryArg.offset, limit: queryArg.limit },
      }),
    }),
    getStatisticsNetYieldBuildingsById: build.query<
      GetStatisticsNetYieldBuildingsByIdApiResponse,
      GetStatisticsNetYieldBuildingsByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/statistics/net-yield/buildings/${queryArg.id}`,
        params: { startDate: queryArg.startDate, endDate: queryArg.endDate },
      }),
    }),
    getStatisticsNetYieldBuildings: build.query<
      GetStatisticsNetYieldBuildingsApiResponse,
      GetStatisticsNetYieldBuildingsApiArg
    >({
      query: (queryArg) => ({
        url: `/statistics/net-yield/buildings`,
        params: {
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
          page: queryArg.page,
          pageSize: queryArg.pageSize,
        },
      }),
    }),
    postStatisticsNetYieldDashboard: build.mutation<
      PostStatisticsNetYieldDashboardApiResponse,
      PostStatisticsNetYieldDashboardApiArg
    >({
      query: (queryArg) => ({
        url: `/statistics/net-yield/dashboard`,
        method: 'POST',
        body: queryArg.body,
        params: { startDate: queryArg.startDate, endDate: queryArg.endDate },
      }),
    }),
    getStatisticsNetYield: build.query<GetStatisticsNetYieldApiResponse, GetStatisticsNetYieldApiArg>({
      query: (queryArg) => ({
        url: `/statistics/net-yield`,
        params: { startDate: queryArg.startDate, endDate: queryArg.endDate },
      }),
    }),
    getStatisticsRent: build.query<GetStatisticsRentApiResponse, GetStatisticsRentApiArg>({
      query: (queryArg) => ({
        url: `/statistics/rent`,
        params: {
          groupBy: queryArg.groupBy,
          'currencyCode.Equal': queryArg['currencyCode.Equal'],
          'countryCode.Equal': queryArg['countryCode.Equal'],
          'zipPlace.Equal': queryArg['zipPlace.Equal'],
          'zipCode.Equal': queryArg['zipCode.Equal'],
          'streetName.Equal': queryArg['streetName.Equal'],
          'streetNumber.Equal': queryArg['streetNumber.Equal'],
        },
      }),
    }),
    getStatisticsSpacesVacancy: build.query<GetStatisticsSpacesVacancyApiResponse, GetStatisticsSpacesVacancyApiArg>({
      query: (queryArg) => ({
        url: `/statistics/spaces/vacancy`,
        params: { offset: queryArg.offset, limit: queryArg.limit },
      }),
    }),
    getStatisticsVacancy: build.query<GetStatisticsVacancyApiResponse, GetStatisticsVacancyApiArg>({
      query: (queryArg) => ({
        url: `/statistics/vacancy`,
        params: {
          'ancestorPath.Equal': queryArg['ancestorPath.Equal'],
          'discriminator.Contains': queryArg['discriminator.Contains'],
        },
      }),
    }),
    getTags: build.query<GetTagsApiResponse, GetTagsApiArg>({
      query: (queryArg) => ({
        url: `/tags`,
        params: {
          'spaceId.Equal': queryArg['spaceId.Equal'],
          'isUsed.Equal': queryArg['isUsed.Equal'],
          'pagination.Offset': queryArg['pagination.Offset'],
          'pagination.Limit': queryArg['pagination.Limit'],
          search: queryArg.search,
        },
      }),
    }),
    getTenantsCurrentCompany: build.query<GetTenantsCurrentCompanyApiResponse, GetTenantsCurrentCompanyApiArg>({
      query: () => ({ url: `/tenants/current/company` }),
    }),
    getTenantsCurrentMembers: build.query<GetTenantsCurrentMembersApiResponse, GetTenantsCurrentMembersApiArg>({
      query: (queryArg) => ({
        url: `/tenants/current/members`,
        params: {
          'pagination.Offset': queryArg['pagination.Offset'],
          'pagination.Limit': queryArg['pagination.Limit'],
          search: queryArg.search,
          includeInactive: queryArg.includeInactive,
        },
      }),
    }),
    getTenantsByTenantIdPersons: build.query<GetTenantsByTenantIdPersonsApiResponse, GetTenantsByTenantIdPersonsApiArg>(
      {
        query: (queryArg) => ({ url: `/tenants/${queryArg.tenantId}/persons` }),
      },
    ),
    postUsages: build.mutation<PostUsagesApiResponse, PostUsagesApiArg>({
      query: (queryArg) => ({ url: `/usages`, method: 'POST', body: queryArg.body }),
    }),
    getUsages: build.query<GetUsagesApiResponse, GetUsagesApiArg>({
      query: (queryArg) => ({
        url: `/usages`,
        params: {
          'spaceId.Equal': queryArg['spaceId.Equal'],
          'spaceAncestorPath.Equal': queryArg['spaceAncestorPath.Equal'],
          'sort.Property': queryArg['sort.Property'],
          'sort.Order': queryArg['sort.Order'],
          'pagination.Offset': queryArg['pagination.Offset'],
          'pagination.Limit': queryArg['pagination.Limit'],
          search: queryArg.search,
        },
      }),
    }),
    deleteUsagesById: build.mutation<DeleteUsagesByIdApiResponse, DeleteUsagesByIdApiArg>({
      query: (queryArg) => ({ url: `/usages/${queryArg.id}`, method: 'DELETE' }),
    }),
    getUsagesById: build.query<GetUsagesByIdApiResponse, GetUsagesByIdApiArg>({
      query: (queryArg) => ({ url: `/usages/${queryArg.id}` }),
    }),
    putUsagesById: build.mutation<PutUsagesByIdApiResponse, PutUsagesByIdApiArg>({
      query: (queryArg) => ({ url: `/usages/${queryArg.id}`, method: 'PUT', body: queryArg.body }),
    }),
    getUserPermissions: build.query<GetUserPermissionsApiResponse, GetUserPermissionsApiArg>({
      query: () => ({ url: `/user/permissions` }),
    }),
    postUserPermissionsSpaces: build.mutation<PostUserPermissionsSpacesApiResponse, PostUserPermissionsSpacesApiArg>({
      query: (queryArg) => ({ url: `/user/permissions/spaces`, method: 'POST', body: queryArg.body }),
    }),
    getUserPermissionsSpacesById: build.query<
      GetUserPermissionsSpacesByIdApiResponse,
      GetUserPermissionsSpacesByIdApiArg
    >({
      query: (queryArg) => ({ url: `/user/permissions/spaces/${queryArg.id}` }),
    }),
    postUserPermissionsAgreements: build.mutation<
      PostUserPermissionsAgreementsApiResponse,
      PostUserPermissionsAgreementsApiArg
    >({
      query: (queryArg) => ({ url: `/user/permissions/agreements`, method: 'POST', body: queryArg.body }),
    }),
    getUserPermissionsAgreementsById: build.query<
      GetUserPermissionsAgreementsByIdApiResponse,
      GetUserPermissionsAgreementsByIdApiArg
    >({
      query: (queryArg) => ({ url: `/user/permissions/agreements/${queryArg.id}` }),
    }),
    getUserPermissionsDefinitions: build.query<
      GetUserPermissionsDefinitionsApiResponse,
      GetUserPermissionsDefinitionsApiArg
    >({
      query: () => ({ url: `/user/permissions/definitions` }),
    }),
    getVacancyExportDetails: build.query<GetVacancyExportDetailsApiResponse, GetVacancyExportDetailsApiArg>({
      query: (queryArg) => ({
        url: `/vacancy/export-details`,
        params: {
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
          orderBy: queryArg.orderBy,
          page: queryArg.page,
          pageSize: queryArg.pageSize,
        },
      }),
    }),
    postVacancyDashboard: build.mutation<PostVacancyDashboardApiResponse, PostVacancyDashboardApiArg>({
      query: (queryArg) => ({
        url: `/vacancy/dashboard`,
        method: 'POST',
        body: queryArg.body,
        params: { startDate: queryArg.startDate, endDate: queryArg.endDate },
      }),
    }),
    getVacancyDetails: build.query<GetVacancyDetailsApiResponse, GetVacancyDetailsApiArg>({
      query: (queryArg) => ({
        url: `/vacancy/details`,
        params: {
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
          orderBy: queryArg.orderBy,
          page: queryArg.page,
          pageSize: queryArg.pageSize,
        },
      }),
    }),
    getVacancySummary: build.query<GetVacancySummaryApiResponse, GetVacancySummaryApiArg>({
      query: (queryArg) => ({
        url: `/vacancy/summary`,
        params: { startDate: queryArg.startDate, endDate: queryArg.endDate },
      }),
    }),
    postWebhooksDocumentSigning: build.mutation<
      PostWebhooksDocumentSigningApiResponse,
      PostWebhooksDocumentSigningApiArg
    >({
      query: (queryArg) => ({ url: `/webhooks/document-signing`, method: 'POST', body: queryArg.body }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as generatedApiSlice };
export type GetActivitiesLatestApiResponse = /** status 200 Success */ ActivityReadModel[];
export type GetActivitiesLatestApiArg = void;
export type GetAgreementPartiesApiResponse = /** status 200 Success */ AgreementPartyReadModelOffsetPaginationResponse;
export type GetAgreementPartiesApiArg = {
  'spaceId.Equal'?: string;
  'spaceAncestorPath.Equal'?: string;
  'status.Contains'?: AgreementStatus[];
  'active.Equal'?: boolean;
  'type.Contains'?: RelationshipType[];
  'at.Equal.Start'?: string;
  'at.Equal.End'?: string;
  'sort.Property'?: AgreementPartyReadModelSort;
  'sort.Order'?: SortOrder;
  'pagination.Offset'?: number;
  'pagination.Limit'?: number;
  search?: string;
};
export type PostAgreementImportsBySessionIdAbandonApiResponse = /** status 200 Success */ AgreementImportSessionStatus;
export type PostAgreementImportsBySessionIdAbandonApiArg = {
  sessionId: string;
};
export type PostAgreementImportsBySessionIdContractsAndContractIdApproveApiResponse = /** status 200 Success */ string;
export type PostAgreementImportsBySessionIdContractsAndContractIdApproveApiArg = {
  sessionId: string;
  contractId: string;
};
export type PostAgreementImportsBySessionIdCompleteApiResponse = /** status 200 Success */ AgreementImportSessionStatus;
export type PostAgreementImportsBySessionIdCompleteApiArg = {
  sessionId: string;
};
export type PatchAgreementImportsBySessionIdContractsAndContractIdApiResponse =
  /** status 200 Success */ ContractReview;
export type PatchAgreementImportsBySessionIdContractsAndContractIdApiArg = {
  sessionId: string;
  contractId: string;
  body: CorrectAgreementImportContractPayload;
};
export type PostAgreementImportsApiResponse = /** status 200 Success */ string;
export type PostAgreementImportsApiArg = {
  body: CreateAgreementImportSessionPayload;
};
export type GetAgreementImportsApiResponse = /** status 200 Success */ AgreementImportSessionSummary[];
export type GetAgreementImportsApiArg = {
  buildingSpaceId?: string;
};
export type GetAgreementImportsBySessionIdContractsApiResponse = /** status 200 Success */ ContractReview[];
export type GetAgreementImportsBySessionIdContractsApiArg = {
  sessionId: string;
};
export type GetAgreementImportsBySessionIdContractsAndContractIdValidationApiResponse =
  /** status 200 Success */ AgreementReadinessStatus;
export type GetAgreementImportsBySessionIdContractsAndContractIdValidationApiArg = {
  sessionId: string;
  contractId: string;
};
export type PostAgreementImportsBySessionIdRowsApiResponse = /** status 200 Success */ ContractReview[];
export type PostAgreementImportsBySessionIdRowsApiArg = {
  sessionId: string;
  body: AgreementImportSourceRow[];
};
export type PostAgreementImportsBySessionIdContractsAndContractIdRejectApiResponse =
  /** status 200 Success */ ContractReview;
export type PostAgreementImportsBySessionIdContractsAndContractIdRejectApiArg = {
  sessionId: string;
  contractId: string;
};
export type PostAgreementImportsBySessionIdContractsAndContractIdLinesLineIdRejectApiResponse =
  /** status 200 Success */ ContractReview;
export type PostAgreementImportsBySessionIdContractsAndContractIdLinesLineIdRejectApiArg = {
  sessionId: string;
  contractId: string;
  lineId: string;
};
export type PostAgreementsApiResponse = /** status 200 Success */ AgreementReadModel;
export type PostAgreementsApiArg = {
  body: CreateAgreementPayload;
};
export type GetAgreementsApiResponse = /** status 200 Success */ AgreementReadModelOffsetPaginationResponse;
export type GetAgreementsApiArg = {
  'userId.Equal'?: string;
  'spaceId.Equal'?: string;
  'spaceAncestorPath.Equal'?: string;
  'at.Equal.Start'?: string;
  'at.Equal.End'?: string;
  'buildingId.Equal'?: string;
  'hasNoBuilding.Equal'?: boolean;
  'companyId.Equal'?: string;
  'productId.Equal'?: string;
  'status.Equal'?: AgreementStatus;
  'sort.Property'?: AgreementReadModelSort;
  'sort.Order'?: SortOrder;
  'pagination.Offset'?: number;
  'pagination.Limit'?: number;
  search?: string;
};
export type DeleteAgreementsByIdApiResponse = /** status 200 Success */ undefined;
export type DeleteAgreementsByIdApiArg = {
  id: string;
};
export type GetAgreementsByIdApiResponse = /** status 200 Success */ AgreementReadModel;
export type GetAgreementsByIdApiArg = {
  id: string;
};
export type PutAgreementsByIdApiResponse = /** status 200 Success */ undefined;
export type PutAgreementsByIdApiArg = {
  id: string;
  body: SetAgreementModel;
};
export type GetAgreementsBuildingsApiResponse = /** status 200 Success */ BuildingsWithAgreementsResponse;
export type GetAgreementsBuildingsApiArg = {
  'pagination.Offset'?: number;
  'pagination.Limit'?: number;
  search?: string;
};
export type GetAgreementsReportToInvoiceApiResponse =
  /** status 200 Success */ AgreementToInvoiceReadModelOffsetPaginationResponse;
export type GetAgreementsReportToInvoiceApiArg = {
  periodFrom?: string;
  periodTo?: string;
  sortBy?: AgreementsToInvoiceReportSort;
  sortOrder?: SortOrder;
  'pagination.Offset'?: number;
  'pagination.Limit'?: number;
  search?: string;
};
export type PostAgreementsByIdRestoreApiResponse = /** status 200 Success */ AgreementReadModel;
export type PostAgreementsByIdRestoreApiArg = {
  id: string;
};
export type PostAgreementsByIdSyncTripletexApiResponse = /** status 200 Success */ undefined;
export type PostAgreementsByIdSyncTripletexApiArg = {
  id: string;
};
export type PostAgreementsByAgreementIdIndexAdjustmentsApiResponse = /** status 201 Created */ IndexAdjustmentDto;
export type PostAgreementsByAgreementIdIndexAdjustmentsApiArg = {
  agreementId: string;
  body: CreateIndexAdjustmentApiRequest;
};
export type GetAgreementsByAgreementIdIndexAdjustmentsApiResponse = /** status 200 Success */ IndexAdjustmentDto[];
export type GetAgreementsByAgreementIdIndexAdjustmentsApiArg = {
  agreementId: string;
};
export type GetAgreementsStakeholdersApiResponse = /** status 200 Success */ TenantReadModelOffsetPaginationResponse;
export type GetAgreementsStakeholdersApiArg = {
  'pagination.Offset'?: number;
  'pagination.Limit'?: number;
  search?: string;
};
export type PutAgreementsByAgreementIdSpacesApiResponse = /** status 200 Success */ undefined;
export type PutAgreementsByAgreementIdSpacesApiArg = {
  agreementId: string;
  body: SetAgreementSpacePayload[];
};
export type PostAgreementsByAgreementIdProductsApiResponse = /** status 200 Success */ undefined;
export type PostAgreementsByAgreementIdProductsApiArg = {
  agreementId: string;
  body: CreateAgreementProductPayload;
};
export type PutAgreementsByAgreementIdProductsApiResponse = /** status 200 Success */ undefined;
export type PutAgreementsByAgreementIdProductsApiArg = {
  agreementId: string;
  body: SetAgreementProductPayload[];
};
export type DeleteAgreementsByAgreementIdProductsAndPriceIdApiResponse = /** status 200 Success */ undefined;
export type DeleteAgreementsByAgreementIdProductsAndPriceIdApiArg = {
  agreementId: string;
  priceId: string;
};
export type PutAgreementsByAgreementIdProductsAndPriceIdApiResponse = /** status 200 Success */ undefined;
export type PutAgreementsByAgreementIdProductsAndPriceIdApiArg = {
  agreementId: string;
  priceId: string;
  body: UpdateAgreementProductPayload;
};
export type PostAgreementsByAgreementIdPartiesApiResponse = /** status 200 Success */ undefined;
export type PostAgreementsByAgreementIdPartiesApiArg = {
  agreementId: string;
  body: CreateAgreementPartyPayload;
};
export type PutAgreementsByAgreementIdPartiesApiResponse = /** status 200 Success */ undefined;
export type PutAgreementsByAgreementIdPartiesApiArg = {
  agreementId: string;
  body: SetAgreementPartyPayload[];
};
export type DeleteAgreementsByAgreementIdPartiesAndLegalPersonIdApiResponse = /** status 200 Success */ undefined;
export type DeleteAgreementsByAgreementIdPartiesAndLegalPersonIdApiArg = {
  agreementId: string;
  legalPersonId: string;
};
export type GetAgreementsByAgreementIdPartiesAndPartyIdAvailableContactsApiResponse =
  /** status 200 Success */ PersonReadModel[];
export type GetAgreementsByAgreementIdPartiesAndPartyIdAvailableContactsApiArg = {
  agreementId: string;
  partyId: string;
};
export type GetAgreementsByAgreementIdInvoiceHistoryApiResponse = /** status 200 Success */ InvoiceHistoryItemDto[];
export type GetAgreementsByAgreementIdInvoiceHistoryApiArg = {
  agreementId: string;
};
export type PostAgreementsByAgreementIdFilesApiResponse = /** status 200 Success */ AgreementFileReadModel;
export type PostAgreementsByAgreementIdFilesApiArg = {
  agreementId: string;
  body: {
    File?: Blob;
  };
};
export type GetAgreementsByAgreementIdFilesApiResponse =
  /** status 200 Success */ AgreementFileReadModelOffsetPaginationResponse;
export type GetAgreementsByAgreementIdFilesApiArg = {
  agreementId: string;
  'agreementId.Equal'?: string;
  'pagination.Offset'?: number;
  'pagination.Limit'?: number;
  search?: string;
};
export type DeleteAgreementsByAgreementIdFilesAndFileIdApiResponse = /** status 200 Success */ undefined;
export type DeleteAgreementsByAgreementIdFilesAndFileIdApiArg = {
  agreementId: string;
  fileId: string;
};
export type GetAgreementsByAgreementIdFilesAndFileIdDownloadApiResponse = unknown;
export type GetAgreementsByAgreementIdFilesAndFileIdDownloadApiArg = {
  agreementId: string;
  fileId: string;
};
export type GetAgreementsByAgreementIdActivityLogsApiResponse =
  /** status 200 Success */ AgreementActivityLogDtoPagedListDto;
export type GetAgreementsByAgreementIdActivityLogsApiArg = {
  agreementId: string;
  orderBy?: string;
  page?: number;
  pageSize?: number;
};
export type PostAuthFinishInvitationApiResponse = /** status 200 Success */ undefined;
export type PostAuthFinishInvitationApiArg = {
  body: FinishInvitationPayload;
};
export type GetAuthSessionApiResponse = /** status 200 Success */ AclModel;
export type GetAuthSessionApiArg = void;
export type GetAuthSessionUserApiResponse = /** status 200 Success */ UserReadModel;
export type GetAuthSessionUserApiArg = void;
export type PostBranchesApiResponse = /** status 200 Success */ BranchReadModel;
export type PostBranchesApiArg = {
  body: CreateBranchPayload;
};
export type DeleteBranchesByIdApiResponse = /** status 200 Success */ undefined;
export type DeleteBranchesByIdApiArg = {
  id: string;
};
export type PutBranchesByIdApiResponse = /** status 200 Success */ undefined;
export type PutBranchesByIdApiArg = {
  id: string;
  body: BaseOrganizationModel;
};
export type PostBuildingsApiResponse = /** status 200 Success */ BuildingReadModel;
export type PostBuildingsApiArg = {
  body: SetBuildingPayload;
};
export type GetBuildingsApiResponse = /** status 200 Success */ BuildingReadModelOffsetPaginationResponse;
export type GetBuildingsApiArg = {
  'type.Contains'?: BuildingType[];
  'energyLabel.Contains'?: EnergyLabel[];
  'country.Equal'?: string;
  'constructionYear.From'?: number;
  'constructionYear.To'?: number;
  'location.From.Longitude'?: number;
  'location.From.Latitude'?: number;
  'location.RadiusMetric'?: number;
  'availableAreaMetric.From'?: number;
  'availableAreaMetric.To'?: number;
  'parentId.Equal'?: string;
  'rootId.Equal'?: string;
  'ancestorPath.Equal'?: string;
  'discriminator.Contains'?: SpaceDiscriminator[];
  'usageType.Contains'?: UsageType[];
  'standard.Contains'?: StandardType[];
  'totalAreaMetric.From'?: number;
  'totalAreaMetric.To'?: number;
  'available.Equal.Start'?: string;
  'available.Equal.End'?: string;
  'vacant.Equal.Start'?: string;
  'vacant.Equal.End'?: string;
  'hasRent.Equal'?: boolean;
  'bedroomCount.From'?: number;
  'bedroomCount.To'?: number;
  'bathroomCount.From'?: number;
  'bathroomCount.To'?: number;
  'tags.Contains'?: string[];
  'requiredPackage.Equal'?: PackageType;
  'sort.Property'?: BuildingReadModelSort;
  'sort.Order'?: SortOrder;
  'pagination.Offset'?: number;
  'pagination.Limit'?: number;
  search?: string;
};
export type CreateBuildingsForTenantApiResponse = /** status 200 Success */ CreateBuildingsForTenantResponse;
export type CreateBuildingsForTenantApiArg = {
  body: CreateBuildingsForTenantPayload;
};
export type GetBuildingsByBuildingIdAvailableBidAreasApiResponse = /** status 200 Success */ EnergyBidAreaReadModel[];
export type GetBuildingsByBuildingIdAvailableBidAreasApiArg = {
  buildingId: string;
};
export type GetBuildingsByBuildingIdBidAreaApiResponse = /** status 200 Success */ SpaceEnergyBidAreaReadModel;
export type GetBuildingsByBuildingIdBidAreaApiArg = {
  buildingId: string;
};
export type PutBuildingsByBuildingIdBidAreaApiResponse = /** status 200 Success */ SpaceEnergyBidAreaReadModel;
export type PutBuildingsByBuildingIdBidAreaApiArg = {
  buildingId: string;
  body: SetBuildingBidAreaPayload;
};
export type GetBuildingsByIdApiResponse = /** status 200 Success */ BuildingReadModel;
export type GetBuildingsByIdApiArg = {
  id: string;
};
export type PutBuildingsByIdApiResponse = /** status 200 Success */ undefined;
export type PutBuildingsByIdApiArg = {
  id: string;
  body: SetBuildingPayload;
};
export type GetBuildingsByBuildingIdEnergySettingsApiResponse =
  /** status 200 Success */ BuildingEnergySettingReadModel[];
export type GetBuildingsByBuildingIdEnergySettingsApiArg = {
  buildingId: string;
};
export type PutBuildingsByBuildingIdEnergySettingsApiResponse =
  /** status 200 Success */ BuildingEnergySettingReadModel;
export type PutBuildingsByBuildingIdEnergySettingsApiArg = {
  buildingId: string;
  body: SetBuildingEnergySettingModel;
};
export type GetBuildingsByIdInvestorApiResponse = /** status 200 Success */ BuildingAssigneeReadModel[];
export type GetBuildingsByIdInvestorApiArg = {
  id: string;
};
export type GetBuildingsByIdManagerApiResponse = /** status 200 Success */ BuildingAssigneeReadModel;
export type GetBuildingsByIdManagerApiArg = {
  id: string;
};
export type GetBuildingsByIdOwnerApiResponse = /** status 200 Success */ BuildingAssigneeReadModel[];
export type GetBuildingsByIdOwnerApiArg = {
  id: string;
};
export type GetCompaniesAtBuildingAddressApiResponse = /** status 200 Success */ CompanyReadModel[];
export type GetCompaniesAtBuildingAddressApiArg = {
  id: string;
};
export type GetCommercialSpacesByIdApiResponse = /** status 200 Success */ SpaceReadModel;
export type GetCommercialSpacesByIdApiArg = {
  id: string;
};
export type GetCommercialSpacesApiResponse = /** status 200 Success */ SpaceReadModelOffsetPaginationResponse;
export type GetCommercialSpacesApiArg = {
  'parentId.Equal'?: string;
  'rootId.Equal'?: string;
  'ancestorPath.Equal'?: string;
  'discriminator.Contains'?: SpaceDiscriminator[];
  'usageType.Contains'?: UsageType[];
  'standard.Contains'?: StandardType[];
  'totalAreaMetric.From'?: number;
  'totalAreaMetric.To'?: number;
  'available.Equal.Start'?: string;
  'available.Equal.End'?: string;
  'vacant.Equal.Start'?: string;
  'vacant.Equal.End'?: string;
  'hasRent.Equal'?: boolean;
  'bedroomCount.From'?: number;
  'bedroomCount.To'?: number;
  'bathroomCount.From'?: number;
  'bathroomCount.To'?: number;
  'tags.Contains'?: string[];
  'requiredPackage.Equal'?: PackageType;
  'sort.Property'?: SpaceReadModelSort;
  'sort.Order'?: SortOrder;
  'pagination.Offset'?: number;
  'pagination.Limit'?: number;
  search?: string;
};
export type PostCommonAreasApiResponse = /** status 200 Success */ CommonAreaReadModel;
export type PostCommonAreasApiArg = {
  body: CreateCommonAreaPayload;
};
export type GetCommonAreasApiResponse = /** status 200 Success */ CommonAreaReadModelOffsetPaginationResponse;
export type GetCommonAreasApiArg = {
  'parentId.Equal'?: string;
  'rootId.Equal'?: string;
  'ancestorPath.Equal'?: string;
  'discriminator.Contains'?: SpaceDiscriminator[];
  'usageType.Contains'?: UsageType[];
  'standard.Contains'?: StandardType[];
  'totalAreaMetric.From'?: number;
  'totalAreaMetric.To'?: number;
  'available.Equal.Start'?: string;
  'available.Equal.End'?: string;
  'vacant.Equal.Start'?: string;
  'vacant.Equal.End'?: string;
  'hasRent.Equal'?: boolean;
  'bedroomCount.From'?: number;
  'bedroomCount.To'?: number;
  'bathroomCount.From'?: number;
  'bathroomCount.To'?: number;
  'tags.Contains'?: string[];
  'requiredPackage.Equal'?: PackageType;
  'sort.Property'?: SpaceReadModelSort;
  'sort.Order'?: SortOrder;
  'pagination.Offset'?: number;
  'pagination.Limit'?: number;
  search?: string;
};
export type GetCommonAreasByIdApiResponse = /** status 200 Success */ CommonAreaReadModel;
export type GetCommonAreasByIdApiArg = {
  id: string;
};
export type PutCommonAreasByIdApiResponse = /** status 200 Success */ undefined;
export type PutCommonAreasByIdApiArg = {
  id: string;
  body: UpdateCommonAreaPayload;
};
export type PostCompaniesApiResponse = /** status 200 Success */ LegalPersonReadModel;
export type PostCompaniesApiArg = {
  body: BaseCompanyModel;
};
export type GetCompaniesApiResponse = /** status 200 Success */ CompanyReadModelOffsetPaginationResponse;
export type GetCompaniesApiArg = {
  'sort.Property'?: CompanyReadModelSort;
  'sort.Order'?: SortOrder;
  'pagination.Offset'?: number;
  'pagination.Limit'?: number;
  search?: string;
  role?: string;
};
export type DeleteCompaniesByIdApiResponse = /** status 200 Success */ undefined;
export type DeleteCompaniesByIdApiArg = {
  id: string;
};
export type GetCompaniesByIdApiResponse = /** status 200 Success */ CompanyReadModel;
export type GetCompaniesByIdApiArg = {
  id: string;
};
export type PutCompaniesByIdApiResponse = /** status 200 Success */ undefined;
export type PutCompaniesByIdApiArg = {
  id: string;
  body: BaseCompanyModel;
};
export type DeleteCompaniesByCompanyIdMembersInviteAndInvitationIdApiResponse = unknown;
export type DeleteCompaniesByCompanyIdMembersInviteAndInvitationIdApiArg = {
  companyId: string;
  invitationId: string;
};
export type GetCompaniesByCompanyIdContactPersonAssignmentsApiResponse =
  /** status 200 Success */ CompanyContactPersonAssignmentReadModel[];
export type GetCompaniesByCompanyIdContactPersonAssignmentsApiArg = {
  companyId: string;
};
export type GetCompaniesByIdDepartmentsApiResponse = /** status 200 Success */ CompanyDepartmentDto[];
export type GetCompaniesByIdDepartmentsApiArg = {
  id: string;
};
export type GetCompaniesByCompanyIdMembersApiResponse =
  /** status 200 Success */ TenantMemberReadModelOffsetPaginationResponse;
export type GetCompaniesByCompanyIdMembersApiArg = {
  companyId: string;
  'pagination.Offset'?: number;
  'pagination.Limit'?: number;
  search?: string;
  includeInactive?: boolean;
};
export type GetCompaniesRoleCountsApiResponse = /** status 200 Success */ CompanyRoleCountsDto;
export type GetCompaniesRoleCountsApiArg = void;
export type PostCompaniesByCompanyIdMembersInviteAndInvitationIdResendApiResponse = unknown;
export type PostCompaniesByCompanyIdMembersInviteAndInvitationIdResendApiArg = {
  companyId: string;
  invitationId: string;
};
export type DeleteCompaniesByCompanyIdPersonsAndUserIdApiResponse = /** status 200 Success */ undefined;
export type DeleteCompaniesByCompanyIdPersonsAndUserIdApiArg = {
  companyId: string;
  userId: string;
};
export type GetCompaniesByCompanyIdPersonsApiResponse =
  /** status 200 Success */ CompanyPersonReadModelOffsetPaginationResponse;
export type GetCompaniesByCompanyIdPersonsApiArg = {
  companyId: string;
  'sort.Property'?: PersonReadModelSort;
  'sort.Order'?: SortOrder;
  'pagination.Offset'?: number;
  'pagination.Limit'?: number;
  search?: string;
};
export type PostCompaniesByCompanyIdPersonsAndUserIdReactivateApiResponse = /** status 200 Success */ undefined;
export type PostCompaniesByCompanyIdPersonsAndUserIdReactivateApiArg = {
  companyId: string;
  userId: string;
};
export type DeleteContractsByIdSigningApiResponse = /** status 200 Success */ undefined;
export type DeleteContractsByIdSigningApiArg = {
  id: string;
  body: CancelContractSigningPayload;
};
export type PostContractsByIdSigningApiResponse = /** status 200 Success */ undefined;
export type PostContractsByIdSigningApiArg = {
  id: string;
};
export type PostContractsApiResponse = /** status 200 Success */ ContractReadModel;
export type PostContractsApiArg = {
  body: {
    AgreementId?: string;
    Name?: string;
    Description?: string;
    Deadline?: string;
    File?: Blob;
  };
};
export type GetContractsApiResponse = /** status 200 Success */ ContractReadModelOffsetPaginationResponse;
export type GetContractsApiArg = {
  'agreementId.Equal'?: string;
  'pagination.Offset'?: number;
  'pagination.Limit'?: number;
  search?: string;
};
export type DeleteContractsByIdApiResponse = /** status 200 Success */ undefined;
export type DeleteContractsByIdApiArg = {
  id: string;
};
export type GetContractsExpirationExportDetailsApiResponse =
  /** status 200 Success */ ContractExpirationDetailReportDto[];
export type GetContractsExpirationExportDetailsApiArg = {
  startDate?: string;
  endDate?: string;
  orderBy?: string;
  page?: number;
  pageSize?: number;
};
export type GetContractsExportDetailsApiResponse = /** status 200 Success */ BuildingContractLengthDetailsDto[];
export type GetContractsExportDetailsApiArg = {
  startDate?: string;
  endDate?: string;
  orderBy?: string;
  page?: number;
  pageSize?: number;
};
export type GetContractsVatPercentageExportDetailsApiResponse = /** status 200 Success */ VatPercentageByBuildingDto[];
export type GetContractsVatPercentageExportDetailsApiArg = {
  startDate?: string;
  endDate?: string;
  orderBy?: string;
  page?: number;
  pageSize?: number;
};
export type PostContractsAverageLengthDashboardApiResponse =
  /** status 200 Success */ AverageContractLengthDashboardDto;
export type PostContractsAverageLengthDashboardApiArg = {
  startDate?: string;
  endDate?: string;
  body: BuildingPayload;
};
export type GetContractsAverageLengthApiResponse = /** status 200 Success */ AverageContractLengthReportDto;
export type GetContractsAverageLengthApiArg = {
  startDate?: string;
  endDate?: string;
};
export type PostContractsExpirationDashboardApiResponse = /** status 200 Success */ ContractExpirationSummaryReportDto;
export type PostContractsExpirationDashboardApiArg = {
  startDate?: string;
  endDate?: string;
  body: BuildingPayload;
};
export type GetContractsExpirationDetailsApiResponse =
  /** status 200 Success */ ContractExpirationDetailReportDtoPagedListDto;
export type GetContractsExpirationDetailsApiArg = {
  startDate?: string;
  endDate?: string;
  orderBy?: string;
  page?: number;
  pageSize?: number;
};
export type GetContractsExpirationSummaryApiResponse = /** status 200 Success */ ContractExpirationSummaryReportDto;
export type GetContractsExpirationSummaryApiArg = {
  startDate?: string;
  endDate?: string;
};
export type GetContractsDetailsApiResponse = /** status 200 Success */ BuildingContractLengthDetailsDtoPagedListDto;
export type GetContractsDetailsApiArg = {
  startDate?: string;
  endDate?: string;
  orderBy?: string;
  page?: number;
  pageSize?: number;
};
export type GetContractsVatPercentageDetailsApiResponse =
  /** status 200 Success */ VatPercentageByBuildingDtoPagedListDto;
export type GetContractsVatPercentageDetailsApiArg = {
  startDate?: string;
  endDate?: string;
  orderBy?: string;
  page?: number;
  pageSize?: number;
};
export type GetContractsVatPercentageSummaryApiResponse = /** status 200 Success */ VatPercentageSummaryDto;
export type GetContractsVatPercentageSummaryApiArg = {
  startDate?: string;
  endDate?: string;
};
export type PostContractsByIdSignaturesApiResponse = /** status 200 Success */ undefined;
export type PostContractsByIdSignaturesApiArg = {
  id: string;
  body: CreateContractSignaturePayload;
};
export type DeleteContractsByIdSignaturesApiResponse = /** status 200 Success */ undefined;
export type DeleteContractsByIdSignaturesApiArg = {
  id: string;
  body: string[];
};
export type PutContractsByIdSignaturesApiResponse = /** status 200 Success */ undefined;
export type PutContractsByIdSignaturesApiArg = {
  id: string;
  body: SetContractSignaturePayload[];
};
export type GetDataPortfolioApiResponse = /** status 200 Success */ undefined;
export type GetDataPortfolioApiArg = void;
export type PostDataPortfolioApiResponse = /** status 200 Success */ PortfolioImpactedCountModel;
export type PostDataPortfolioApiArg = {
  body: {
    payload?: Blob;
  };
};
export type PostDataPortfolioValidateApiResponse = /** status 200 Success */ PortfolioImpactedCountModel;
export type PostDataPortfolioValidateApiArg = {
  body: {
    payload?: Blob;
  };
};
export type PostDebugFixturesApiResponse = unknown;
export type PostDebugFixturesApiArg = void;
export type DeleteDebugConsumptionsByBuildingIdApiResponse = /** status 200 Success */ undefined;
export type DeleteDebugConsumptionsByBuildingIdApiArg = {
  buildingId: string;
  consumptionIntegration?: ConsumptionIntegration;
};
export type PostDebugConsumptionsByBuildingIdApiResponse = /** status 200 Success */ undefined;
export type PostDebugConsumptionsByBuildingIdApiArg = {
  buildingId: string;
  consumptionIntegration?: ConsumptionIntegration;
  from?: string;
  to?: string;
};
export type GetEconomySettingsChartOfAccountsApiResponse = /** status 200 Success */ ChartOfAccountsResponse;
export type GetEconomySettingsChartOfAccountsApiArg = void;
export type GetEconomySettingsOverviewApiResponse = /** status 200 Success */ EconomySettingsOverviewResponse;
export type GetEconomySettingsOverviewApiArg = void;
export type GetEconomySettingsSharedCostsApiResponse = /** status 200 Success */ SharedCostResponse[];
export type GetEconomySettingsSharedCostsApiArg = void;
export type GetEosAirQualityApiResponse = /** status 200 Success */ AirQualityResponse;
export type GetEosAirQualityApiArg = {
  from?: string;
  to?: string;
  spaceIds?: string[];
  sources?: string[];
};
export type GetEosConsumptionByDeviceApiResponse = /** status 200 Success */ ConsumptionByDeviceResponse;
export type GetEosConsumptionByDeviceApiArg = {
  from?: string;
  to?: string;
  resolution?: EosResolution;
  spaceIds?: string[];
};
export type GetEosConsumptionByEnergyCostApiResponse = /** status 200 Success */ ConsumptionByEnergyCostResponse;
export type GetEosConsumptionByEnergyCostApiArg = {
  from?: string;
  to?: string;
  spaceIds?: string[];
  sources?: string[];
};
export type GetEosConsumptionByEnergyTypeApiResponse = /** status 200 Success */ ConsumptionByEnergyTypeResponse;
export type GetEosConsumptionByEnergyTypeApiArg = {
  from?: string;
  to?: string;
  spaceIds?: string[];
  sources?: string[];
};
export type GetEosConsumptionBySourceApiResponse = /** status 200 Success */ ConsumptionBySourceResponse;
export type GetEosConsumptionBySourceApiArg = {
  from?: string;
  to?: string;
  spaceIds?: string[];
  sources?: string[];
};
export type GetEosConsumptionSpacesApiResponse = /** status 200 Success */ ConsumptionSpace[];
export type GetEosConsumptionSpacesApiArg = {
  type?: string;
  from?: string;
  to?: string;
  spaceIds?: string[];
};
export type GetEosConsumptionVsAverageApiResponse = /** status 200 Success */ ConsumptionVsAverageResponse;
export type GetEosConsumptionVsAverageApiArg = {
  from?: string;
  to?: string;
  spaceIds?: string[];
};
export type GetEosCorrelationApiResponse = /** status 200 Success */ CorrelationResponse;
export type GetEosCorrelationApiArg = {
  from?: string;
  to?: string;
  resolution?: EosResolution;
  spaceIds?: string[];
};
export type GetEosEstimatedEnergyCostApiResponse = /** status 200 Success */ EstimatedEnergyCostResponse;
export type GetEosEstimatedEnergyCostApiArg = {
  from?: string;
  to?: string;
  spaceIds?: string[];
  sources?: string[];
};
export type GetEosEstimatedEnergyCostSpacesApiResponse = /** status 200 Success */ EstimatedEnergyCostSpace[];
export type GetEosEstimatedEnergyCostSpacesApiArg = {
  type?: string;
  from?: string;
  to?: string;
  spaceIds?: string[];
};
export type GetEosTotalConsumptionApiResponse = /** status 200 Success */ TotalConsumptionResponse;
export type GetEosTotalConsumptionApiArg = {
  from?: string;
  to?: string;
  spaceIds?: string[];
  sources?: string[];
};
export type GetEosConsumptionSquareMeterApiResponse = /** status 200 Success */ ConsumptionSquareMeterResponse;
export type GetEosConsumptionSquareMeterApiArg = {
  from?: string;
  to?: string;
  spaceIds?: string[];
};
export type GetEosTotalEnergyCostApiResponse = /** status 200 Success */ TotalEnergyCostResponse;
export type GetEosTotalEnergyCostApiArg = {
  from?: string;
  to?: string;
  spaceIds?: string[];
  sources?: string[];
};
export type PostInvestmentsApiResponse = /** status 200 Success */ InvestmentReadModel;
export type PostInvestmentsApiArg = {
  body: CreateInvestmentPayload;
};
export type GetInvestmentsApiResponse = /** status 200 Success */ InvestmentReadModelOffsetPaginationResponse;
export type GetInvestmentsApiArg = {
  'spaceId.Equal'?: string;
  'spaceAncestorPath.Equal'?: string;
  'sort.Property'?: InvestmentReadModelSort;
  'sort.Order'?: SortOrder;
  'pagination.Offset'?: number;
  'pagination.Limit'?: number;
  search?: string;
};
export type DeleteInvestmentsByIdApiResponse = /** status 200 Success */ undefined;
export type DeleteInvestmentsByIdApiArg = {
  id: string;
};
export type GetInvestmentsByIdApiResponse = /** status 200 Success */ InvestmentReadModel;
export type GetInvestmentsByIdApiArg = {
  id: string;
};
export type PutInvestmentsByIdApiResponse = /** status 200 Success */ undefined;
export type PutInvestmentsByIdApiArg = {
  id: string;
  body: SetInvestmentModel;
};
export type PutInvestmentsByInvestmentIdSpacesApiResponse = /** status 200 Success */ undefined;
export type PutInvestmentsByInvestmentIdSpacesApiArg = {
  investmentId: string;
  body: SetInvestmentSpacePayload[];
};
export type GetInvoicesExportOverdueDetailsApiResponse = /** status 200 Success */ BuildingOverdueInvoicesDto[];
export type GetInvoicesExportOverdueDetailsApiArg = {
  buildingIds?: string[];
  startDate?: string;
  endDate?: string;
  orderBy?: string;
  page?: number;
  pageSize?: number;
};
export type GetInvoicesExportReceivableDetailsApiResponse = /** status 200 Success */ BuildingAccountsReceivableDto[];
export type GetInvoicesExportReceivableDetailsApiArg = {
  buildingIds?: string[];
  companyId?: string;
  startDate?: string;
  endDate?: string;
  orderBy?: string;
  page?: number;
  pageSize?: number;
};
export type PostInvoicesDashboardApiResponse = /** status 200 Success */ InvoiceDashboardDto;
export type PostInvoicesDashboardApiArg = {
  startDate?: string;
  endDate?: string;
  body: BuildingPayload;
};
export type GetInvoicesByIdDocumentApiResponse = unknown;
export type GetInvoicesByIdDocumentApiArg = {
  id: string;
};
export type GetInvoicesOverdueDetailsApiResponse = /** status 200 Success */ BuildingOverdueInvoicesDtoPagedListDto;
export type GetInvoicesOverdueDetailsApiArg = {
  buildingIds?: string[];
  startDate?: string;
  endDate?: string;
  orderBy?: string;
  page?: number;
  pageSize?: number;
};
export type GetInvoicesOverdueSummaryApiResponse = /** status 200 Success */ OverdueSummaryDto;
export type GetInvoicesOverdueSummaryApiArg = void;
export type GetInvoicesReceivableDetailsApiResponse =
  /** status 200 Success */ BuildingAccountsReceivableDtoPagedListDto;
export type GetInvoicesReceivableDetailsApiArg = {
  buildingIds?: string[];
  companyId?: string;
  startDate?: string;
  endDate?: string;
  orderBy?: string;
  page?: number;
  pageSize?: number;
};
export type GetInvoicesReceivablesSummaryApiResponse = /** status 200 Success */ ReceivableSummaryDto;
export type GetInvoicesReceivablesSummaryApiArg = {
  startDate?: string;
  endDate?: string;
};
export type GetKpiApiResponse = /** status 200 Success */ KpiDto;
export type GetKpiApiArg = {
  year?: number;
  month?: number;
};
export type GetLegalPersonsByIdApiResponse = /** status 200 Success */ LegalPersonReadModel;
export type GetLegalPersonsByIdApiArg = {
  id: string;
};
export type GetLegalPersonsApiResponse = /** status 200 Success */ LegalPersonReadModelOffsetPaginationResponse;
export type GetLegalPersonsApiArg = {
  'sort.Property'?: LegalPersonReadModelSort;
  'sort.Order'?: SortOrder;
  'pagination.Offset'?: number;
  'pagination.Limit'?: number;
  search?: string;
};
export type PostLegalPersonsByLegalPersonIdRepresentativesApiResponse = /** status 200 Success */ undefined;
export type PostLegalPersonsByLegalPersonIdRepresentativesApiArg = {
  legalPersonId: string;
  body: string;
};
export type GetLegalPersonsByLegalPersonIdRepresentativesApiResponse =
  /** status 200 Success */ LegalPersonRepresentativeReadModelOffsetPaginationResponse;
export type GetLegalPersonsByLegalPersonIdRepresentativesApiArg = {
  legalPersonId: string;
  'sort.Property'?: PersonReadModelSort;
  'sort.Order'?: SortOrder;
  'pagination.Offset'?: number;
  'pagination.Limit'?: number;
  search?: string;
};
export type DeleteLegalPersonsByLegalPersonIdRepresentativesAndRepresentativeIdApiResponse =
  /** status 200 Success */ undefined;
export type DeleteLegalPersonsByLegalPersonIdRepresentativesAndRepresentativeIdApiArg = {
  legalPersonId: string;
  representativeId: string;
};
export type GetMeterDataApiResponse = /** status 200 Success */ MeterDataReadModelOffsetPaginationResponse;
export type GetMeterDataApiArg = {
  'meterId.Equal'?: string;
  'resolution.Equal'?: Resolution;
  'rollup.Equal'?: Rollup;
  'interval.Equal.Start'?: string;
  'interval.Equal.End'?: string;
  'pagination.Offset'?: number;
  'pagination.Limit'?: number;
  search?: string;
};
export type GetMetersApiResponse = /** status 200 Success */ MeterReadModelOffsetPaginationResponse;
export type GetMetersApiArg = {
  'spaceId.Equal'?: string;
  'measureType.Equal'?: MeasureType;
  'energyCarrier.Equal'?: EnergyCarrier;
  'pagination.Offset'?: number;
  'pagination.Limit'?: number;
  search?: string;
};
export type GetOccupancyRatesExportDetailsApiResponse = /** status 200 Success */ OccupancyRatesDetailDto[];
export type GetOccupancyRatesExportDetailsApiArg = {
  startDate?: string;
  endDate?: string;
  orderBy?: string;
  page?: number;
  pageSize?: number;
};
export type PostOccupancyRatesDashboardApiResponse = /** status 200 Success */ OccupancyRateDashboardDto;
export type PostOccupancyRatesDashboardApiArg = {
  startDate?: string;
  endDate?: string;
  body: BuildingPayload;
};
export type GetOccupancyRatesDetailsApiResponse = /** status 200 Success */ OccupancyRatesDetailDtoPagedListDto;
export type GetOccupancyRatesDetailsApiArg = {
  startDate?: string;
  endDate?: string;
  orderBy?: string;
  page?: number;
  pageSize?: number;
};
export type GetOccupancyRatesSummaryApiResponse = /** status 200 Success */ OccupancyRatesSummaryDto;
export type GetOccupancyRatesSummaryApiArg = {
  startDate?: string;
  endDate?: string;
};
export type GetOrganizationsApiResponse = /** status 200 Success */ OrganizationReadModelOffsetPaginationResponse;
export type GetOrganizationsApiArg = {
  'parentId.Equal'?: string;
  'sort.Property'?: OrganizationReadModelSort;
  'sort.Order'?: SortOrder;
  'pagination.Offset'?: number;
  'pagination.Limit'?: number;
  search?: string;
};
export type PutOrganizationsByOrganizationIdChildrenApiResponse = /** status 200 Success */ OrganizationReadModel[];
export type PutOrganizationsByOrganizationIdChildrenApiArg = {
  organizationId: string;
  body: string[];
};
export type PostOrganizationsByOrganizationIdPersonsApiResponse = /** status 200 Success */ undefined;
export type PostOrganizationsByOrganizationIdPersonsApiArg = {
  organizationId: string;
  body: string;
};
export type GetOrganizationsByOrganizationIdPersonsApiResponse =
  /** status 200 Success */ OrganizationPersonReadModelOffsetPaginationResponse;
export type GetOrganizationsByOrganizationIdPersonsApiArg = {
  organizationId: string;
  'sort.Property'?: PersonReadModelSort;
  'sort.Order'?: SortOrder;
  'pagination.Offset'?: number;
  'pagination.Limit'?: number;
  search?: string;
};
export type PutOrganizationsByOrganizationIdPersonsApiResponse = /** status 200 Success */ undefined;
export type PutOrganizationsByOrganizationIdPersonsApiArg = {
  organizationId: string;
  body: SetOrganizationPersonsPayload[];
};
export type DeleteOrganizationsByOrganizationIdPersonsAndPersonIdApiResponse = /** status 200 Success */ undefined;
export type DeleteOrganizationsByOrganizationIdPersonsAndPersonIdApiArg = {
  organizationId: string;
  personId: string;
};
export type PostParkingSpotsApiResponse = /** status 200 Success */ ParkingSpotReadModel;
export type PostParkingSpotsApiArg = {
  body: CreateParkingSpotPayload;
};
export type GetParkingSpotsApiResponse = /** status 200 Success */ ParkingSpotReadModelOffsetPaginationResponse;
export type GetParkingSpotsApiArg = {
  'parentId.Equal'?: string;
  'rootId.Equal'?: string;
  'ancestorPath.Equal'?: string;
  'discriminator.Contains'?: SpaceDiscriminator[];
  'usageType.Contains'?: UsageType[];
  'standard.Contains'?: StandardType[];
  'totalAreaMetric.From'?: number;
  'totalAreaMetric.To'?: number;
  'available.Equal.Start'?: string;
  'available.Equal.End'?: string;
  'vacant.Equal.Start'?: string;
  'vacant.Equal.End'?: string;
  'hasRent.Equal'?: boolean;
  'bedroomCount.From'?: number;
  'bedroomCount.To'?: number;
  'bathroomCount.From'?: number;
  'bathroomCount.To'?: number;
  'tags.Contains'?: string[];
  'requiredPackage.Equal'?: PackageType;
  'sort.Property'?: SpaceReadModelSort;
  'sort.Order'?: SortOrder;
  'pagination.Offset'?: number;
  'pagination.Limit'?: number;
  search?: string;
};
export type GetParkingSpotsByIdApiResponse = /** status 200 Success */ ParkingSpotReadModel;
export type GetParkingSpotsByIdApiArg = {
  id: string;
};
export type PutParkingSpotsByIdApiResponse = /** status 200 Success */ undefined;
export type PutParkingSpotsByIdApiArg = {
  id: string;
  body: UpdateParkingSpotPayload;
};
export type PostPersonsApiResponse = /** status 200 Success */ PersonReadModel;
export type PostPersonsApiArg = {
  body: CreatePersonModel;
};
export type GetPersonsApiResponse = /** status 200 Success */ PersonReadModelOffsetPaginationResponse;
export type GetPersonsApiArg = {
  'sort.Property'?: PersonReadModelSort;
  'sort.Order'?: SortOrder;
  'pagination.Offset'?: number;
  'pagination.Limit'?: number;
  search?: string;
};
export type DeletePersonsByIdApiResponse = /** status 200 Success */ undefined;
export type DeletePersonsByIdApiArg = {
  id: string;
};
export type GetPersonsByIdApiResponse = /** status 200 Success */ PersonReadModel;
export type GetPersonsByIdApiArg = {
  id: string;
};
export type PutPersonsByIdApiResponse = /** status 200 Success */ undefined;
export type PutPersonsByIdApiArg = {
  id: string;
  body: UpdatePersonModel;
};
export type DeletePersonsInviteByInvitationIdApiResponse = /** status 204 No Content */ undefined;
export type DeletePersonsInviteByInvitationIdApiArg = {
  invitationId: string;
};
export type PutPersonsAdminInviteApiResponse = /** status 200 Success */ undefined;
export type PutPersonsAdminInviteApiArg = {
  body: InviteClientAdmin;
};
export type PutPersonsCompanyUserInviteApiResponse = /** status 200 Success */ undefined;
export type PutPersonsCompanyUserInviteApiArg = {
  body: InviteCompanyUser;
};
export type PutPersonsByIdInviteApiResponse = /** status 200 Success */ undefined;
export type PutPersonsByIdInviteApiArg = {
  id: string;
};
export type PutPersonsTenantUserInviteApiResponse = /** status 200 Success */ undefined;
export type PutPersonsTenantUserInviteApiArg = {
  body: InviteTenantUser;
};
export type PutPersonsUserInviteApiResponse = /** status 200 Success */ undefined;
export type PutPersonsUserInviteApiArg = {
  body: InviteUser;
};
export type PostPersonsByIdReactivateApiResponse = /** status 200 Success */ undefined;
export type PostPersonsByIdReactivateApiArg = {
  id: string;
};
export type PostPersonsInviteByInvitationIdResendApiResponse = /** status 200 Success */ undefined;
export type PostPersonsInviteByInvitationIdResendApiArg = {
  invitationId: string;
};
export type CompletePortfolioOnboardingApiResponse = /** status 200 Success */ CompletePortfolioOnboardingResponse;
export type CompletePortfolioOnboardingApiArg = {
  body: CompletePortfolioOnboardingPayload;
};
export type CreatePortfolioOnboardingInvitationApiResponse =
  /** status 200 Success */ CreatePortfolioOnboardingInvitationResponse;
export type CreatePortfolioOnboardingInvitationApiArg = {
  body: CreatePortfolioOnboardingInvitationPayload;
};
export type GetCompaniesAtAddressApiResponse = /** status 200 Success */ CompaniesAtAddressResponse;
export type GetCompaniesAtAddressApiArg = {
  postalCode?: string;
  address?: string;
};
export type GetPendingPortfolioInvitationApiResponse = /** status 200 Success */ GetPendingInvitationResponse;
export type GetPendingPortfolioInvitationApiArg = void;
export type SearchBuildingsApiResponse = /** status 200 Success */ SearchBuildingsResponse;
export type SearchBuildingsApiArg = {
  query?: string;
  searchType?: string;
};
export type GetPricesByIdApiResponse = /** status 200 Success */ PriceReadModel;
export type GetPricesByIdApiArg = {
  id: string;
};
export type GetPricesApiResponse = /** status 200 Success */ PriceReadModelOffsetPaginationResponse;
export type GetPricesApiArg = {
  'productId.Equal'?: string;
  'recurring.Equal'?: boolean;
  'sort.Property'?: PriceReadModelSort;
  'sort.Order'?: SortOrder;
  'pagination.Offset'?: number;
  'pagination.Limit'?: number;
  search?: string;
};
export type PostProductsApiResponse = /** status 200 Success */ ProductReadModel;
export type PostProductsApiArg = {
  body: CreateProductWithPricesPayload;
};
export type GetProductsApiResponse = /** status 200 Success */ ProductReadModelOffsetPaginationResponse;
export type GetProductsApiArg = {
  'sort.Property'?: ProductReadModelSort;
  'sort.Order'?: SortOrder;
  'pagination.Offset'?: number;
  'pagination.Limit'?: number;
  search?: string;
};
export type PostProductsByIdChildrenApiResponse = /** status 200 Success */ ProductReadModel;
export type PostProductsByIdChildrenApiArg = {
  id: string;
  body: CreateSubProductPayload;
};
export type GetProductsByIdChildrenApiResponse = /** status 200 Success */ SubProductReadModel[];
export type GetProductsByIdChildrenApiArg = {
  id: string;
};
export type DeleteProductsByIdApiResponse = /** status 200 Success */ undefined;
export type DeleteProductsByIdApiArg = {
  id: string;
};
export type GetProductsByIdApiResponse = /** status 200 Success */ ProductReadModel;
export type GetProductsByIdApiArg = {
  id: string;
};
export type PutProductsByIdApiResponse = /** status 200 Success */ undefined;
export type PutProductsByIdApiArg = {
  id: string;
  body: UpdateProductPayload;
};
export type DeleteProductsByIdChildrenAndChildIdApiResponse = /** status 200 Success */ undefined;
export type DeleteProductsByIdChildrenAndChildIdApiArg = {
  id: string;
  childId: string;
};
export type PutProductsByIdChildrenAndChildIdApiResponse = /** status 200 Success */ undefined;
export type PutProductsByIdChildrenAndChildIdApiArg = {
  id: string;
  childId: string;
  body: UpdateSubProductPayload;
};
export type GetProductsSubProductTemplatesApiResponse = /** status 200 Success */ SubProductCategoryTemplateReadModel[];
export type GetProductsSubProductTemplatesApiArg = {
  countryCode?: string;
};
export type GetProductsTripletexApiResponse = /** status 200 Success */ TripletexProductDto[];
export type GetProductsTripletexApiArg = void;
export type GetRentalIncomesExportDetailsApiResponse = /** status 200 Success */ BuildingIncomeData[];
export type GetRentalIncomesExportDetailsApiArg = {
  startDate?: string;
  endDate?: string;
  orderBy?: string;
  page?: number;
  pageSize?: number;
};
export type PostRentalIncomesDashboardApiResponse = /** status 200 Success */ RentalIncomeDashboardDto;
export type PostRentalIncomesDashboardApiArg = {
  startDate?: string;
  endDate?: string;
  companyId?: string;
  body: BuildingPayload;
};
export type GetRentalIncomesDetailsApiResponse = /** status 200 Success */ BuildingIncomeDataPagedListDto;
export type GetRentalIncomesDetailsApiArg = {
  startDate?: string;
  endDate?: string;
  orderBy?: string;
  page?: number;
  pageSize?: number;
};
export type GetRentalIncomesSummaryApiResponse = /** status 200 Success */ RentalIncomeSummaryReportReadModel;
export type GetRentalIncomesSummaryApiArg = {
  startDate?: string;
  endDate?: string;
};
export type GetReportingFinancingApiResponse = /** status 200 Success */ FinancingReadModel;
export type GetReportingFinancingApiArg = {
  startDate?: string;
  endDate?: string;
};
export type GetReportingPortfolioDiversificationApiResponse =
  /** status 200 Success */ PortfolioDiversificationReadModel;
export type GetReportingPortfolioDiversificationApiArg = {
  startDate?: string;
  endDate?: string;
};
export type GetReportingPortfolioOverviewApiResponse = /** status 200 Success */ PortfolioOverviewReadModel;
export type GetReportingPortfolioOverviewApiArg = {
  startDate?: string;
  endDate?: string;
};
export type GetResidentialUnitsByIdApiResponse = /** status 200 Success */ SpaceReadModel;
export type GetResidentialUnitsByIdApiArg = {
  id: string;
};
export type GetResidentialUnitsApiResponse = /** status 200 Success */ SpaceReadModelOffsetPaginationResponse;
export type GetResidentialUnitsApiArg = {
  'parentId.Equal'?: string;
  'rootId.Equal'?: string;
  'ancestorPath.Equal'?: string;
  'discriminator.Contains'?: SpaceDiscriminator[];
  'usageType.Contains'?: UsageType[];
  'standard.Contains'?: StandardType[];
  'totalAreaMetric.From'?: number;
  'totalAreaMetric.To'?: number;
  'available.Equal.Start'?: string;
  'available.Equal.End'?: string;
  'vacant.Equal.Start'?: string;
  'vacant.Equal.End'?: string;
  'hasRent.Equal'?: boolean;
  'bedroomCount.From'?: number;
  'bedroomCount.To'?: number;
  'bathroomCount.From'?: number;
  'bathroomCount.To'?: number;
  'tags.Contains'?: string[];
  'requiredPackage.Equal'?: PackageType;
  'sort.Property'?: SpaceReadModelSort;
  'sort.Order'?: SortOrder;
  'pagination.Offset'?: number;
  'pagination.Limit'?: number;
  search?: string;
};
export type PutResidentialUnitsByIdRoomsApiResponse = /** status 200 Success */ undefined;
export type PutResidentialUnitsByIdRoomsApiArg = {
  id: string;
  body: SetRoomPayload[];
};
export type PostRoomsApiResponse = /** status 200 Success */ RoomReadModel;
export type PostRoomsApiArg = {
  body: CreateRoomPayload;
};
export type GetRoomsApiResponse = /** status 200 Success */ RoomReadModelOffsetPaginationResponse;
export type GetRoomsApiArg = {
  'parentId.Equal'?: string;
  'rootId.Equal'?: string;
  'ancestorPath.Equal'?: string;
  'discriminator.Contains'?: SpaceDiscriminator[];
  'usageType.Contains'?: UsageType[];
  'standard.Contains'?: StandardType[];
  'totalAreaMetric.From'?: number;
  'totalAreaMetric.To'?: number;
  'available.Equal.Start'?: string;
  'available.Equal.End'?: string;
  'vacant.Equal.Start'?: string;
  'vacant.Equal.End'?: string;
  'hasRent.Equal'?: boolean;
  'bedroomCount.From'?: number;
  'bedroomCount.To'?: number;
  'bathroomCount.From'?: number;
  'bathroomCount.To'?: number;
  'tags.Contains'?: string[];
  'requiredPackage.Equal'?: PackageType;
  'sort.Property'?: SpaceReadModelSort;
  'sort.Order'?: SortOrder;
  'pagination.Offset'?: number;
  'pagination.Limit'?: number;
  search?: string;
};
export type GetRoomsByIdApiResponse = /** status 200 Success */ RoomReadModel;
export type GetRoomsByIdApiArg = {
  id: string;
};
export type PutRoomsByIdApiResponse = /** status 200 Success */ undefined;
export type PutRoomsByIdApiArg = {
  id: string;
  body: UpdateRoomPayload;
};
export type GetSourcesAddressesFilterApiResponse = /** status 200 Success */ AddressValue[];
export type GetSourcesAddressesFilterApiArg = {
  streetName?: string;
  streetNumber?: string;
  zipCode?: string;
  zipPlace?: string;
  countryThreeLetterCode?: string;
};
export type GetSourcesBuildingsByIntegrationAndIdentifierApiResponse = /** status 200 Success */ BuildingInformation;
export type GetSourcesBuildingsByIntegrationAndIdentifierApiArg = {
  integration: AddressSource;
  identifier: string;
};
export type GetSourcesAddressesSearchApiResponse = /** status 200 Success */ AddressValue[];
export type GetSourcesAddressesSearchApiArg = {
  query?: string;
};
export type PostSpacesByIdLoansApiResponse = /** status 201 Created */ string;
export type PostSpacesByIdLoansApiArg = {
  id: string;
  body: LoanPayload;
};
export type GetSpacesByIdLoansApiResponse = /** status 200 Success */ LoanReadModel[];
export type GetSpacesByIdLoansApiArg = {
  id: string;
};
export type PostSpacesByIdPortfolioTenantsApiResponse = /** status 201 Created */ string;
export type PostSpacesByIdPortfolioTenantsApiArg = {
  id: string;
  body: PortfolioTenantPayload;
};
export type GetSpacesByIdPortfolioTenantsApiResponse = /** status 200 Success */ PortfolioTenantReadModel[];
export type GetSpacesByIdPortfolioTenantsApiArg = {
  id: string;
};
export type PostSpacesApiResponse = /** status 200 Success */ SpaceReadModel;
export type PostSpacesApiArg = {
  body: CreateSpacePayload;
};
export type GetSpacesApiResponse = /** status 200 Success */ SpaceReadModelOffsetPaginationResponse;
export type GetSpacesApiArg = {
  'parentId.Equal'?: string;
  'rootId.Equal'?: string;
  'ancestorPath.Equal'?: string;
  'discriminator.Contains'?: SpaceDiscriminator[];
  'usageType.Contains'?: UsageType[];
  'standard.Contains'?: StandardType[];
  'totalAreaMetric.From'?: number;
  'totalAreaMetric.To'?: number;
  'available.Equal.Start'?: string;
  'available.Equal.End'?: string;
  'vacant.Equal.Start'?: string;
  'vacant.Equal.End'?: string;
  'hasRent.Equal'?: boolean;
  'bedroomCount.From'?: number;
  'bedroomCount.To'?: number;
  'bathroomCount.From'?: number;
  'bathroomCount.To'?: number;
  'tags.Contains'?: string[];
  'requiredPackage.Equal'?: PackageType;
  'sort.Property'?: SpaceReadModelSort;
  'sort.Order'?: SortOrder;
  'pagination.Offset'?: number;
  'pagination.Limit'?: number;
  search?: string;
};
export type PostSpacesByIdOccupanciesApiResponse = /** status 201 Created */ string;
export type PostSpacesByIdOccupanciesApiArg = {
  id: string;
  body: SpaceOccupancyPayload;
};
export type GetSpacesByIdOccupanciesApiResponse = /** status 200 Success */ SpaceOccupancyRegisterReadModel;
export type GetSpacesByIdOccupanciesApiArg = {
  id: string;
};
export type DeleteSpacesByIdBudgetsAndYearApiResponse = /** status 204 No Content */ undefined;
export type DeleteSpacesByIdBudgetsAndYearApiArg = {
  id: string;
  year: number;
};
export type GetSpacesByIdBudgetsAndYearApiResponse = /** status 200 Success */ BudgetReadModel;
export type GetSpacesByIdBudgetsAndYearApiArg = {
  id: string;
  year: number;
};
export type PutSpacesByIdBudgetsAndYearApiResponse = /** status 200 Success */ string;
export type PutSpacesByIdBudgetsAndYearApiArg = {
  id: string;
  year: number;
  body: BudgetPayload;
};
export type DeleteSpacesByIdLoansAndLoanIdApiResponse = /** status 204 No Content */ undefined;
export type DeleteSpacesByIdLoansAndLoanIdApiArg = {
  id: string;
  loanId: string;
};
export type PutSpacesByIdLoansAndLoanIdApiResponse = /** status 204 No Content */ undefined;
export type PutSpacesByIdLoansAndLoanIdApiArg = {
  id: string;
  loanId: string;
  body: LoanPayload;
};
export type DeleteSpacesByIdPortfolioTenantsAndTenantIdApiResponse = /** status 204 No Content */ undefined;
export type DeleteSpacesByIdPortfolioTenantsAndTenantIdApiArg = {
  id: string;
  tenantId: string;
};
export type PutSpacesByIdPortfolioTenantsAndTenantIdApiResponse = /** status 204 No Content */ undefined;
export type PutSpacesByIdPortfolioTenantsAndTenantIdApiArg = {
  id: string;
  tenantId: string;
  body: PortfolioTenantPayload;
};
export type DeleteSpacesByIdApiResponse = /** status 200 Success */ undefined;
export type DeleteSpacesByIdApiArg = {
  id: string;
};
export type GetSpacesByIdApiResponse = /** status 200 Success */ SpaceReadModel;
export type GetSpacesByIdApiArg = {
  id: string;
};
export type PutSpacesByIdApiResponse = /** status 200 Success */ undefined;
export type PutSpacesByIdApiArg = {
  id: string;
  body: UpdateSpacePayload;
};
export type DeleteSpacesByIdOccupanciesAndOccupancyIdApiResponse = /** status 204 No Content */ undefined;
export type DeleteSpacesByIdOccupanciesAndOccupancyIdApiArg = {
  id: string;
  occupancyId: string;
};
export type PutSpacesByIdOccupanciesAndOccupancyIdApiResponse = /** status 204 No Content */ undefined;
export type PutSpacesByIdOccupanciesAndOccupancyIdApiArg = {
  id: string;
  occupancyId: string;
  body: SpaceOccupancyPayload;
};
export type GetSpacesByIdFinancialReportsApiResponse = /** status 200 Success */ FinancialReportSummary[];
export type GetSpacesByIdFinancialReportsApiArg = {
  id: string;
};
export type PostSpacesByIdFinancialReportsAndYearApiResponse = /** status 200 Success */ FinancialReportUploadResult;
export type PostSpacesByIdFinancialReportsAndYearApiArg = {
  id: string;
  year: number;
  quarter?: number;
  accumulated?: boolean;
  body: {
    File?: Blob;
    ErpSystem?: ErpSystem;
    MonthsCovered?: number;
  };
};
export type DeleteSpacesByIdFinancialReportsAndYearApiResponse = /** status 204 No Content */ undefined;
export type DeleteSpacesByIdFinancialReportsAndYearApiArg = {
  id: string;
  year: number;
  quarter?: number;
};
export type GetSpacesByIdFinancialReportsAndYearFileApiResponse = /** status 200 Success */ undefined;
export type GetSpacesByIdFinancialReportsAndYearFileApiArg = {
  id: string;
  year: number;
  quarter?: number;
};
export type GetSpacesByIdBudgetsApiResponse = /** status 200 Success */ BudgetReadModel[];
export type GetSpacesByIdBudgetsApiArg = {
  id: string;
};
export type GetSpacesByIdConsumptionApiResponse = /** status 200 Success */ ConsumptionData[];
export type GetSpacesByIdConsumptionApiArg = {
  id: string;
  tenantId?: string;
  resolution?: Resolution;
  rollup?: Rollup;
  'interval.Start'?: string;
  'interval.End'?: string;
};
export type GetSpacesByIdConsumptionEnergyApiResponse = /** status 200 Success */ EnergyConsumptionData[];
export type GetSpacesByIdConsumptionEnergyApiArg = {
  id: string;
  tenantId?: string;
  resolution?: Resolution;
  rollup?: Rollup;
  'interval.Start'?: string;
  'interval.End'?: string;
};
export type GetSpacesByIdConsumptionOccupancyApiResponse = /** status 200 Success */ OccupancyConsumptionData[];
export type GetSpacesByIdConsumptionOccupancyApiArg = {
  id: string;
  tenantId?: string;
  resolution?: Resolution;
  rollup?: Rollup;
  'interval.Start'?: string;
  'interval.End'?: string;
};
export type GetSpacesByIdConsumptionTenantsApiResponse = /** status 200 Success */ TenantConsumptionData[];
export type GetSpacesByIdConsumptionTenantsApiArg = {
  id: string;
  tenantId?: string;
  resolution?: Resolution;
  rollup?: Rollup;
  'interval.Start'?: string;
  'interval.End'?: string;
};
export type GetSpacesByIdPortfolioFinancialsApiResponse = /** status 200 Success */ PortfolioFinancialsReadModel;
export type GetSpacesByIdPortfolioFinancialsApiArg = {
  id: string;
};
export type PutSpacesByIdPortfolioFinancialsApiResponse = /** status 204 No Content */ undefined;
export type PutSpacesByIdPortfolioFinancialsApiArg = {
  id: string;
  body: PortfolioFinancialsPayload;
};
export type GetSpacesByIdAreaChangesApiResponse = /** status 200 Success */ SpaceAreaChangeReadModel[];
export type GetSpacesByIdAreaChangesApiArg = {
  id: string;
};
export type GetSpacesByBuildingIdAssociationMatrixApiResponse =
  /** status 200 Success */ SpaceAssociationMatrixReadModel;
export type GetSpacesByBuildingIdAssociationMatrixApiArg = {
  buildingId: string;
};
export type PutSpacesByBuildingIdAssociationMatrixApiResponse = /** status 204 No Content */ undefined;
export type PutSpacesByBuildingIdAssociationMatrixApiArg = {
  buildingId: string;
  body: SetSpaceAssociationMatrixRequest;
};
export type GetSpacesByIdAssociationsApiResponse = /** status 200 Success */ SpaceReadModel[];
export type GetSpacesByIdAssociationsApiArg = {
  id: string;
};
export type PutSpacesByIdAssociationsApiResponse = /** status 204 No Content */ undefined;
export type PutSpacesByIdAssociationsApiArg = {
  id: string;
  body: string[];
};
export type GetSpacesByIdHierarchyApiResponse = /** status 200 Success */ SpaceHierarchyReadModel;
export type GetSpacesByIdHierarchyApiArg = {
  id: string;
};
export type PutSpacesByIdAreaChangesAndChangeIdTagApiResponse = /** status 204 No Content */ undefined;
export type PutSpacesByIdAreaChangesAndChangeIdTagApiArg = {
  id: string;
  changeId: string;
  body: SetSpaceAreaChangeTagPayload;
};
export type PutSpacesByIdChildrenApiResponse = /** status 200 Success */ undefined;
export type PutSpacesByIdChildrenApiArg = {
  id: string;
  body: SetSpaceChildrenPayload;
};
export type PutSpacesByIdTagsApiResponse = /** status 204 No Content */ undefined;
export type PutSpacesByIdTagsApiArg = {
  id: string;
  body: string[];
};
export type PutSpacesByIdInvestorApiResponse = /** status 200 Success */ undefined;
export type PutSpacesByIdInvestorApiArg = {
  id: string;
  body: UpdateSpaceInvestorPayload;
};
export type PutSpacesByIdManagerApiResponse = /** status 200 Success */ undefined;
export type PutSpacesByIdManagerApiArg = {
  id: string;
  body: UpdateSpaceManagerPayload;
};
export type PutSpacesByIdOwnerApiResponse = /** status 200 Success */ undefined;
export type PutSpacesByIdOwnerApiArg = {
  id: string;
  body: UpdateSpaceOwnerPayload;
};
export type PutSpacesByIdFinancialsApiResponse = /** status 204 No Content */ undefined;
export type PutSpacesByIdFinancialsApiArg = {
  id: string;
  body: SpaceFinancialsPayload;
};
export type PostSpacesByIdPortfolioFinancialsValuationReportsApiResponse =
  /** status 200 Success */ ValuationReportReadModel;
export type PostSpacesByIdPortfolioFinancialsValuationReportsApiArg = {
  id: string;
  body: {
    File?: Blob;
  };
};
export type GetSpacesByIdPortfolioFinancialsValuationReportsAndReportIdApiResponse =
  /** status 200 Success */ undefined;
export type GetSpacesByIdPortfolioFinancialsValuationReportsAndReportIdApiArg = {
  id: string;
  reportId: string;
};
export type DeleteSpacesByIdPortfolioFinancialsValuationReportsAndReportIdApiResponse =
  /** status 204 No Content */ undefined;
export type DeleteSpacesByIdPortfolioFinancialsValuationReportsAndReportIdApiArg = {
  id: string;
  reportId: string;
};
export type GetSpacesStakeholdersApiResponse = /** status 200 Success */ TenantReadModelOffsetPaginationResponse;
export type GetSpacesStakeholdersApiArg = {
  'pagination.Offset'?: number;
  'pagination.Limit'?: number;
  search?: string;
};
export type PostSpacesBySpaceIdFilesApiResponse = /** status 200 Success */ SpaceFileReadModel;
export type PostSpacesBySpaceIdFilesApiArg = {
  spaceId: string;
  body: {
    File?: Blob;
  };
};
export type GetSpacesBySpaceIdFilesApiResponse = /** status 200 Success */ SpaceFileReadModelOffsetPaginationResponse;
export type GetSpacesBySpaceIdFilesApiArg = {
  spaceId: string;
  'spaceId.Equal'?: string;
  'pagination.Offset'?: number;
  'pagination.Limit'?: number;
  search?: string;
};
export type DeleteSpacesBySpaceIdFilesAndFileIdApiResponse = /** status 200 Success */ undefined;
export type DeleteSpacesBySpaceIdFilesAndFileIdApiArg = {
  spaceId: string;
  fileId: string;
};
export type GetStatisticsNetYieldBuildingsExportApiResponse =
  /** status 200 Success */ NetYieldBuildingDetailReadModel[];
export type GetStatisticsNetYieldBuildingsExportApiArg = {
  startDate?: string;
  endDate?: string;
};
export type GetStatisticsCitiesVacancyApiResponse = /** status 200 Success */ CityVacancyReport[];
export type GetStatisticsCitiesVacancyApiArg = {
  sortOrder?: SortOrder;
};
export type GetStatisticsSpacesEndingContractApiResponse =
  /** status 200 Success */ EndingContractReportReadModelOffsetPaginationResponse;
export type GetStatisticsSpacesEndingContractApiArg = {
  endingBy?: string;
  offset?: number;
  limit?: number;
};
export type GetStatisticsNetYieldBuildingsByIdApiResponse = /** status 200 Success */ NetYieldBuildingDetailReadModel;
export type GetStatisticsNetYieldBuildingsByIdApiArg = {
  id: string;
  startDate?: string;
  endDate?: string;
};
export type GetStatisticsNetYieldBuildingsApiResponse =
  /** status 200 Success */ NetYieldBuildingDetailReadModelPagedListDto;
export type GetStatisticsNetYieldBuildingsApiArg = {
  startDate?: string;
  endDate?: string;
  page?: number;
  pageSize?: number;
};
export type PostStatisticsNetYieldDashboardApiResponse = /** status 200 Success */ NetYieldBuildingReadModel[];
export type PostStatisticsNetYieldDashboardApiArg = {
  startDate?: string;
  endDate?: string;
  body: BuildingPayload;
};
export type GetStatisticsNetYieldApiResponse = /** status 200 Success */ NetYieldSummaryReadModel;
export type GetStatisticsNetYieldApiArg = {
  startDate?: string;
  endDate?: string;
};
export type GetStatisticsRentApiResponse = /** status 200 Success */ RentReportReadModel[];
export type GetStatisticsRentApiArg = {
  groupBy?: RentReportGroupType;
  'currencyCode.Equal'?: string;
  'countryCode.Equal'?: string;
  'zipPlace.Equal'?: string;
  'zipCode.Equal'?: string;
  'streetName.Equal'?: string;
  'streetNumber.Equal'?: string;
};
export type GetStatisticsSpacesVacancyApiResponse =
  /** status 200 Success */ VacantSpaceReportReadModelOffsetPaginationResponse;
export type GetStatisticsSpacesVacancyApiArg = {
  offset?: number;
  limit?: number;
};
export type GetStatisticsVacancyApiResponse = /** status 200 Success */ VacancyReport;
export type GetStatisticsVacancyApiArg = {
  'ancestorPath.Equal'?: string;
  'discriminator.Contains'?: SpaceDiscriminator[];
};
export type GetTagsApiResponse = /** status 200 Success */ TagReadModelOffsetPaginationResponse;
export type GetTagsApiArg = {
  'spaceId.Equal'?: string;
  'isUsed.Equal'?: boolean;
  'pagination.Offset'?: number;
  'pagination.Limit'?: number;
  search?: string;
};
export type GetTenantsCurrentCompanyApiResponse = /** status 200 Success */ CompanyReadModel;
export type GetTenantsCurrentCompanyApiArg = void;
export type GetTenantsCurrentMembersApiResponse =
  /** status 200 Success */ TenantMemberReadModelOffsetPaginationResponse;
export type GetTenantsCurrentMembersApiArg = {
  'pagination.Offset'?: number;
  'pagination.Limit'?: number;
  search?: string;
  includeInactive?: boolean;
};
export type GetTenantsByTenantIdPersonsApiResponse = /** status 200 Success */ PersonReadModel[];
export type GetTenantsByTenantIdPersonsApiArg = {
  tenantId: string;
};
export type PostUsagesApiResponse = /** status 200 Success */ UsageReadModel;
export type PostUsagesApiArg = {
  body: CreateUsagePayload;
};
export type GetUsagesApiResponse = /** status 200 Success */ UsageReadModelOffsetPaginationResponse;
export type GetUsagesApiArg = {
  'spaceId.Equal'?: string;
  'spaceAncestorPath.Equal'?: string;
  'sort.Property'?: UsageReadModelSort;
  'sort.Order'?: SortOrder;
  'pagination.Offset'?: number;
  'pagination.Limit'?: number;
  search?: string;
};
export type DeleteUsagesByIdApiResponse = /** status 200 Success */ undefined;
export type DeleteUsagesByIdApiArg = {
  id: string;
};
export type GetUsagesByIdApiResponse = /** status 200 Success */ UsageReadModel;
export type GetUsagesByIdApiArg = {
  id: string;
};
export type PutUsagesByIdApiResponse = /** status 200 Success */ undefined;
export type PutUsagesByIdApiArg = {
  id: string;
  body: SetUsageModel;
};
export type GetUserPermissionsApiResponse = /** status 200 Success */ UserPermissionsDto;
export type GetUserPermissionsApiArg = void;
export type PostUserPermissionsSpacesApiResponse = /** status 200 Success */ UserSpacePermissionsDto[];
export type PostUserPermissionsSpacesApiArg = {
  body: GetUserSpacesPermissionsRequest;
};
export type GetUserPermissionsSpacesByIdApiResponse = /** status 200 Success */ UserSpacePermissionsDto;
export type GetUserPermissionsSpacesByIdApiArg = {
  id: string;
};
export type PostUserPermissionsAgreementsApiResponse = /** status 200 Success */ UserAgreementPermissionsDto[];
export type PostUserPermissionsAgreementsApiArg = {
  body: GetUserAgreementsPermissionsRequest;
};
export type GetUserPermissionsAgreementsByIdApiResponse = /** status 200 Success */ UserAgreementPermissionsDto;
export type GetUserPermissionsAgreementsByIdApiArg = {
  id: string;
};
export type GetUserPermissionsDefinitionsApiResponse = /** status 200 Success */ PermissionDefinitionDto[];
export type GetUserPermissionsDefinitionsApiArg = void;
export type GetVacancyExportDetailsApiResponse = /** status 200 Success */ VacancyDetailsDto[];
export type GetVacancyExportDetailsApiArg = {
  startDate?: string;
  endDate?: string;
  orderBy?: string;
  page?: number;
  pageSize?: number;
};
export type PostVacancyDashboardApiResponse = /** status 200 Success */ VacancyDashboardDto;
export type PostVacancyDashboardApiArg = {
  startDate?: string;
  endDate?: string;
  body: BuildingPayload;
};
export type GetVacancyDetailsApiResponse = /** status 200 Success */ VacancyDetailsDtoPagedListDto;
export type GetVacancyDetailsApiArg = {
  startDate?: string;
  endDate?: string;
  orderBy?: string;
  page?: number;
  pageSize?: number;
};
export type GetVacancySummaryApiResponse = /** status 200 Success */ ReceivableSummaryDto;
export type GetVacancySummaryApiArg = {
  startDate?: string;
  endDate?: string;
};
export type PostWebhooksDocumentSigningApiResponse = unknown;
export type PostWebhooksDocumentSigningApiArg = {
  body: DocumentSigningEvent;
};
export type ActivityType = 'Created' | 'Updated';
export type ActivityEntity = 'Building' | 'Space' | 'Agreement';
export type ActivityReadModel = {
  type: ActivityType;
  entity: ActivityEntity;
  name: string;
  at: string;
};
export type TenantType = 'Customer' | 'Company' | 'Department';
export type CountryValue = {
  threeLetterCode: string;
  twoLetterCode?: string | null;
  name?: string | null;
};
export type CurrencyValue = {
  code: string;
  symbol?: string;
  englishName?: string;
};
export type MoneyValue = {
  amount: number;
  currency: CurrencyValue;
};
export type IntervalType = 'Month' | 'Year';
export type IntervalValue = {
  type: IntervalType;
  count: number;
};
export type InvoicingIntegration = 'Stripe' | 'Tripletex';
export type InvoicingIntegrationExternalReferenceValue = {
  integration: InvoicingIntegration;
  identifier: string;
};
export type UnitScheme = 'AreaMetric' | 'AreaImperial' | 'Custom';
export type UnitSchemeValue = {
  scheme: UnitScheme;
  label?: string | null;
};
export type ProductCategory = 'Other' | 'Leie' | 'Felleskostnader';
export type ProductReadModel = {
  id: string;
  name: string;
  description?: string | null;
  unit?: UnitSchemeValue | null;
  sourceId?: string | null;
  category: ProductCategory;
  parentProductId?: string | null;
  hasActiveAgreements?: boolean | null;
  hasAgreements?: boolean | null;
};
export type PriceReadModel = {
  id: string;
  description?: string | null;
  unitAmount: MoneyValue;
  yearlyUnitAmount?: MoneyValue | null;
  oneTimeUnitAmount?: MoneyValue | null;
  recurring: boolean;
  interval?: IntervalValue | null;
  source?: InvoicingIntegrationExternalReferenceValue | null;
  product: ProductReadModel;
};
export type TenantSettingsReadModel = {
  id: string;
  tenantId?: string;
  country?: CountryValue;
  currency?: CurrencyValue;
  price?: PriceReadModel;
};
export type ErpIntegration = 'Tripletex';
export type TenantErpIntegrationReadModel = {
  key: ErpIntegration;
  configured: boolean;
};
export type TenantReadModel = {
  id: string;
  name: string;
  type: TenantType;
  companyId?: string | null;
  settings?: TenantSettingsReadModel | null;
  erpIntegrations?: TenantErpIntegrationReadModel[] | null;
};
export type SocialSecurityNumberValue = {
  country: CountryValue;
  value: string;
};
export type CultureValue = {
  language: string;
  timezone: string;
};
export type PersonSource = 'ExcelImport';
export type PersonSourceExternalReferenceValue = {
  integration: PersonSource;
  identifier: string;
};
export type PersonReadModel = {
  id: string;
  name: string;
  vatId?: string | null;
  invoicingAccount?: InvoicingIntegrationExternalReferenceValue | null;
  firstName: string;
  lastName: string;
  email: string;
  phone?: string | null;
  socialSecurityNumber?: SocialSecurityNumberValue | null;
  culture?: CultureValue | null;
  initials: string;
  source?: PersonSourceExternalReferenceValue | null;
  role?: string | null;
};
export type Role =
  | 'Creator'
  | 'ClientDefault'
  | 'ClientAdmin'
  | 'ClientUser'
  | 'Manager'
  | 'Owner'
  | 'Tenant'
  | 'Investor'
  | 'Inherited';
export type AgreementPartyReadModel = {
  id: string;
  agreementId: string;
  stakeholder: TenantReadModel;
  representative?: PersonReadModel | null;
  type?: Role | null;
};
export type AgreementPartyReadModelOffsetPaginationResponse = {
  totalCount: number;
  offset: number;
  limit: number;
  items: AgreementPartyReadModel[];
  hasPrevious?: boolean;
  hasNext?: boolean;
};
export type AgreementStatus = 'Draft' | 'Ready' | 'Effective' | 'Terminated';
export type RelationshipType = 'Administrator' | 'Owner' | 'Broker' | 'Tenant';
export type AgreementPartyReadModelSort = 'Name';
export type SortOrder = 'Asc' | 'Desc';
export type AgreementImportSessionStatus = 'InProgress' | 'Completed' | 'Abandoned';
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export type AgreementImportRecordStatus = 'Pending' | 'NeedsReview' | 'Approved' | 'Rejected';
export type ContractRawSourceData = {
  tenantName?: string | null;
  managerName?: string | null;
  durationStartDate?: string | null;
  durationEndDate?: string | null;
  indexAdjustment?: string | null;
  indexBaseDate?: string | null;
  indexBaseValue?: string | null;
  indexInterval?: string | null;
  indexStartDate?: string | null;
  indexType?: string | null;
  invoicing?: string | null;
  optionLength?: string | null;
  notificationDeadlineMonths?: string | null;
  securityAmount?: string | null;
  securityType?: string | null;
};
export type IndexType = 'Custom' | 'NorskKPI';
export type SecurityType = 'BankDeposit' | 'BankGuarantee' | 'Cash' | 'Other';
export type ContractMappedData = {
  tenantId?: string | null;
  durationStart?: string | null;
  durationEnd?: string | null;
  isOngoing: boolean;
  indexAdjustmentValue?: number | null;
  indexAdjustmentNote?: string | null;
  indexBaseDate?: string | null;
  indexBaseValue?: number | null;
  indexIntervalCount?: number | null;
  indexIntervalType?: IntervalType | null;
  indexStartDate?: string | null;
  indexAdjustmentType?: IndexType | null;
  optionLengthCount?: number | null;
  optionLengthType?: IntervalType | null;
  notificationDeadlineMonths?: number | null;
  securityAmount?: number | null;
  securityCurrencyCode?: string | null;
  securityType?: SecurityType | null;
};
export type FieldSource = 'Interpreted' | 'Api' | 'ConfirmedAgainstExio' | 'Manual';
export type LineRawSourceData = {
  spaceName?: string | null;
  area?: string | null;
  amount?: string | null;
  unit?: string | null;
  parkingRate?: string | null;
};
export type LineMappedData = {
  overrideArea?: number | null;
  overwrittenUnitAmount?: number | null;
  parsedAmountInterval?: string | null;
  spaceId?: string | null;
  priceId?: string | null;
};
export type ContractReviewLine = {
  id: string;
  status: AgreementImportRecordStatus;
  rawSourceData: LineRawSourceData;
  mappedData: LineMappedData;
  fieldSources: {
    [key: string]: FieldSource;
  };
};
export type AgreementReadinessRuleResult = {
  rule: string;
  isSatisfied: boolean;
};
export type AgreementReadinessStatus = {
  rules: AgreementReadinessRuleResult[];
  isReady?: boolean;
  failedRules?: string[];
};
export type ContractReview = {
  id: string;
  documentId: string;
  status: AgreementImportRecordStatus;
  rawSourceData: ContractRawSourceData;
  mappedData: ContractMappedData;
  fieldSources: {
    [key: string]: FieldSource;
  };
  lines: ContractReviewLine[];
  readiness: AgreementReadinessStatus;
  hasOpenEndedDuration: boolean;
};
export type ManualContractCorrectionPayload = {
  tenantId?: string | null;
  durationStart?: string | null;
  durationEnd?: string | null;
  isOngoing?: boolean | null;
  indexAdjustmentValue?: number | null;
  indexAdjustmentNote?: string | null;
  indexBaseDate?: string | null;
  indexBaseValue?: number | null;
  indexIntervalCount?: number | null;
  indexIntervalType?: IntervalType | null;
  indexStartDate?: string | null;
  indexAdjustmentType?: IndexType | null;
  optionLengthCount?: number | null;
  optionLengthType?: IntervalType | null;
  notificationDeadlineMonths?: number | null;
  securityAmount?: number | null;
  securityCurrencyCode?: string | null;
  securityType?: SecurityType | null;
};
export type ManualLineCorrectionPayload = {
  spaceId?: string | null;
  priceId?: string | null;
  overrideArea?: number | null;
  overwrittenUnitAmount?: number | null;
};
export type CorrectAgreementImportContractPayload = {
  contract?: ManualContractCorrectionPayload | null;
  lines?: {
    [key: string]: ManualLineCorrectionPayload;
  } | null;
};
export type CreateAgreementImportSessionPayload = {
  buildingSpaceId: string;
};
export type AgreementImportSessionSummary = {
  id: string;
  status: AgreementImportSessionStatus;
  createdAt: string;
  updatedAt: string;
  contractCount: number;
  pendingCount: number;
  needsReviewCount: number;
  approvedCount: number;
  rejectedCount: number;
};
export type AgreementImportSourceRow = {
  documentId: string;
  tenantName?: string | null;
  managerName?: string | null;
  durationStartDate?: string | null;
  durationEndDate?: string | null;
  indexAdjustment?: string | null;
  indexBaseDate?: string | null;
  indexBaseValue?: string | null;
  indexInterval?: string | null;
  indexStartDate?: string | null;
  indexType?: string | null;
  invoicing?: string | null;
  optionLength?: string | null;
  notificationDeadlineMonths?: string | null;
  securityAmount?: string | null;
  securityType?: string | null;
  spaceName?: string | null;
  area?: string | null;
  amount?: string | null;
  unit?: string | null;
  parkingRate?: string | null;
};
export type DateIntervalValue = {
  start?: string;
  end?: string;
  isPast?: boolean;
  isCurrent?: boolean;
  isFuture?: boolean;
};
export type IndexValue = {
  interval: IntervalValue;
  adjustmentPerInterval: number;
  startDate: string;
  type: IndexType;
  baseIndexDate?: string | null;
  baseIndexValue?: number | null;
  currentAdjustment?: number | null;
  lastAdjustmentDate?: string | null;
};
export type SecurityValue = {
  type: SecurityType;
  amount?: MoneyValue | null;
};
export type CalendarEntryType = 'Lifespan' | 'Rentability' | 'Reservation' | 'Occupancy' | 'Renovation';
export type SpaceDiscriminator =
  | 'Generic'
  | 'Building'
  | 'ResidentialUnit'
  | 'CommercialSpace'
  | 'CommonArea'
  | 'ParkingSpot'
  | 'Room';
export type UsageType = 'Residential' | 'Commercial' | 'Mixed';
export type BaseSpaceReadModel = {
  id: string;
  discriminator: SpaceDiscriminator;
  path: string;
  name: string;
  usageType?: UsageType | null;
};
export type AddressSource = 'Norkart' | 'Nominatim' | 'Kartverket' | 'Photon';
export type AddressSourceValue = {
  integration: AddressSource;
  identifier: string;
};
export type CoordinateValue = {
  longitude: number;
  latitude: number;
};
export type AddressValue = {
  streetName: string;
  streetNumber?: string | null;
  streetAddress2?: string | null;
  zipCode: string;
  zipPlace: string;
  country: CountryValue;
  source?: AddressSourceValue | null;
  coordinate?: CoordinateValue | null;
  streetAddress1?: string;
  municipality?: string;
  formattedAddress?: string;
};
export type StandardType = 'Low' | 'Medium' | 'High';
export type AreaValue = {
  metric: number;
  imperial?: number;
};
export type AssetClass =
  | 'Office'
  | 'RetailHighStreet'
  | 'Retail'
  | 'Logistics'
  | 'Industrial'
  | 'Hotel'
  | 'Healthcare'
  | 'Education'
  | 'Mixed';
export type SpaceSource = 'Norkart' | 'Manual';
export type SpaceSourceExternalReferenceValue = {
  integration: SpaceSource;
  identifier: string;
};
export type VacancyStatus = 'Vacant' | 'VacantSoon' | 'Rented';
export type SpaceReadModel = {
  id: string;
  discriminator: SpaceDiscriminator;
  path: string;
  building?: BaseSpaceReadModel | null;
  parent?: BaseSpaceReadModel | null;
  name: string;
  address: AddressValue;
  description?: string | null;
  usageType?: UsageType | null;
  standard?: StandardType | null;
  area?: AreaValue | null;
  assetClass?: AssetClass | null;
  lifespan: DateIntervalValue;
  rentablePeriod?: DateIntervalValue | null;
  rent?: PriceReadModel | null;
  operationalCost?: PriceReadModel | null;
  source?: SpaceSourceExternalReferenceValue | null;
  status?: VacancyStatus | null;
  roomCount: {
    [key: string]: number | null;
  };
  tags: string[];
  tenantId?: string | null;
  tenantName?: string | null;
  agreementStatus?: AgreementStatus | null;
  hasActiveAgreements: boolean;
};
export type AgreementSpaceAddonReadModel = {
  id: string;
  quantity: number;
  price: PriceReadModel;
  totalAmount: MoneyValue;
  yearlyTotalAmount?: MoneyValue | null;
  oneTimeTotalAmount?: MoneyValue | null;
};
export type AgreementSpaceReadModel = {
  id: string;
  type: CalendarEntryType;
  interval: DateIntervalValue;
  price?: PriceReadModel | null;
  totalAmount?: MoneyValue | null;
  yearlyTotalAmount?: MoneyValue | null;
  oneTimeTotalAmount?: MoneyValue | null;
  overrideArea?: number | null;
  overwrittenUnitAmount?: MoneyValue | null;
  isInvoiced: boolean;
  externalOrderLineId?: number | null;
  space: SpaceReadModel;
  addons: AgreementSpaceAddonReadModel[];
  totalAddonYearlyAmount: MoneyValue;
  totalAddonOneTimeAmount: MoneyValue;
  commonAreaShare?: number | null;
  calculatedLettableArea?: number | null;
  commonAreaAddOnFactor?: number | null;
  overrideAreaAddOnFactor?: number | null;
};
export type AgreementProductReadModel = {
  id: string;
  isInvoiced: boolean;
  externalOrderLineId?: number | null;
  quantity: number;
  interval?: DateIntervalValue | null;
  overwrittenUnitAmount?: MoneyValue | null;
  overrideArea?: number | null;
  parentAgreementProductId?: string | null;
  price: PriceReadModel;
  children: AgreementProductReadModel[];
  totalAmount: MoneyValue;
  yearlyTotalAmount?: MoneyValue | null;
  yearlyTotalAmountForAgreementList?: MoneyValue | null;
  oneTimeTotalAmount?: MoneyValue | null;
};
export type FileReadModel = {
  id: string;
  author: PersonReadModel;
  name: string;
  description?: string | null;
  path: string;
  thumbnailPath?: string | null;
};
export type AgreementFileReadModel = {
  id: string;
  agreementId: string;
  file: FileReadModel;
};
export type AgreementReadModel = {
  id: string;
  name: string;
  duration: DateIntervalValue;
  status: AgreementStatus;
  effectiveAt?: string | null;
  terminatedAt?: string | null;
  terminationReason?: string | null;
  invoicingStart?: string | null;
  invoicingPeriod: IntervalValue;
  invoiceDueDate?: number | null;
  invoiceComment?: string | null;
  index?: IndexValue | null;
  security?: SecurityValue | null;
  vatInclusivePercentage?: number | null;
  departmentId?: number | null;
  optionLength?: IntervalValue | null;
  notificationDeadlineMonths?: number | null;
  terminationNoticePeriodMonths?: number | null;
  invoiceId?: string | null;
  spaces: AgreementSpaceReadModel[];
  products: AgreementProductReadModel[];
  parties: AgreementPartyReadModel[];
  files: AgreementFileReadModel[];
  totalSpaceYearlyAmount: MoneyValue;
  totalProductYearlyAmount: MoneyValue;
  totalAddonYearlyAmount: MoneyValue;
  totalSpaceOneTimeAmount: MoneyValue;
  totalProductOneTimeAmount: MoneyValue;
  totalAddonOneTimeAmount: MoneyValue;
  totalYearlyAmount: MoneyValue;
  totalYearlyAmountProRated: MoneyValue;
  totalOneTimeAmount: MoneyValue;
  totalArea: AreaValue;
  hasTripletexPendingSync: boolean;
  erpIntegration?: TenantErpIntegrationReadModel | null;
};
export type OpenDateInterval = {
  start?: string | null;
  end?: string | null;
};
export type SetPriceWithProductPayload = {
  unitAmount: MoneyValue;
  interval?: IntervalValue | null;
  description?: string | null;
  source?: InvoicingIntegrationExternalReferenceValue | null;
  id?: string | null;
  productId: string;
};
export type CreateAgreementSpacePayload = {
  spaceId: string;
  price?: SetPriceWithProductPayload | null;
};
export type CreateAgreementPayload = {
  name?: string | null;
  duration?: OpenDateInterval | null;
  invoicingStart?: string | null;
  invoicingPeriod?: IntervalValue | null;
  invoiceDueDate?: number | null;
  invoiceComment?: string | null;
  index?: IndexValue | null;
  security?: SecurityValue | null;
  status?: AgreementStatus | null;
  vatInclusivePercentage?: number | null;
  terminationReason?: string | null;
  departmentId?: number | null;
  optionLength?: IntervalValue | null;
  notificationDeadlineMonths?: number | null;
  terminationNoticePeriodMonths?: number | null;
  spaces: CreateAgreementSpacePayload[];
};
export type AgreementReadModelOffsetPaginationResponse = {
  totalCount: number;
  offset: number;
  limit: number;
  items: AgreementReadModel[];
  hasPrevious?: boolean;
  hasNext?: boolean;
};
export type AgreementReadModelSort = 'Default' | 'Status' | 'Start' | 'End' | 'TenantName' | 'Name';
export type SetAgreementModel = {
  name?: string | null;
  duration?: OpenDateInterval | null;
  invoicingStart?: string | null;
  invoicingPeriod?: IntervalValue | null;
  invoiceDueDate?: number | null;
  invoiceComment?: string | null;
  index?: IndexValue | null;
  security?: SecurityValue | null;
  status?: AgreementStatus | null;
  vatInclusivePercentage?: number | null;
  terminationReason?: string | null;
  departmentId?: number | null;
  optionLength?: IntervalValue | null;
  notificationDeadlineMonths?: number | null;
  terminationNoticePeriodMonths?: number | null;
};
export type BuildingWithAgreementSummary = {
  buildingId: string;
  buildingName?: string | null;
  buildingAddress?: string | null;
  tenantCount: number;
  agreementCount: number;
  totalAreaMetric?: number | null;
  totalYearlyAmount?: number | null;
  currency?: string | null;
};
export type BuildingsWithAgreementsResponse = {
  items: BuildingWithAgreementSummary[];
  totalCount: number;
  unassignedAgreementCount: number;
};
export type AgreementToInvoiceReadModel = {
  agreementId: string;
  agreementName: string;
  tenantName: string;
  periodFrom: string;
  periodTo: string;
  amount: MoneyValue;
};
export type AgreementToInvoiceReadModelOffsetPaginationResponse = {
  totalCount: number;
  offset: number;
  limit: number;
  items: AgreementToInvoiceReadModel[];
  hasPrevious?: boolean;
  hasNext?: boolean;
};
export type AgreementsToInvoiceReportSort = 'PeriodFrom' | 'Amount' | 'TenantName' | 'AgreementName';
export type IndexAdjustmentDto = {
  id: string;
  adjustmentDate: string;
  baseIndexValue: number;
  currentIndexValue: number;
  percentageChange: number;
  previousRent?: number | null;
  newRent?: number | null;
  isAutomatic: boolean;
  baseIndexPeriod?: string | null;
  currentIndexPeriod?: string | null;
  createdAt: string;
};
export type CreateIndexAdjustmentApiRequest = {
  adjustmentDate: string;
  baseIndexValue: number;
  currentIndexValue: number;
  percentageChange: number;
  previousRent?: number | null;
  newRent?: number | null;
  baseIndexPeriod?: string | null;
  currentIndexPeriod?: string | null;
  updateAgreement: boolean;
};
export type TenantReadModelOffsetPaginationResponse = {
  totalCount: number;
  offset: number;
  limit: number;
  items: TenantReadModel[];
  hasPrevious?: boolean;
  hasNext?: boolean;
};
export type SetAgreementSpacePayload = {
  id?: string | null;
  spaceId: string;
  priceId: string;
  overrideArea?: number | null;
  overwrittenUnitAmount?: MoneyValue | null;
};
export type CreateAgreementProductPayload = {
  priceId: string;
  quantity: number;
};
export type SetAgreementProductIntervalPayload = {
  start?: string | null;
  end?: string | null;
};
export type SetAgreementProductChildPayload = {
  id?: string | null;
  priceId: string;
  overwrittenUnitAmount?: MoneyValue | null;
};
export type SetAgreementProductPayload = {
  id?: string | null;
  priceId: string;
  quantity: number;
  interval?: SetAgreementProductIntervalPayload | null;
  overwrittenUnitAmount?: MoneyValue | null;
  overrideArea?: number | null;
  children?: SetAgreementProductChildPayload[] | null;
};
export type UpdateAgreementProductPayload = {
  quantity: number;
};
export type CreateAgreementPartyPayload = {
  legalPersonId: string;
  representativeId?: string | null;
  type: RelationshipType;
};
export type SetAgreementPartyPayload = {
  id?: string | null;
  stakeholderId: string;
  role: Role;
  representativeId?: string | null;
};
export type InvoiceHistoryItemDto = {
  id: string;
  invoiceNumber: number;
  customerName?: string | null;
  amount: number;
  amountOutstanding: number;
  isCreditNote: boolean;
  invoiceDate?: string | null;
  invoiceDueDate?: string | null;
  invoiceComment?: string | null;
};
export type AgreementFileReadModelOffsetPaginationResponse = {
  totalCount: number;
  offset: number;
  limit: number;
  items: AgreementFileReadModel[];
  hasPrevious?: boolean;
  hasNext?: boolean;
};
export type AgreementActivityType =
  | 'AgreementCreated'
  | 'AgreementUpdated'
  | 'TripletexSyncStatus'
  | 'TripletexUpdated'
  | 'TripletexOrderTerminatedFailure'
  | 'TripletexInvoiceCreatedFailure'
  | 'TripletexInvoiceUpdatedFailure'
  | 'AgreementError'
  | 'TripletexOrderCreatedFailure';
export type AgreementActivitySummary =
  | 'AgreementCreated'
  | 'AgreementSpaceUpdated'
  | 'AgreementProductUpdated'
  | 'AgreementFileRemoved'
  | 'AgreementFileCreated'
  | 'AgreementPartyUpdated'
  | 'AgreementDetailUpdated'
  | 'TripletexSyncInvoiceCreate'
  | 'TripletexSyncInvoiceUpdate'
  | 'TripletexSyncOrderTerminated'
  | 'TripletexInvoiceCreated'
  | 'TripletexOrderTerminated'
  | 'Error'
  | 'TripletexSyncOrderCreated';
export type ActivityResult = 'Success' | 'Failure' | 'InProgress' | 'PartialSuccess';
export type AgreementActivityLogDto = {
  id: string;
  logTime: string;
  company: string;
  traceId?: string | null;
  user: string;
  type: AgreementActivityType;
  summary: AgreementActivitySummary;
  changes: string[];
  erp?: InvoicingIntegration | null;
  result: ActivityResult;
};
export type AgreementActivityLogDtoPagedListDto = {
  page: number;
  pageSize: number;
  total: number;
  items: AgreementActivityLogDto[];
};
export type FinishInvitationPayload = {
  token: string;
  password: string;
  confirmPassword: string;
};
export type UserReadModel = {
  id: string;
  email: string;
  person?: PersonReadModel | null;
};
export type TenantUserRoleReadModel = {
  id: string;
  name: string;
  type: TenantType;
  companyId?: string | null;
  settings?: TenantSettingsReadModel | null;
  erpIntegrations?: TenantErpIntegrationReadModel[] | null;
  role?: Role | null;
};
export type AclModel = {
  user?: UserReadModel | null;
  allowedTenants?: TenantUserRoleReadModel[] | null;
  selectedTenant?: TenantUserRoleReadModel | null;
  isAllAllowed: boolean;
  requestedTenantId?: string | null;
};
export type BranchReadModel = {
  id: string;
  name: string;
  vatId?: string | null;
  invoicingAccount?: InvoicingIntegrationExternalReferenceValue | null;
  parentId?: string | null;
  personCount: number;
  agreementCount: number;
};
export type CreateBranchPayload = {
  organizationId: string;
  name: string;
};
export type BaseOrganizationModel = {
  name: string;
  vatId?: string | null;
  invoicingAccount?: InvoicingIntegrationExternalReferenceValue | null;
};
export type BuildingType =
  | 'DetachedHouse'
  | 'HouseWithTwoDwellings'
  | 'RowHouseThreeOrMoreDwellings'
  | 'MultiDwellingHouse'
  | 'ResidenceForCommunities'
  | 'HolidayHouse'
  | 'MountainHut'
  | 'Mall'
  | 'Industry'
  | 'IndustrialLogistics'
  | 'Warehouse'
  | 'Office'
  | 'RetailHighStreet'
  | 'Retail'
  | 'Logistics'
  | 'Industrial'
  | 'Hotel'
  | 'Healthcare'
  | 'Education'
  | 'Mixed';
export type EnergyLabel = 'A' | 'B' | 'C' | 'D' | 'E' | 'F' | 'G';
export type CadastralValue = {
  cadastralUnit?: string | null;
  propertyUnit?: string | null;
  leaseholdUnit?: string | null;
  sectionUnit?: string | null;
  constructionYear?: number | null;
};
export type AreaAggregate = {
  count: number;
  area: AreaValue;
};
export type AreaAggregateRate = {
  count?: number | null;
  area?: number | null;
};
export type VacancyReport = {
  vacant: AreaAggregate;
  rented: AreaAggregate;
  nonRentable: AreaAggregate;
  rentable?: AreaAggregate;
  total?: AreaAggregate;
  vacancyRate?: AreaAggregateRate;
};
export type DetailedVacancyReport = {
  vacant: AreaAggregate;
  rented: AreaAggregate;
  nonRentable: AreaAggregate;
  rentable?: AreaAggregate;
  vacancyRate?: AreaAggregateRate;
  defined?: AreaValue | null;
  used?: AreaValue;
  unused?: AreaValue;
  extra?: AreaValue;
  unavailable?: AreaAggregate;
  available?: AreaAggregate;
  total?: AreaAggregate;
};
export type PackageType = 'Management' | 'Eos' | 'Portfolio';
export type PackageTier = 'Basic' | 'Standard' | 'Premium';
export type BuildingPackageReadModel = {
  packageType: PackageType;
  tier?: PackageTier | null;
  isActive: boolean;
};
export type BuildingReadModel = {
  id: string;
  discriminator: SpaceDiscriminator;
  path: string;
  building?: BaseSpaceReadModel | null;
  parent?: BaseSpaceReadModel | null;
  name: string;
  address: AddressValue;
  description?: string | null;
  usageType?: UsageType | null;
  standard?: StandardType | null;
  area?: AreaValue | null;
  assetClass?: AssetClass | null;
  lifespan: DateIntervalValue;
  rentablePeriod?: DateIntervalValue | null;
  rent?: PriceReadModel | null;
  operationalCost?: PriceReadModel | null;
  source?: SpaceSourceExternalReferenceValue | null;
  status?: VacancyStatus | null;
  roomCount: {
    [key: string]: number | null;
  };
  tags: string[];
  tenantId?: string | null;
  tenantName?: string | null;
  agreementStatus?: AgreementStatus | null;
  hasActiveAgreements: boolean;
  type?: BuildingType | null;
  energyLabel?: EnergyLabel | null;
  heatingGrade?: string | null;
  cadastralInformation?: CadastralValue | null;
  buildingNumber?: string | null;
  energyCertificateIssuedDate?: string | null;
  energyCertificateUrl?: string | null;
  energyCertificateNumber?: string | null;
  commercialArea?: AreaValue | null;
  residentialArea?: AreaValue | null;
  rentalObjects: VacancyReport;
  commercialSpaces: DetailedVacancyReport;
  commonAreaTotal: AreaAggregate;
  packages: BuildingPackageReadModel[];
};
export type SetBuildingPackagePayload = {
  packageType: PackageType;
  tier: PackageTier;
};
export type SetBuildingPayload = {
  name: string;
  description?: string | null;
  address?: AddressValue | null;
  areaMetric?: number | null;
  source?: SpaceSourceExternalReferenceValue | null;
  standard?: StandardType | null;
  assetClass?: AssetClass | null;
  type?: BuildingType | null;
  energyLabel?: EnergyLabel | null;
  heatingGrade?: string | null;
  cadastralInformation?: CadastralValue | null;
  buildingNumber?: string | null;
  operationalCostPriceId?: string | null;
  tags?: string[] | null;
  packages?: SetBuildingPackagePayload[] | null;
};
export type BuildingReadModelOffsetPaginationResponse = {
  totalCount: number;
  offset: number;
  limit: number;
  items: BuildingReadModel[];
  hasPrevious?: boolean;
  hasNext?: boolean;
};
export type BuildingReadModelSort = 'Name' | 'TotalArea' | 'Type';
export type CreateBuildingsForTenantResponse = {
  buildingIds: string[];
};
export type BulkOwnerPayload = {
  name?: string | null;
  organizationNumber?: string | null;
  isJuridical: boolean;
  shareNumerator?: number | null;
  shareDenominator?: number | null;
};
export type BulkChildBuildingPayload = {
  buildingNumber?: string | null;
  bra: number;
  numberOfFloors?: number | null;
  matrikkelBuildingTypeCode?: number | null;
  energyLabel?: string | null;
  heatingGrade?: string | null;
  constructionYear?: number | null;
  energyCertificateUrl?: string | null;
  energyCertificateNumber?: string | null;
  energyCertificateIssuedDate?: string | null;
};
export type BulkBuildingPackagePayload = {
  packageType: PackageType;
  tier: PackageTier;
};
export type BulkBuildingPayload = {
  name?: string | null;
  address: string;
  postalCode: string;
  city: string;
  countryThreeLetterCode?: string | null;
  streetName?: string | null;
  streetNumber?: string | null;
  source?: string | null;
  type: string;
  bra: number;
  role: string;
  numberOfFloors?: number | null;
  buildingNumber?: string | null;
  energySourceType?: string | null;
  heatingType?: string | null;
  matrikkelBuildingTypeCode?: number | null;
  latitude?: number | null;
  longitude?: number | null;
  gnr?: string | null;
  bnr?: string | null;
  municipalityCode?: string | null;
  ownerOrgNumber?: string | null;
  ownerName?: string | null;
  owners?: BulkOwnerPayload[] | null;
  ownerPath?: string | null;
  ownerPathRootOrgNumber?: string | null;
  energyLabel?: string | null;
  heatingGrade?: string | null;
  constructionYear?: number | null;
  energyCertificateUrl?: string | null;
  energyCertificateNumber?: string | null;
  energyCertificateIssuedDate?: string | null;
  isGrouped: boolean;
  childBuildings?: BulkChildBuildingPayload[] | null;
  packages?: BulkBuildingPackagePayload[] | null;
};
export type BulkImportCompanyPayload = {
  orgNr: string;
  name: string;
};
export type CreateBuildingsForTenantPayload = {
  buildings: BulkBuildingPayload[];
  importCompanies?: BulkImportCompanyPayload[] | null;
};
export type EnergyBidAreaReadModel = {
  id: string;
  countryThreeLetterCode: string;
  bidArea: string;
};
export type SpaceEnergyBidAreaReadModel = {
  spaceId: string;
  bidAreaId: string;
  bidArea: string;
  countryThreeLetterCode: string;
  manualOverride: boolean;
};
export type SetBuildingBidAreaPayload = {
  bidAreaId: string;
};
export type PriceSourceType = 'Nordpool' | 'Custom';
export type BuildingEnergySettingReadModel = {
  id: string;
  buildingId: string;
  year: number;
  priceSource: PriceSourceType;
  customPricePerKwh?: number | null;
  consumptionKwh?: number | null;
};
export type SetBuildingEnergySettingModel = {
  year: number;
  priceSource: PriceSourceType;
  customPricePerKwh?: number | null;
  consumptionKwh?: number | null;
};
export type BuildingAssigneeReadModel = {
  id: string;
  name: string;
  companyId?: string | null;
  ownershipShare?: number | null;
};
export type CompanyStatus = 'Pending' | 'Ready';
export type CompanySource = 'ExcelImport';
export type CompanySourceExternalReferenceValue = {
  integration: CompanySource;
  identifier: string;
};
export type BrregAddressValue = {
  address?: string | null;
  postalCode?: string | null;
  city?: string | null;
  municipality?: string | null;
};
export type CompanyReadModel = {
  id: string;
  name?: string | null;
  vatId?: string | null;
  country?: CountryValue | null;
  status?: CompanyStatus | null;
  source?: CompanySourceExternalReferenceValue | null;
  invoicingAccount?: InvoicingIntegrationExternalReferenceValue | null;
  personCount: number;
  agreementCount: number;
  stakeholderId?: string | null;
  hasAgreement?: boolean;
  businessAddress?: BrregAddressValue | null;
  organizationNumber?: string | null;
  organizationForm?: string | null;
  industryCode?: string | null;
  institutionalSectorCode?: string | null;
  numberOfEmployees?: number | null;
  isBankrupt?: boolean | null;
  isUnderLiquidation?: boolean | null;
  isUnderForcedDissolution?: boolean | null;
  parentOrganizationNumber?: string | null;
  registeredInVatRegistry?: boolean | null;
  vatRegistrationDate?: string | null;
  lastAnnualAccountsYear?: string | null;
  activity?: string | null;
  remarks?: string | null;
  brregUrl?: string | null;
  website?: string | null;
  emailAddress?: string | null;
  mobilePhone?: string | null;
  entityRegistrationDate?: string | null;
  isPartOfGroup?: boolean | null;
  languageCode?: string | null;
  roles: string[];
};
export type SpaceReadModelOffsetPaginationResponse = {
  totalCount: number;
  offset: number;
  limit: number;
  items: SpaceReadModel[];
  hasPrevious?: boolean;
  hasNext?: boolean;
};
export type SpaceReadModelSort = 'Default' | 'Name' | 'BuildingName' | 'Area' | 'Address';
export type CommonAreaType = 'Shared' | 'Building' | 'Communication' | 'TechnicalOperation';
export type CommonAreaReadModel = {
  id: string;
  discriminator: SpaceDiscriminator;
  path: string;
  building?: BaseSpaceReadModel | null;
  parent?: BaseSpaceReadModel | null;
  name: string;
  address: AddressValue;
  description?: string | null;
  usageType?: UsageType | null;
  standard?: StandardType | null;
  area?: AreaValue | null;
  assetClass?: AssetClass | null;
  lifespan: DateIntervalValue;
  rentablePeriod?: DateIntervalValue | null;
  rent?: PriceReadModel | null;
  operationalCost?: PriceReadModel | null;
  source?: SpaceSourceExternalReferenceValue | null;
  status?: VacancyStatus | null;
  roomCount: {
    [key: string]: number | null;
  };
  tags: string[];
  tenantId?: string | null;
  tenantName?: string | null;
  agreementStatus?: AgreementStatus | null;
  hasActiveAgreements: boolean;
  type: CommonAreaType;
};
export type CreateCommonAreaPayload = {
  name: string;
  description?: string | null;
  address?: AddressValue | null;
  areaMetric?: number | null;
  source?: SpaceSourceExternalReferenceValue | null;
  standard?: StandardType | null;
  assetClass?: AssetClass | null;
  type: CommonAreaType;
  operationalCostPriceId?: string | null;
  parentId: string;
};
export type CommonAreaReadModelOffsetPaginationResponse = {
  totalCount: number;
  offset: number;
  limit: number;
  items: CommonAreaReadModel[];
  hasPrevious?: boolean;
  hasNext?: boolean;
};
export type UpdateCommonAreaPayload = {
  name: string;
  description?: string | null;
  address?: AddressValue | null;
  areaMetric?: number | null;
  source?: SpaceSourceExternalReferenceValue | null;
  standard?: StandardType | null;
  assetClass?: AssetClass | null;
  type: CommonAreaType;
  operationalCostPriceId?: string | null;
  parentId: string;
};
export type LegalPersonReadModel = {
  id: string;
  name: string;
  vatId?: string | null;
  invoicingAccount?: InvoicingIntegrationExternalReferenceValue | null;
};
export type BaseCompanyModel = {
  name: string;
  vatId?: string | null;
  country?: CountryValue | null;
  source?: CompanySourceExternalReferenceValue | null;
  organizationNumber?: string | null;
  provider?: string | null;
  businessAddress?: BrregAddressValue | null;
  organizationForm?: string | null;
  industryCode?: string | null;
  institutionalSectorCode?: string | null;
  numberOfEmployees?: number | null;
  isBankrupt?: boolean | null;
  isUnderLiquidation?: boolean | null;
  isUnderForcedDissolution?: boolean | null;
  parentOrganizationNumber?: string | null;
  registeredInVatRegistry?: boolean | null;
  vatRegistrationDate?: string | null;
  lastAnnualAccountsYear?: string | null;
  activity?: string | null;
  remarks?: string | null;
  brregUrl?: string | null;
  website?: string | null;
  emailAddress?: string | null;
  mobilePhone?: string | null;
  entityRegistrationDate?: string | null;
  isPartOfGroup?: boolean | null;
  languageCode?: string | null;
};
export type CompanyReadModelOffsetPaginationResponse = {
  totalCount: number;
  offset: number;
  limit: number;
  items: CompanyReadModel[];
  hasPrevious?: boolean;
  hasNext?: boolean;
};
export type CompanyReadModelSort = 'Name' | 'VatId';
export type CompanyContactPersonAssignmentReadModel = {
  agreementId: string;
  agreementName: string;
  role: Role;
  contactPerson?: PersonReadModel | null;
};
export type CompanyDepartmentDto = {
  id: number;
  name: string;
};
export type TenantMemberStatus = 'Active' | 'Invited' | 'Inactive';
export type TenantMemberReadModel = {
  id: string;
  userId?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  name?: string | null;
  email: string;
  role?: Role | null;
  status: TenantMemberStatus;
  culture?: CultureValue | null;
  invitedAt?: string | null;
  acceptedAt?: string | null;
  initials?: string;
};
export type TenantMemberReadModelOffsetPaginationResponse = {
  totalCount: number;
  offset: number;
  limit: number;
  items: TenantMemberReadModel[];
  hasPrevious?: boolean;
  hasNext?: boolean;
};
export type CompanyRoleCountsDto = {
  all: number;
  managers: number;
  owners: number;
  tenants: number;
  investors: number;
};
export type CompanyPersonReadModel = {
  id: string;
  person: PersonReadModel;
};
export type CompanyPersonReadModelOffsetPaginationResponse = {
  totalCount: number;
  offset: number;
  limit: number;
  items: CompanyPersonReadModel[];
  hasPrevious?: boolean;
  hasNext?: boolean;
};
export type PersonReadModelSort = 'Name' | 'FirstName' | 'LastName' | 'Email';
export type CancelContractSigningPayload = {
  cancellationReason: string;
};
export type ContractStatus = 'Unsigned' | 'PartiallySigned' | 'Canceled' | 'Expired' | 'Signed';
export type ContractSignatureReadModel = {
  id: string;
  legalPerson: LegalPersonReadModel;
  representative?: PersonReadModel | null;
  url?: string | null;
  isSigned: boolean;
};
export type DocumentSigningIntegration = 'Signicat';
export type DocumentSigningIntegrationExternalReferenceValue = {
  integration: DocumentSigningIntegration;
  identifier: string;
};
export type ContractReadModel = {
  id: string;
  author: PersonReadModel;
  name: string;
  description?: string | null;
  path: string;
  thumbnailPath?: string | null;
  agreementId: string;
  deadline: string;
  status: ContractStatus;
  cancellationReason?: string | null;
  signatures: ContractSignatureReadModel[];
  externalReference?: DocumentSigningIntegrationExternalReferenceValue | null;
  isSent: boolean;
};
export type ContractReadModelOffsetPaginationResponse = {
  totalCount: number;
  offset: number;
  limit: number;
  items: ContractReadModel[];
  hasPrevious?: boolean;
  hasNext?: boolean;
};
export type TenantContractExpirationDetailsDto = {
  agreementId: string;
  contractName: string;
  tenantId: string;
  tenantName: string;
  remainingContractExpirationMonths: number;
  expirationDate: string;
};
export type ContractExpirationDetailReportDto = {
  buildingId: string;
  buildingName: string;
  numberOfTenants: number;
  tenants: TenantContractExpirationDetailsDto[];
};
export type TenantContractLengthDetailsDto = {
  agreementId: string;
  tenantId: string;
  name: string;
  remainingContractLengthYears?: number | null;
  startDate?: string | null;
  endDate?: string | null;
  totalContractLengthYears?: number | null;
};
export type BuildingContractLengthDetailsDto = {
  buildingId: string;
  buildingName: string;
  numberOfTenants: number;
  tenants: TenantContractLengthDetailsDto[];
};
export type VatVarianceDto = {
  absolutePp?: number | null;
  relativePercent?: number | null;
  status?: string | null;
};
export type VatPercentageTenantDto = {
  tenantId: string;
  tenantName: string;
  agreementId: string;
  agreementName: string;
  currentPeriodVatPercentage?: number | null;
  comparisonPeriodVatPercentage?: number | null;
  variance: VatVarianceDto;
  lastUpdated?: string | null;
};
export type VatPercentageByBuildingDto = {
  buildingId: string;
  buildingName: string;
  numberOfTenants: number;
  currentPeriodAverageVat?: number | null;
  comparisonPeriodAverageVat?: number | null;
  variance: VatVarianceDto;
  lastUpdated?: string | null;
  tenants: VatPercentageTenantDto[];
};
export type BuildingContractLengthDto = {
  buildingId: string;
  buildingName: string;
  agreementRemainingLengthYears: number;
};
export type AverageContractLengthDashboardDto = {
  averageContractLengthYears: number;
  topThreeBuildingsByRemainingLength: BuildingContractLengthDto[];
  bottomThreeBuildingsByRemainingLength: BuildingContractLengthDto[];
};
export type BuildingPayload = {
  buildingIds?: string[] | null;
};
export type AverageContractLengthReportDto = {
  averageContractLengthYears: number;
  averageRemainingContractLengthYears: number;
  developmentMonths: number;
};
export type ExpirationPeriodDto = {
  startDate: string;
  endDate: string;
  numberOfContractsExpired: number;
};
export type ExpirationBucketDto = {
  label: string;
  startDate: string;
  endDate: string;
  count: number;
  isCritical: boolean;
};
export type ContractExpirationSummaryReportDto = {
  expiringInNext6Months: ExpirationPeriodDto;
  expiringInNext12Months: ExpirationPeriodDto;
  expiringInNext24Months: ExpirationPeriodDto;
  buckets: ExpirationBucketDto[];
};
export type ContractExpirationDetailReportDtoPagedListDto = {
  page: number;
  pageSize: number;
  total: number;
  items: ContractExpirationDetailReportDto[];
};
export type BuildingContractLengthDetailsDtoPagedListDto = {
  page: number;
  pageSize: number;
  total: number;
  items: BuildingContractLengthDetailsDto[];
};
export type VatPercentageByBuildingDtoPagedListDto = {
  page: number;
  pageSize: number;
  total: number;
  items: VatPercentageByBuildingDto[];
};
export type VatPercentageSummaryDto = {
  agreementsWithVat: number;
  agreementsWithoutVat: number;
  currentPeriodAverageVat?: number | null;
  comparisonPeriodAverageVat?: number | null;
  variance: VatVarianceDto;
};
export type CreateContractSignaturePayload = {
  legalPersonId: string;
  representativeId?: string | null;
};
export type SetContractSignaturePayload = {
  id?: string | null;
  legalPersonId: string;
  representativeId?: string | null;
};
export type ImpactedCountModel = {
  added: number;
  updated: number;
};
export type PortfolioImpactedCountModel = {
  buildings: ImpactedCountModel;
  commercialSpaces: ImpactedCountModel;
  residentialUnits: ImpactedCountModel;
};
export type ConsumptionIntegration = 'Adaptic' | 'Relynk';
export type ChartAccountResponse = {
  id: string;
  accountNumber: string;
  name: string;
  sortOrder: number;
  isActive: boolean;
};
export type CommonCostCategoryResponse = {
  id: string;
  name: string;
  sortOrder: number;
  accounts: ChartAccountResponse[];
};
export type CommonCostChartResponse = {
  categories: CommonCostCategoryResponse[];
};
export type OwnerCostCategoryResponse = {
  id: string;
  name: string;
  sortOrder: number;
};
export type OwnerCostAccountResponse = {
  id: string;
  accountNumber: string;
  name: string;
  categoryId: string;
  categoryName: string;
  sortOrder: number;
  isActive: boolean;
};
export type OwnerCostChartResponse = {
  categories: OwnerCostCategoryResponse[];
  accounts: OwnerCostAccountResponse[];
};
export type ChartOfAccountsResponse = {
  commonCost: CommonCostChartResponse;
  ownerCost: OwnerCostChartResponse;
};
export type CountryTemplate = 'Norway' | 'Sweden' | 'Estonia';
export type ChartOfAccountsSummaryResponse = {
  lineCount: number;
  standard?: CountryTemplate | null;
  subCategoryCount: number;
};
export type EconomySettingsOverviewResponse = {
  name: string;
  organizationNumber: string;
  erpSystem?: ErpIntegration | null;
  erpConfigured?: boolean | null;
  chartOfAccounts: ChartOfAccountsSummaryResponse;
};
export type CostClass = 'CommonCost' | 'OwnerCost';
export type AllocationMethod = 'PerSquareMetre' | 'EquallyDistributed' | 'NoiWeighted';
export type SharedCostResponse = {
  id: string;
  accountNumber: string;
  name: string;
  costClass: CostClass;
  amount: number;
  allocationMethod: AllocationMethod;
  isActive: boolean;
};
export type AirQualityBatteryLevel = {
  unit?: string | null;
  value?: number | null;
};
export type AirQualityBucket = {
  key: string;
  value: number;
};
export type AirQualityCo2 = {
  unit: string;
  threshold: number;
  buckets: AirQualityBucket[];
};
export type AirQualityTemperature = {
  unit: string;
  buckets: AirQualityBucket[];
};
export type AirQualityResponse = {
  batteryLevel: AirQualityBatteryLevel;
  co2: AirQualityCo2;
  temperature: AirQualityTemperature;
};
export type EosResolution = 'Hourly' | 'Daily' | 'Weekly' | 'Monthly' | 'Yearly';
export type SeriesData = {
  key: string;
  value: number;
};
export type DeviceData = {
  id: string;
  name: string;
  unit: string;
  type: string;
  series: SeriesData[];
};
export type SpaceDeviceData = {
  id: string;
  name: string;
  devices: DeviceData[];
};
export type ConsumptionByDeviceResponse = {
  resolution: EosResolution;
  spaces: SpaceDeviceData[];
};
export type ConsumptionByEnergyCostBucket = {
  key: string;
  [key: string]: any;
};
export type SeriesTagBucket = {
  key: string;
  value: number;
  unit?: string | null;
};
export type SeriesTag = {
  tag: string;
  unit?: string | null;
  buckets?: SeriesTagBucket[] | null;
};
export type ConsumptionByEnergyCostResponse = {
  resolution?: string | null;
  tags: string[];
  buckets?: ConsumptionByEnergyCostBucket[] | null;
  seriesTags: string[];
  series?: SeriesTag[] | null;
};
export type ConsumptionByEnergyTypeBucket = {
  key: string;
  [key: string]: any;
};
export type ConsumptionByEnergyTypeResponse = {
  resolution?: string | null;
  tags: string[];
  buckets?: ConsumptionByEnergyTypeBucket[] | null;
  seriesTags: string[];
  series?: SeriesTag[] | null;
};
export type ConsumptionBySourceBucket = {
  key: string;
  value: number;
  avg: number;
  max: number;
  min: number;
};
export type ConsumptionBySourceTag = {
  key: string;
  unit?: string | null;
  total: number;
  avg: number;
  max: number;
  min: number;
  buckets?: ConsumptionBySourceBucket[] | null;
};
export type ConsumptionBySourceAggregation = {
  source: string;
  total: number;
  tags?: ConsumptionBySourceTag[] | null;
};
export type ConsumptionBySourceSources = {
  total: number;
  aggregations?: ConsumptionBySourceAggregation[] | null;
};
export type ConsumptionBySourceResponse = {
  resolution?: string | null;
  sources?: ConsumptionBySourceSources | null;
  seriesTags: string[];
  series?: SeriesTag[] | null;
};
export type ConsumptionSpace = {
  name?: string | null;
  percentage?: number | null;
  value?: number | null;
};
export type ConsumptionVsAverageItem = {
  key: string;
  value: number;
  trend: number;
};
export type ConsumptionVsAverageResponse = {
  resolution?: string | null;
  buckets?: ConsumptionVsAverageItem[] | null;
};
export type CorrelationPoint = {
  timestamp: string;
  x: number;
  y: number;
};
export type CorrelationRegressionLine = {
  x: number;
  y: number;
};
export type CorrelationConfidenceBand = {
  x: number;
  yMin: number;
  yMax: number;
};
export type CorrelationRegression = {
  slope: number;
  intercept: number;
  rSquared: number;
  line: CorrelationRegressionLine[];
  confidenceBand: CorrelationConfidenceBand[];
};
export type CorrelationResponse = {
  resolution?: EosResolution | null;
  xLabel?: string | null;
  yLabel?: string | null;
  xUnit?: string | null;
  yUnit?: string | null;
  points: CorrelationPoint[];
  regression?: CorrelationRegression | null;
};
export type EstimatedEnergyCostResponse = {
  costTotal: number;
  costM2: number;
};
export type EstimatedEnergyCostSpace = {
  name?: string | null;
  percentage?: number | null;
  value?: number | null;
};
export type TotalConsumptionItem = {
  key: string;
  total: number;
  percentage: number;
};
export type TotalConsumptionResponse = {
  total?: number | null;
  percentage?: number | null;
  buckets?: TotalConsumptionItem[] | null;
};
export type ConsumptionSquareMeterItem = {
  key: string;
  value: number;
};
export type ConsumptionSquareMeterResponse = {
  value?: number | null;
  percentage?: number | null;
  buckets?: ConsumptionSquareMeterItem[] | null;
};
export type TotalEnergyCostResponse = {
  totalEnergyCost?: number | null;
};
export type InvestmentSpaceReadModel = {
  id: string;
  type: CalendarEntryType;
  interval: DateIntervalValue;
  price?: PriceReadModel | null;
  totalAmount?: MoneyValue | null;
  yearlyTotalAmount?: MoneyValue | null;
  oneTimeTotalAmount?: MoneyValue | null;
  overrideArea?: number | null;
  overwrittenUnitAmount?: MoneyValue | null;
  returnInterval: DateIntervalValue;
  space: SpaceReadModel;
};
export type InvestmentReadModel = {
  id: string;
  name: string;
  purpose?: string | null;
  amount?: MoneyValue | null;
  duration: DateIntervalValue;
  returnDuration: DateIntervalValue;
  spaces: InvestmentSpaceReadModel[];
};
export type CreateInvestmentSpacePayload = {
  spaceId: string;
  priceId?: string | null;
};
export type CreateInvestmentPayload = {
  name: string;
  purpose?: string | null;
  amount?: MoneyValue | null;
  duration: {
    start: string;
    end: string;
  };
  returnDuration: OpenDateInterval;
  spaces: CreateInvestmentSpacePayload[];
};
export type InvestmentReadModelOffsetPaginationResponse = {
  totalCount: number;
  offset: number;
  limit: number;
  items: InvestmentReadModel[];
  hasPrevious?: boolean;
  hasNext?: boolean;
};
export type InvestmentReadModelSort = 'Default' | 'Start' | 'End';
export type SetInvestmentModel = {
  name: string;
  purpose?: string | null;
  amount?: MoneyValue | null;
  duration: {
    start: string;
    end: string;
  };
  returnDuration: OpenDateInterval;
};
export type SetInvestmentSpacePayload = {
  id?: string | null;
  spaceId: string;
  priceId?: string | null;
};
export type MoneyDto = {
  value: number;
  currency: string;
};
export type VarianceDto = {
  absolute: MoneyDto;
  percentage: number;
};
export type OverdueInvoiceDto = {
  invoiceId: string;
  invoiceNumber: number;
  invoiceText: string;
  dueDate: string;
  amountOutstanding: MoneyDto;
  daysOverdue: number;
};
export type TenantOverdueInvoicesDto = {
  tenantId: string;
  tenantName: string;
  currentPeriodOutstanding: MoneyDto;
  comparisonPeriodOutstanding: MoneyDto;
  variance: VarianceDto;
  currentPeriodInvoiceCount: number;
  comparisonPeriodInvoiceCount: number;
  invoices: OverdueInvoiceDto[];
};
export type BuildingOverdueInvoicesDto = {
  buildingId: string;
  buildingName: string;
  tenantCount: number;
  currentPeriodOutstanding: MoneyDto;
  comparisonPeriodOutstanding: MoneyDto;
  variance: VarianceDto;
  currentPeriodInvoiceCount: number;
  comparisonPeriodInvoiceCount: number;
  tenantOverdueInvoices: TenantOverdueInvoicesDto[];
};
export type InvoiceStatus = 'CreditNote' | 'Credited' | 'Paid' | 'PartiallyPaid' | 'Overdue' | 'Unpaid';
export type InvoiceReceivableDto = {
  invoiceId: string;
  invoiceNumber: number;
  invoiceText: string;
  invoiceDate: string;
  dueDate: string;
  amount: MoneyDto;
  amountOutstanding: MoneyDto;
  isCreditNote: boolean;
  isCredited: boolean;
  isCharged: boolean;
  status: InvoiceStatus;
};
export type TenantAccountsReceivableDto = {
  tenantId: string;
  tenantName: string;
  currentPeriodOutstanding: MoneyDto;
  comparisonPeriodOutstanding: MoneyDto;
  variance: VarianceDto;
  currentPeriodInvoiceCount: number;
  comparisonPeriodInvoiceCount: number;
  invoices: InvoiceReceivableDto[];
};
export type BuildingAccountsReceivableDto = {
  buildingId: string;
  buildingName: string;
  tenantCount: number;
  currentPeriodOutstanding: MoneyDto;
  comparisonPeriodOutstanding: MoneyDto;
  variance: VarianceDto;
  currentPeriodInvoiceCount: number;
  comparisonPeriodInvoiceCount: number;
  tenantReceivables: TenantAccountsReceivableDto[];
};
export type AgingBucket = 'NOT_DUE' | 'DAYS_1_30' | 'DAYS_31_60' | 'DAYS_61_90' | 'OVER_90';
export type AgingSummaryItemDto = {
  bucket: AgingBucket;
  amount: MoneyDto;
};
export type OverdueCustomerDto = {
  customerId: string;
  customerName: string;
  daysLate: number;
  amount: MoneyDto;
};
export type InvoiceDashboardDto = {
  totalAccountsReceivable: MoneyDto;
  agingSummary: AgingSummaryItemDto[];
  topOverdueCustomers: OverdueCustomerDto[];
  totalOverdueAmount: MoneyDto;
};
export type BuildingOverdueInvoicesDtoPagedListDto = {
  page: number;
  pageSize: number;
  total: number;
  items: BuildingOverdueInvoicesDto[];
};
export type OverdueSummaryDto = {
  last30DaysAmount: MoneyDto;
  over30DaysAmount: MoneyDto;
  variance: VarianceDto;
  lastSyncTimestamp: string;
};
export type BuildingAccountsReceivableDtoPagedListDto = {
  page: number;
  pageSize: number;
  total: number;
  items: BuildingAccountsReceivableDto[];
};
export type ReceivableSummaryDto = {
  selectedYearAmount: MoneyDto;
  previousYearAmount: MoneyDto;
  variance: VarianceDto;
  lastSyncTimestamp?: string | null;
};
export type KpiDto = {
  year: number;
  month: number;
  value?: number | null;
  isAvailable: boolean;
};
export type LegalPersonReadModelOffsetPaginationResponse = {
  totalCount: number;
  offset: number;
  limit: number;
  items: LegalPersonReadModel[];
  hasPrevious?: boolean;
  hasNext?: boolean;
};
export type LegalPersonReadModelSort = 'Name' | 'VatId';
export type LegalPersonRepresentativeReadModel = {
  id: string;
  representative?: PersonReadModel;
};
export type LegalPersonRepresentativeReadModelOffsetPaginationResponse = {
  totalCount: number;
  offset: number;
  limit: number;
  items: LegalPersonRepresentativeReadModel[];
  hasPrevious?: boolean;
  hasNext?: boolean;
};
export type MeterDataReadModel = {
  id: string;
  ts: string;
  value: number;
};
export type MeterDataReadModelOffsetPaginationResponse = {
  totalCount: number;
  offset: number;
  limit: number;
  items: MeterDataReadModel[];
  hasPrevious?: boolean;
  hasNext?: boolean;
};
export type Resolution = 'Hour' | 'Day' | 'Week' | 'Month' | 'Quarter' | 'Year';
export type Rollup = 'Sum' | 'Min' | 'Max' | 'Avg';
export type MeasureType = 'Energy' | 'Cooling' | 'Water' | 'HotWater' | 'CirculationWater';
export type EnergyCarrier = 'Electricity' | 'RemoteHeating' | 'RemoteCooling' | 'Biological' | 'Gas' | 'Oil';
export type MeterReadModel = {
  id: string;
  label: string;
  description?: string | null;
  measureType: MeasureType;
  energyCarrier: EnergyCarrier;
};
export type MeterReadModelOffsetPaginationResponse = {
  totalCount: number;
  offset: number;
  limit: number;
  items: MeterReadModel[];
  hasPrevious?: boolean;
  hasNext?: boolean;
};
export type OccupancyRatesDetailDto = {
  id: string;
  name: string;
  m2?: number | null;
  totalM2?: number | null;
  occupancyRate: number;
  previousYearOccupancyRate?: number | null;
  startDate?: string | null;
  endDate?: string | null;
  vacancyPercentage?: number;
  occupancyChangePercentage?: number;
  children?: OccupancyRatesDetailDto[] | null;
  totalChildren?: number;
  assetClass?: AssetClass | null;
  parentName?: string | null;
  tenantName?: string | null;
  vacancyStatus?: VacancyStatus | null;
  totalSpaceCount?: number | null;
  rentedM2?: number | null;
  vacantM2?: number | null;
  rentedSpaceCount?: number | null;
  vacantSpaceCount?: number | null;
};
export type BuildingOccupancyDto = {
  buildingName: string;
  occupancyRate: number;
};
export type OccupancyRateDashboardDto = {
  occupancyRate: number;
  topBuildings: BuildingOccupancyDto[];
  bottomBuildings: BuildingOccupancyDto[];
};
export type OccupancyRatesDetailDtoPagedListDto = {
  page: number;
  pageSize: number;
  total: number;
  items: OccupancyRatesDetailDto[];
};
export type OccupancyRatesSummaryDto = {
  currentYearOccupancyRate: number;
  previousYearOccupancyRate: number;
  occupancyRateChangePercentage: number;
};
export type OrganizationReadModel = {
  id: string;
  name: string;
  vatId?: string | null;
  invoicingAccount?: InvoicingIntegrationExternalReferenceValue | null;
  parentId?: string | null;
  personCount: number;
  agreementCount: number;
};
export type OrganizationReadModelOffsetPaginationResponse = {
  totalCount: number;
  offset: number;
  limit: number;
  items: OrganizationReadModel[];
  hasPrevious?: boolean;
  hasNext?: boolean;
};
export type OrganizationReadModelSort = 'Name';
export type OrganizationPersonReadModel = {
  id: string;
  person: PersonReadModel;
};
export type OrganizationPersonReadModelOffsetPaginationResponse = {
  totalCount: number;
  offset: number;
  limit: number;
  items: OrganizationPersonReadModel[];
  hasPrevious?: boolean;
  hasNext?: boolean;
};
export type SetOrganizationPersonsPayload = {
  id?: string | null;
  personId: string;
};
export type ParkingSpotType = 'OutdoorUncovered' | 'OutdoorCovered' | 'Indoor' | 'Garage';
export type ParkingSpotReadModel = {
  id: string;
  discriminator: SpaceDiscriminator;
  path: string;
  building?: BaseSpaceReadModel | null;
  parent?: BaseSpaceReadModel | null;
  name: string;
  address: AddressValue;
  description?: string | null;
  usageType?: UsageType | null;
  standard?: StandardType | null;
  area?: AreaValue | null;
  assetClass?: AssetClass | null;
  lifespan: DateIntervalValue;
  rentablePeriod?: DateIntervalValue | null;
  rent?: PriceReadModel | null;
  operationalCost?: PriceReadModel | null;
  source?: SpaceSourceExternalReferenceValue | null;
  status?: VacancyStatus | null;
  roomCount: {
    [key: string]: number | null;
  };
  tags: string[];
  tenantId?: string | null;
  tenantName?: string | null;
  agreementStatus?: AgreementStatus | null;
  hasActiveAgreements: boolean;
  type: ParkingSpotType;
};
export type CreateParkingSpotPayload = {
  name: string;
  description?: string | null;
  address?: AddressValue | null;
  areaMetric?: number | null;
  source?: SpaceSourceExternalReferenceValue | null;
  standard?: StandardType | null;
  assetClass?: AssetClass | null;
  type: ParkingSpotType;
  parentId: string;
  rentPriceId?: string | null;
};
export type ParkingSpotReadModelOffsetPaginationResponse = {
  totalCount: number;
  offset: number;
  limit: number;
  items: ParkingSpotReadModel[];
  hasPrevious?: boolean;
  hasNext?: boolean;
};
export type UpdateParkingSpotPayload = {
  name: string;
  description?: string | null;
  address?: AddressValue | null;
  areaMetric?: number | null;
  source?: SpaceSourceExternalReferenceValue | null;
  standard?: StandardType | null;
  assetClass?: AssetClass | null;
  type: ParkingSpotType;
  parentId: string;
  rentPriceId?: string | null;
};
export type CreatePersonModel = {
  firstName: string;
  lastName: string;
  email: string;
  phone?: string | null;
  socialSecurityNumber?: SocialSecurityNumberValue | null;
  culture?: CultureValue | null;
  country?: CountryValue | null;
  vatId?: string | null;
  invoicingAccount?: InvoicingIntegrationExternalReferenceValue | null;
  source?: PersonSourceExternalReferenceValue | null;
};
export type PersonReadModelOffsetPaginationResponse = {
  totalCount: number;
  offset: number;
  limit: number;
  items: PersonReadModel[];
  hasPrevious?: boolean;
  hasNext?: boolean;
};
export type UpdatePersonModel = {
  firstName: string;
  lastName: string;
  email: string;
  phone?: string | null;
  socialSecurityNumber?: SocialSecurityNumberValue | null;
  culture?: CultureValue | null;
  country?: CountryValue | null;
  vatId?: string | null;
  invoicingAccount?: InvoicingIntegrationExternalReferenceValue | null;
  source?: PersonSourceExternalReferenceValue | null;
};
export type InviteClientAdmin = {
  email: string;
};
export type InviteCompanyUser = {
  email: string;
  companyId?: string | null;
};
export type InviteTenantUser = {
  email: string;
  role: Role;
};
export type InviteUser = {
  email: string;
  companyId?: string | null;
};
export type CompletePortfolioOnboardingResponse = {
  tenantId: string;
  tenantName: string;
};
export type OnboardingCompanyPayload = {
  orgNr: string;
  name: string;
  address?: string | null;
  postalCode?: string | null;
  city?: string | null;
  municipality?: string | null;
  organizationForm?: string | null;
  industryCode?: string | null;
  institutionalSectorCode?: string | null;
  numberOfEmployees?: number | null;
  isBankrupt?: boolean | null;
  isUnderLiquidation?: boolean | null;
  isUnderForcedDissolution?: boolean | null;
  parentOrganizationNumber?: string | null;
  registeredInVatRegistry?: boolean | null;
  vatRegistrationDate?: string | null;
  lastAnnualAccountsYear?: string | null;
  activity?: string | null;
  remarks?: string | null;
  brregUrl?: string | null;
  website?: string | null;
  emailAddress?: string | null;
  mobilePhone?: string | null;
  entityRegistrationDate?: string | null;
  isPartOfGroup?: boolean | null;
  languageCode?: string | null;
};
export type OnboardingOwnerPayload = {
  name?: string | null;
  organizationNumber?: string | null;
  isJuridical: boolean;
  shareNumerator?: number | null;
  shareDenominator?: number | null;
};
export type OnboardingChildBuildingPayload = {
  buildingNumber?: string | null;
  bra: number;
  numberOfFloors?: number | null;
  matrikkelBuildingTypeCode?: number | null;
  energyLabel?: string | null;
  heatingGrade?: string | null;
  constructionYear?: number | null;
  energyCertificateUrl?: string | null;
  energyCertificateNumber?: string | null;
  energyCertificateIssuedDate?: string | null;
};
export type OnboardingBuildingPayload = {
  name?: string | null;
  address: string;
  postalCode: string;
  city: string;
  countryThreeLetterCode?: string | null;
  streetName?: string | null;
  streetNumber?: string | null;
  source?: string | null;
  type: string;
  bra: number;
  role: string;
  numberOfFloors?: number | null;
  buildingNumber?: string | null;
  energySourceType?: string | null;
  heatingType?: string | null;
  matrikkelBuildingTypeCode?: number | null;
  latitude?: number | null;
  longitude?: number | null;
  gnr?: string | null;
  bnr?: string | null;
  municipalityCode?: string | null;
  ownerOrgNumber?: string | null;
  ownerName?: string | null;
  owners?: OnboardingOwnerPayload[] | null;
  ownerPath?: string | null;
  ownerPathRootOrgNumber?: string | null;
  energyLabel?: string | null;
  heatingGrade?: string | null;
  constructionYear?: number | null;
  energyCertificateUrl?: string | null;
  energyCertificateNumber?: string | null;
  energyCertificateIssuedDate?: string | null;
  isGrouped: boolean;
  childBuildings?: OnboardingChildBuildingPayload[] | null;
};
export type OnboardingUserPayload = {
  email: string;
  role: string;
};
export type OnboardingImportCompanyPayload = {
  orgNr: string;
  name: string;
};
export type CompletePortfolioOnboardingPayload = {
  company: OnboardingCompanyPayload;
  buildings: OnboardingBuildingPayload[];
  users: OnboardingUserPayload[];
  importCompanies?: OnboardingImportCompanyPayload[] | null;
};
export type CreatePortfolioOnboardingInvitationResponse = {
  invitationId: string;
  email: string;
  clerkInvitationSent: boolean;
};
export type CreatePortfolioOnboardingInvitationPayload = {
  email: string;
  companyOrgNr: string;
  companyName: string;
  confirmReset: boolean;
};
export type CompanyAtAddressItem = {
  orgNumber: string;
  name: string;
  organizationForm?: string | null;
  industryCode?: string | null;
  institutionalSectorCode?: string | null;
  numberOfEmployees?: number | null;
  address?: string | null;
  postalCode?: string | null;
  city?: string | null;
  municipality?: string | null;
  isBankrupt?: boolean | null;
  isUnderLiquidation?: boolean | null;
  isUnderForcedDissolution?: boolean | null;
  parentOrganizationNumber?: string | null;
  registeredInVatRegistry?: boolean | null;
  vatRegistrationDate?: string | null;
  lastAnnualAccountsYear?: string | null;
  activity?: string | null;
  remarks?: string | null;
  brregUrl?: string | null;
  isBranch: boolean;
  existsInDb: boolean;
  website?: string | null;
  emailAddress?: string | null;
  mobilePhone?: string | null;
  entityRegistrationDate?: string | null;
  isPartOfGroup?: boolean | null;
  languageCode?: string | null;
};
export type CompaniesAtAddressResponse = {
  companies: CompanyAtAddressItem[];
};
export type GetPendingInvitationResponse = {
  invitationId: string;
  email: string;
  roleId: string;
  companyOrgNr?: string | null;
  companyName?: string | null;
  isExpired: boolean;
  expiresAt?: string | null;
};
export type SearchOwnerItem = {
  name?: string | null;
  organizationNumber?: string | null;
  isJuridical: boolean;
  shareNumerator?: number | null;
  shareDenominator?: number | null;
};
export type SearchBuildingItem = {
  buildingNumber?: string | null;
  address?: string | null;
  postalCode?: string | null;
  city?: string | null;
  buildingType?: string | null;
  matrikkelBuildingTypeCode?: number | null;
  buildingStatusType?: string | null;
  grossArea?: number | null;
  utilityFloorSpace?: number | null;
  municipalityCode?: string | null;
  gnr: number;
  bnr: number;
  latitude?: number | null;
  longitude?: number | null;
  ownerOrgNumber?: string | null;
  ownerName?: string | null;
  owners: SearchOwnerItem[];
  ownerPath?: string | null;
  ownerPathRootOrgNumber?: string | null;
  numberOfFloors?: number | null;
  energySourceType?: string | null;
  heatingType?: string | null;
  yearBuilt?: string | null;
  energyLabel?: string | null;
  heatingGrade?: string | null;
  constructionYear?: number | null;
  energyCertificateIssuedDate?: string | null;
  energyCertificateUrl?: string | null;
  energyCertificateNumber?: string | null;
};
export type SearchCompanyItem = {
  orgNumber: string;
  name: string;
};
export type SearchBuildingsResponse = {
  buildings: SearchBuildingItem[];
  companies: SearchCompanyItem[];
};
export type PriceReadModelOffsetPaginationResponse = {
  totalCount: number;
  offset: number;
  limit: number;
  items: PriceReadModel[];
  hasPrevious?: boolean;
  hasNext?: boolean;
};
export type PriceReadModelSort = 'Description';
export type BasePricePayload = {
  unitAmount: MoneyValue;
  interval?: IntervalValue | null;
  description?: string | null;
  source?: InvoicingIntegrationExternalReferenceValue | null;
};
export type CreateProductWithPricesPayload = {
  name: string;
  description?: string | null;
  sourceId?: string | null;
  category: ProductCategory;
  unit?: UnitSchemeValue | null;
  prices?: BasePricePayload[] | null;
};
export type ProductReadModelOffsetPaginationResponse = {
  totalCount: number;
  offset: number;
  limit: number;
  items: ProductReadModel[];
  hasPrevious?: boolean;
  hasNext?: boolean;
};
export type ProductReadModelSort = 'Name';
export type CreateSubProductPayload = {
  name: string;
  description?: string | null;
  price?: BasePricePayload | null;
};
export type SubProductReadModel = {
  id: string;
  name: string;
  description?: string | null;
  priceId?: string | null;
  unitAmount?: MoneyValue | null;
  interval?: IntervalValue | null;
};
export type SetPricePayload = {
  unitAmount: MoneyValue;
  interval?: IntervalValue | null;
  description?: string | null;
  source?: InvoicingIntegrationExternalReferenceValue | null;
  id?: string | null;
};
export type UpdateProductPayload = {
  name: string;
  description?: string | null;
  sourceId?: string | null;
  category: ProductCategory;
  unit?: UnitSchemeValue | null;
  prices?: SetPricePayload[] | null;
};
export type UpdateSubProductPayload = {
  name: string;
  description?: string | null;
  price?: SetPricePayload | null;
};
export type SubProductCategoryTemplateReadModel = {
  id: string;
  name: string;
  countryCode: string;
  benchmarkAverage: number;
  benchmarkLow: number;
  benchmarkHigh: number;
  sortOrder: number;
};
export type TripletexProductDto = {
  id: number;
  name?: string | null;
  number?: string | null;
  description?: string | null;
  ean?: string | null;
};
export type TenantIncomeData = {
  tenantId: string;
  tenantName: string;
  currentPeriodIncome: MoneyDto;
  comparisonPeriodIncome: MoneyDto;
  variance: VarianceDto;
};
export type BuildingIncomeData = {
  buildingId: string;
  buildingName: string;
  currentPeriodIncome: MoneyDto;
  comparisonPeriodIncome: MoneyDto;
  variance: VarianceDto;
  tenantIncomes: TenantIncomeData[];
};
export type MonthlyIncomeDto = {
  month: number;
  income: MoneyValue;
};
export type RentalIncomeDashboardDto = {
  year: number;
  totalRentalIncome: MoneyValue;
  totalCommonAreaCosts: MoneyValue;
  monthlyIncomes: MonthlyIncomeDto[];
  monthlyCommonAreaCosts: MonthlyIncomeDto[];
};
export type BuildingIncomeDataPagedListDto = {
  page: number;
  pageSize: number;
  total: number;
  items: BuildingIncomeData[];
};
export type PeriodDto = {
  startDate: string;
  endDate: string;
};
export type RentalIncomeSummaryReportReadModel = {
  currentPeriod: PeriodDto;
  comparisonPeriod: PeriodDto;
  currency: CurrencyValue;
  currentPeriodIncome: MoneyDto;
  comparisonPeriodIncome: MoneyDto;
  variance: VarianceDto;
};
export type FinancingSummary = {
  companyCount: number;
  buildingCount: number;
  totalInterestBearingDebt: number;
  debtRatio?: number | null;
  equityRatioPercent?: number | null;
  interestCoverageRatio?: number | null;
};
export type AccountingPrinciple = 'Ngaap' | 'Ifrs';
export type FinancingStatusType = 'Synced' | 'Missing';
export type FinancingCompanyRow = {
  organizationNumber?: string | null;
  name?: string | null;
  groupParentName?: string | null;
  groupParentOrgNumber?: string | null;
  buildingCount: number;
  regime: AccountingPrinciple;
  totalAssets: number;
  totalLiabilities: number;
  interestBearingDebt: number;
  equity: number;
  debtRatio?: number | null;
  equityRatioPercent?: number | null;
  interestCoverageRatio?: number | null;
  operatingResultExclValueChange: number;
  interestCost: number;
  status: FinancingStatusType;
  statusPeriodEnd?: string | null;
  firstMissingQuarter?: number | null;
};
export type FinancingReadModel = {
  summary: FinancingSummary;
  companies: FinancingCompanyRow[];
  currency: string;
};
export type PortfolioDiversificationRow = {
  key: string;
  buildingCount: number;
  tenantCount: number;
  areaM2: number;
  yearlyIncome: number;
  percentage?: number | null;
};
export type PortfolioDiversificationReadModel = {
  byCity: PortfolioDiversificationRow[];
  byType: PortfolioDiversificationRow[];
  byIndustry: PortfolioDiversificationRow[];
  currency: string;
};
export type PortfolioOverviewSummary = {
  buildingCount: number;
  totalAreaM2: number;
  occupancyRate?: number | null;
  vacancyRate?: number | null;
};
export type PortfolioOverviewBuilding = {
  id: string;
  name: string;
  address: string;
  city?: string | null;
  type?: BuildingType | null;
  constructionYear?: number | null;
  totalAreaM2: number;
  rentedAreaM2: number;
  vacantAreaM2: number;
  occupancyRate?: number | null;
  energyLabel?: EnergyLabel | null;
  owners: string[];
  hasManagementPackage: boolean;
  grossIncome: number;
  operatingCost?: number | null;
  noi: number;
  interestCost?: number | null;
  loanRepayment?: number | null;
  netCashFlow?: number | null;
  dscr?: number | null;
  cadastralUnit?: string | null;
  propertyUnit?: string | null;
  leaseholdUnit?: string | null;
  tags?: string[] | null;
  grossAreaM2: number;
  energyCertificateUrl?: string | null;
  financialYear?: number | null;
  financialGrossRentalIncome?: number | null;
  financialRentalIncome?: number | null;
  financialCommonCostIncome?: number | null;
  financialEbitda?: number | null;
  budgetGrossRentalIncome?: number | null;
  budgetRentalIncome?: number | null;
  budgetCommonCostIncome?: number | null;
  budgetEbitda?: number | null;
  equityRatioPercent?: number | null;
  interestBearingDebt?: number | null;
  financialEquity?: number | null;
  financialTotalCapital?: number | null;
  propertyValue?: number | null;
  yieldValuation?: number | null;
  yieldValuationPerM2?: number | null;
  yieldNoi?: number | null;
  yieldNetYieldPercent?: number | null;
};
export type PortfolioOverviewCashFlow = {
  grossIncome: number;
  grossIncomePerM2?: number | null;
  operatingCost: number;
  operatingCostPerM2?: number | null;
  noi: number;
  noiPerM2?: number | null;
  interestCost: number;
  interestCostPerM2?: number | null;
  loanRepayment: number;
  loanRepaymentPerM2?: number | null;
  netCashFlow: number;
  netCashFlowPerM2?: number | null;
  dscr?: number | null;
  ltv?: number | null;
  totalMortgage: number;
  totalMortgagePerM2?: number | null;
  totalPropertyValue: number;
  totalPropertyValuePerM2?: number | null;
};
export type PortfolioOverviewReadModel = {
  summary: PortfolioOverviewSummary;
  buildings: PortfolioOverviewBuilding[];
  portfolioCashFlow: PortfolioOverviewCashFlow;
  currency: string;
};
export type RoomType =
  | 'LivingRoom'
  | 'Bedroom'
  | 'Kitchen'
  | 'Bathroom'
  | 'Toilet'
  | 'StorageRoom'
  | 'Balcony'
  | 'Loggia'
  | 'Terrace'
  | 'Other'
  | 'Office';
export type SetRoomPayload = {
  name: string;
  description?: string | null;
  address?: AddressValue | null;
  areaMetric?: number | null;
  source?: SpaceSourceExternalReferenceValue | null;
  standard?: StandardType | null;
  assetClass?: AssetClass | null;
  type: RoomType;
  id?: string | null;
};
export type RoomReadModel = {
  id: string;
  discriminator: SpaceDiscriminator;
  path: string;
  building?: BaseSpaceReadModel | null;
  parent?: BaseSpaceReadModel | null;
  name: string;
  address: AddressValue;
  description?: string | null;
  usageType?: UsageType | null;
  standard?: StandardType | null;
  area?: AreaValue | null;
  assetClass?: AssetClass | null;
  lifespan: DateIntervalValue;
  rentablePeriod?: DateIntervalValue | null;
  rent?: PriceReadModel | null;
  operationalCost?: PriceReadModel | null;
  source?: SpaceSourceExternalReferenceValue | null;
  status?: VacancyStatus | null;
  roomCount: {
    [key: string]: number | null;
  };
  tags: string[];
  tenantId?: string | null;
  tenantName?: string | null;
  agreementStatus?: AgreementStatus | null;
  hasActiveAgreements: boolean;
  type: RoomType;
};
export type CreateRoomPayload = {
  name: string;
  description?: string | null;
  address?: AddressValue | null;
  areaMetric?: number | null;
  source?: SpaceSourceExternalReferenceValue | null;
  standard?: StandardType | null;
  assetClass?: AssetClass | null;
  type: RoomType;
  parentId: string;
};
export type RoomReadModelOffsetPaginationResponse = {
  totalCount: number;
  offset: number;
  limit: number;
  items: RoomReadModel[];
  hasPrevious?: boolean;
  hasNext?: boolean;
};
export type UpdateRoomPayload = {
  name: string;
  description?: string | null;
  address?: AddressValue | null;
  areaMetric?: number | null;
  source?: SpaceSourceExternalReferenceValue | null;
  standard?: StandardType | null;
  assetClass?: AssetClass | null;
  type: RoomType;
  parentId: string;
};
export type BuildingInformation = {
  area?: AreaValue | null;
  cadastralInformation?: CadastralValue | null;
  source?: SpaceSourceExternalReferenceValue | null;
};
export type InterestRateType = 'Floating' | 'Fixed';
export type RepaymentType = 'Annuity' | 'Serial' | 'InterestOnly';
export type LoanPayload = {
  lender?: string | null;
  originalAmount?: number | null;
  outstandingAmount?: number | null;
  interestRate?: number | null;
  interestRateType: InterestRateType;
  repaymentType: RepaymentType;
  startDate?: string | null;
  maturityDate?: string | null;
  annualPayment?: number | null;
  covenantNotes?: string | null;
  currency?: string | null;
};
export type LoanReadModel = {
  id: string;
  spaceId: string;
  lender?: string | null;
  originalAmount?: number | null;
  outstandingAmount?: number | null;
  interestRate?: number | null;
  interestRateType: InterestRateType;
  repaymentType: RepaymentType;
  startDate?: string | null;
  maturityDate?: string | null;
  annualPayment?: number | null;
  covenantNotes?: string | null;
  currency: string;
};
export type PortfolioTenantStatus = 'Rented' | 'Vacant';
export type PortfolioTenantPayload = {
  companyId?: string | null;
  companyName?: string | null;
  status: PortfolioTenantStatus;
  fromDate: string;
  toDate?: string | null;
  yearlyIncome: number;
  currency?: string | null;
};
export type PortfolioTenantReadModel = {
  id: string;
  spaceId: string;
  companyId?: string | null;
  companyName?: string | null;
  status: PortfolioTenantStatus;
  fromDate: string;
  toDate?: string | null;
  yearlyIncome: number;
  currency: string;
};
export type CreateSpacePayload = {
  name: string;
  description?: string | null;
  address?: AddressValue | null;
  areaMetric?: number | null;
  source?: SpaceSourceExternalReferenceValue | null;
  standard?: StandardType | null;
  assetClass?: AssetClass | null;
  parentId?: string | null;
  rentPriceId?: string | null;
  operationalCostPriceId?: string | null;
  discriminator: SpaceDiscriminator;
};
export type SpaceOccupancyType = 'LeaseTenant' | 'SubLease' | 'Operator' | 'Other';
export type SpaceOccupancyPayload = {
  stakeholderId: string;
  occupancyType: SpaceOccupancyType;
  validFrom: string;
  validTo: string;
  areaSqM: number;
  note?: string | null;
};
export type SpaceOccupancyReadModel = {
  id?: string | null;
  spaceId: string;
  occupancyType: SpaceOccupancyType;
  stakeholderId?: string | null;
  stakeholderName?: string | null;
  validFrom: string;
  validTo?: string | null;
  areaSqM: number;
  note?: string | null;
  isDerived: boolean;
  sourceAgreementId?: string | null;
};
export type SpaceOccupancyWarningCode = 'AreaExceedsSpaceArea' | 'ImplausibleValidTo';
export type SpaceOccupancyWarning = {
  code: SpaceOccupancyWarningCode;
  occupancyId?: string | null;
  date?: string | null;
  occupiedAreaSqM?: number | null;
  spaceAreaSqM?: number | null;
};
export type SpaceOccupancyRegisterReadModel = {
  spaceId: string;
  spaceAreaSqM?: number | null;
  occupancies: SpaceOccupancyReadModel[];
  warnings: SpaceOccupancyWarning[];
};
export type BudgetReadModel = {
  id: string;
  spaceId: string;
  year: number;
  grossRentalIncome?: number | null;
  vacancyLoss?: number | null;
  energyElectricity?: number | null;
  cleaning?: number | null;
  techMaintenance?: number | null;
  securityAccess?: number | null;
  externalMaintenance?: number | null;
  plannedMaintenance?: number | null;
  repurposingUpgrade?: number | null;
  insurance?: number | null;
  propertyTax?: number | null;
  administration?: number | null;
  currency: string;
};
export type BudgetPayload = {
  year: number;
  grossRentalIncome?: number | null;
  vacancyLoss?: number | null;
  energyElectricity?: number | null;
  cleaning?: number | null;
  techMaintenance?: number | null;
  securityAccess?: number | null;
  externalMaintenance?: number | null;
  plannedMaintenance?: number | null;
  repurposingUpgrade?: number | null;
  insurance?: number | null;
  propertyTax?: number | null;
  administration?: number | null;
  currency?: string | null;
};
export type UpdateSpacePayload = {
  name: string;
  description?: string | null;
  address?: AddressValue | null;
  areaMetric?: number | null;
  source?: SpaceSourceExternalReferenceValue | null;
  standard?: StandardType | null;
  assetClass?: AssetClass | null;
  parentId?: string | null;
  rentPriceId?: string | null;
  operationalCostPriceId?: string | null;
};
export type ErpSystem = 'Tripletex' | 'Fiken' | 'PowerOffice' | 'Visma';
export type FinancialReportSummary = {
  id: string;
  year: number;
  quarter?: number | null;
  isAccumulated: boolean;
  monthsCovered: number;
  erpSystem: ErpSystem;
  fileId: string;
  fileName: string;
  uploadedAt: string;
};
export type FinancialReportUploadResult = {
  id: string;
  year: number;
  quarter?: number | null;
  erpSystem: ErpSystem;
  fileName: string;
  uploadedAt: string;
  accountCount: number;
  unmappedAccounts: number[];
};
export type ConsumptionData = {
  ts: string;
  value: number;
};
export type EnergyConsumptionData = {
  ts: string;
  values: {
    [key: string]: number;
  };
  value?: number;
};
export type OccupancyConsumptionData = {
  ts: string;
  value: number;
  occupiedArea: number;
  vacantArea: number;
  facilitiesArea: number;
  totalArea?: number;
  occupiedValue?: number;
  vacantValue?: number;
  facilitiesValue?: number;
};
export type MeterConsumptionData = {
  meter: MeterReadModel;
  values: ConsumptionData[];
  value?: number;
};
export type SpaceConsumptionData = {
  space: BaseSpaceReadModel;
  meters: MeterConsumptionData[];
  value?: number;
};
export type TenantConsumptionData = {
  tenants: LegalPersonReadModel[];
  spaces: SpaceConsumptionData[];
  value?: number;
};
export type ValuationFrequency = 'SemiAnnual' | 'Annual' | 'Biennial';
export type ValuationMethod =
  | 'Yield'
  | 'Dcf'
  | 'MarketComparable'
  | 'Residual'
  | 'Cost'
  | 'AssetValue'
  | 'Combination'
  | 'Other';
export type ValuationReportReadModel = {
  id: string;
  fileName: string;
};
export type OwnershipShareDto = {
  tenantId: string;
  name: string;
  share?: number | null;
};
export type PortfolioFinancialsReadModel = {
  id: string;
  spaceId: string;
  accountingPrinciple?: AccountingPrinciple | null;
  operatingCost?: number | null;
  interestCost?: number | null;
  loanRepayment?: number | null;
  mortgage?: number | null;
  propertyValue?: number | null;
  purchasePrice?: number | null;
  purchaseDate?: string | null;
  currency: string;
  valuationFrequency?: ValuationFrequency | null;
  valuationMethod?: ValuationMethod | null;
  exitYieldAssumption?: number | null;
  valuatorFirm?: string | null;
  valuationReports?: ValuationReportReadModel[] | null;
  ownershipShares?: OwnershipShareDto[] | null;
};
export type OwnershipShareItem = {
  tenantId: string;
  share: number;
};
export type PortfolioFinancialsPayload = {
  accountingPrinciple?: AccountingPrinciple | null;
  operatingCost?: number | null;
  interestCost?: number | null;
  loanRepayment?: number | null;
  mortgage?: number | null;
  propertyValue?: number | null;
  purchasePrice?: number | null;
  purchaseDate?: string | null;
  currency?: string | null;
  valuationFrequency?: ValuationFrequency | null;
  valuationMethod?: ValuationMethod | null;
  exitYieldAssumption?: number | null;
  valuatorFirm?: string | null;
  ownershipShares?: OwnershipShareItem[] | null;
};
export type SpaceAreaChangeTag = 'Reconstruction' | 'ControlMeasurement' | 'UserError';
export type SpaceAreaChangeReadModel = {
  id: string;
  logTime: string;
  oldAreaMetric?: number | null;
  newAreaMetric?: number | null;
  tag?: SpaceAreaChangeTag | null;
  user: string;
};
export type SpaceAssociationPair = {
  spaceAId: string;
  spaceBId: string;
};
export type SpaceAssociationMatrixReadModel = {
  spaces: SpaceReadModel[];
  associations: SpaceAssociationPair[];
  updatableSpaceIds: string[];
};
export type SetSpaceAssociationMatrixRequest = {
  associations: SpaceAssociationPair[];
};
export type SpaceHierarchyReadModel = {
  id: string;
  discriminator: SpaceDiscriminator;
  path: string;
  name: string;
  usageType?: UsageType | null;
  children: SpaceHierarchyReadModel[];
};
export type SetSpaceAreaChangeTagPayload = {
  tag?: SpaceAreaChangeTag | null;
};
export type SetSpaceChildrenPayload = {
  children: string[];
};
export type UpdateSpaceInvestorPayload = {
  investors: string[];
};
export type UpdateSpaceManagerPayload = {
  tenantId?: string | null;
};
export type UpdateSpaceOwnerPayload = {
  owners: string[];
};
export type SpaceFinancialsPayload = {
  operatingCost?: number | null;
  propertyValue?: number | null;
  currency?: string | null;
};
export type SpaceFileReadModel = {
  id: string;
  spaceId: string;
  file: FileReadModel;
};
export type SpaceFileReadModelOffsetPaginationResponse = {
  totalCount: number;
  offset: number;
  limit: number;
  items: SpaceFileReadModel[];
  hasPrevious?: boolean;
  hasNext?: boolean;
};
export type NetYieldBuildingDetailReadModel = {
  spaceId: string;
  name: string;
  operatingCost?: number | null;
  propertyValue?: number | null;
  costPerM2?: number | null;
  netIncomeAmount?: MoneyValue | null;
  netYield?: number | null;
  percentChange?: number | null;
  previousNetYield?: number | null;
};
export type CityVacancyReport = {
  city: string;
  rented: number;
  rentable: number;
  vacant?: number;
  vacancyRate?: number | null;
};
export type EndingContractReportReadModel = {
  id: string;
  discriminator: SpaceDiscriminator;
  path: string;
  name: string;
  usageType?: UsageType | null;
  parent?: BaseSpaceReadModel | null;
  address: AddressValue;
  area?: AreaValue | null;
  status?: VacancyStatus | null;
  endingOn: string;
};
export type EndingContractReportReadModelOffsetPaginationResponse = {
  totalCount: number;
  offset: number;
  limit: number;
  items: EndingContractReportReadModel[];
  hasPrevious?: boolean;
  hasNext?: boolean;
};
export type NetYieldBuildingDetailReadModelPagedListDto = {
  page: number;
  pageSize: number;
  total: number;
  items: NetYieldBuildingDetailReadModel[];
};
export type NetYieldBuildingReadModel = {
  spaceId: string;
  name: string;
  operatingCost?: number | null;
  propertyValue?: number | null;
  costPerM2?: number | null;
  netIncomeAmount?: MoneyValue | null;
  netYield?: number | null;
  percentChange?: number | null;
};
export type NetYieldSummaryReadModel = {
  selectedNetYield?: number | null;
  previousYearNetYield?: number | null;
  developmentVariance?: number | null;
};
export type RentReport = {
  total: MoneyValue;
  min: MoneyValue;
  max: MoneyValue;
  average: MoneyValue;
  minPerAreaMetric: MoneyValue;
  maxPerAreaMetric: MoneyValue;
  averagePerAreaMetric: MoneyValue;
  averageDurationDays: number;
};
export type RentReportReadModel = {
  name: string;
  counts: VacancyReport;
  rent: RentReport;
};
export type RentReportGroupType = 'CountryCode' | 'ZipPlace' | 'ZipCode' | 'StreetName' | 'StreetNumber';
export type VacantSpaceReportReadModel = {
  id: string;
  discriminator: SpaceDiscriminator;
  path: string;
  name: string;
  usageType?: UsageType | null;
  parent?: BaseSpaceReadModel | null;
  address: AddressValue;
  area?: AreaValue | null;
  status?: VacancyStatus | null;
  availableSince?: string | null;
  previousRent?: MoneyValue | null;
};
export type VacantSpaceReportReadModelOffsetPaginationResponse = {
  totalCount: number;
  offset: number;
  limit: number;
  items: VacantSpaceReportReadModel[];
  hasPrevious?: boolean;
  hasNext?: boolean;
};
export type TagReadModel = {
  id: string;
  name: string;
};
export type TagReadModelOffsetPaginationResponse = {
  totalCount: number;
  offset: number;
  limit: number;
  items: TagReadModel[];
  hasPrevious?: boolean;
  hasNext?: boolean;
};
export type UsageReadModel = {
  id: string;
  type: UsageType;
  interval: DateIntervalValue;
  commercialPercentage: number;
  vatInclusivePercentage: number;
  space: BaseSpaceReadModel;
};
export type CreateUsagePayload = {
  type: UsageType;
  interval?: OpenDateInterval | null;
  commercialPercentage: number;
  vatInclusivePercentage: number;
  spaceId: string;
};
export type UsageReadModelOffsetPaginationResponse = {
  totalCount: number;
  offset: number;
  limit: number;
  items: UsageReadModel[];
  hasPrevious?: boolean;
  hasNext?: boolean;
};
export type UsageReadModelSort = 'Default' | 'Start' | 'End';
export type SetUsageModel = {
  type: UsageType;
  interval?: OpenDateInterval | null;
  commercialPercentage: number;
  vatInclusivePercentage: number;
};
export type UserPermissionsDto = {
  roleId: string;
  role: Role;
  tenantType?: TenantType | null;
  permissions: string[];
};
export type UserSpacePermissionsDto = {
  spaceId: string;
  roles: Role[];
  permissions: string[];
};
export type GetUserSpacesPermissionsRequest = {
  spaceIds?: string[] | null;
};
export type UserAgreementPermissionsDto = {
  agreementId: string;
  roles: Role[];
  permissions: string[];
};
export type GetUserAgreementsPermissionsRequest = {
  agreementIds?: string[] | null;
};
export type PermissionDefinitionDto = {
  key: string;
  scope: string;
  scopeValue: number;
  description?: string | null;
};
export type PremisesVacancyCostDetailsDto = {
  selectedYearAmount?: MoneyDto | null;
  previousYearAmount?: MoneyDto | null;
  numberOfWeekAvailable: number;
  vacantSqmDays: number;
  changePercentage: number;
  areaMetric: number;
  spaceType: SpaceDiscriminator;
};
export type VacancyDetailsDto = {
  selectedYearAmount?: MoneyDto | null;
  previousYearAmount?: MoneyDto | null;
  numberOfWeekAvailable: number;
  vacantSqmDays: number;
  changePercentage: number;
  areaMetric: number;
  buildingId: string;
  buildingName: string;
  numberOfPremises: number;
  premises: PremisesVacancyCostDetailsDto[];
};
export type MonthlyVacancyCostDto = {
  month: number;
  cost: MoneyDto;
};
export type VacancyBuildingDto = {
  buildingId: string;
  buildingName: string;
  durationInMonths: number;
  vacancyCost: MoneyDto;
};
export type VacancyDashboardDto = {
  totalVacancyCost: MoneyDto;
  monthlyVacancyCosts: MonthlyVacancyCostDto[];
  topBuildings: VacancyBuildingDto[];
};
export type VacancyDetailsDtoPagedListDto = {
  page: number;
  pageSize: number;
  total: number;
  items: VacancyDetailsDto[];
};
export type JsonNodeOptions = {
  propertyNameCaseInsensitive: boolean;
};
export type JsonNode = {
  options?: JsonNodeOptions | null;
  parent?: JsonNode | null;
  root?: JsonNode;
};
export type DocumentSigningEvent = {
  id: string;
  type: string;
  payload: {
    [key: string]: JsonNode;
  };
  integration: DocumentSigningIntegration;
};
export const {
  useGetActivitiesLatestQuery,
  useLazyGetActivitiesLatestQuery,
  useGetAgreementPartiesQuery,
  useLazyGetAgreementPartiesQuery,
  usePostAgreementImportsBySessionIdAbandonMutation,
  usePostAgreementImportsBySessionIdContractsAndContractIdApproveMutation,
  usePostAgreementImportsBySessionIdCompleteMutation,
  usePatchAgreementImportsBySessionIdContractsAndContractIdMutation,
  usePostAgreementImportsMutation,
  useGetAgreementImportsQuery,
  useLazyGetAgreementImportsQuery,
  useGetAgreementImportsBySessionIdContractsQuery,
  useLazyGetAgreementImportsBySessionIdContractsQuery,
  useGetAgreementImportsBySessionIdContractsAndContractIdValidationQuery,
  useLazyGetAgreementImportsBySessionIdContractsAndContractIdValidationQuery,
  usePostAgreementImportsBySessionIdRowsMutation,
  usePostAgreementImportsBySessionIdContractsAndContractIdRejectMutation,
  usePostAgreementImportsBySessionIdContractsAndContractIdLinesLineIdRejectMutation,
  usePostAgreementsMutation,
  useGetAgreementsQuery,
  useLazyGetAgreementsQuery,
  useDeleteAgreementsByIdMutation,
  useGetAgreementsByIdQuery,
  useLazyGetAgreementsByIdQuery,
  usePutAgreementsByIdMutation,
  useGetAgreementsBuildingsQuery,
  useLazyGetAgreementsBuildingsQuery,
  useGetAgreementsReportToInvoiceQuery,
  useLazyGetAgreementsReportToInvoiceQuery,
  usePostAgreementsByIdRestoreMutation,
  usePostAgreementsByIdSyncTripletexMutation,
  usePostAgreementsByAgreementIdIndexAdjustmentsMutation,
  useGetAgreementsByAgreementIdIndexAdjustmentsQuery,
  useLazyGetAgreementsByAgreementIdIndexAdjustmentsQuery,
  useGetAgreementsStakeholdersQuery,
  useLazyGetAgreementsStakeholdersQuery,
  usePutAgreementsByAgreementIdSpacesMutation,
  usePostAgreementsByAgreementIdProductsMutation,
  usePutAgreementsByAgreementIdProductsMutation,
  useDeleteAgreementsByAgreementIdProductsAndPriceIdMutation,
  usePutAgreementsByAgreementIdProductsAndPriceIdMutation,
  usePostAgreementsByAgreementIdPartiesMutation,
  usePutAgreementsByAgreementIdPartiesMutation,
  useDeleteAgreementsByAgreementIdPartiesAndLegalPersonIdMutation,
  useGetAgreementsByAgreementIdPartiesAndPartyIdAvailableContactsQuery,
  useLazyGetAgreementsByAgreementIdPartiesAndPartyIdAvailableContactsQuery,
  useGetAgreementsByAgreementIdInvoiceHistoryQuery,
  useLazyGetAgreementsByAgreementIdInvoiceHistoryQuery,
  usePostAgreementsByAgreementIdFilesMutation,
  useGetAgreementsByAgreementIdFilesQuery,
  useLazyGetAgreementsByAgreementIdFilesQuery,
  useDeleteAgreementsByAgreementIdFilesAndFileIdMutation,
  useGetAgreementsByAgreementIdFilesAndFileIdDownloadQuery,
  useLazyGetAgreementsByAgreementIdFilesAndFileIdDownloadQuery,
  useGetAgreementsByAgreementIdActivityLogsQuery,
  useLazyGetAgreementsByAgreementIdActivityLogsQuery,
  usePostAuthFinishInvitationMutation,
  useGetAuthSessionQuery,
  useLazyGetAuthSessionQuery,
  useGetAuthSessionUserQuery,
  useLazyGetAuthSessionUserQuery,
  usePostBranchesMutation,
  useDeleteBranchesByIdMutation,
  usePutBranchesByIdMutation,
  usePostBuildingsMutation,
  useGetBuildingsQuery,
  useLazyGetBuildingsQuery,
  useCreateBuildingsForTenantMutation,
  useGetBuildingsByBuildingIdAvailableBidAreasQuery,
  useLazyGetBuildingsByBuildingIdAvailableBidAreasQuery,
  useGetBuildingsByBuildingIdBidAreaQuery,
  useLazyGetBuildingsByBuildingIdBidAreaQuery,
  usePutBuildingsByBuildingIdBidAreaMutation,
  useGetBuildingsByIdQuery,
  useLazyGetBuildingsByIdQuery,
  usePutBuildingsByIdMutation,
  useGetBuildingsByBuildingIdEnergySettingsQuery,
  useLazyGetBuildingsByBuildingIdEnergySettingsQuery,
  usePutBuildingsByBuildingIdEnergySettingsMutation,
  useGetBuildingsByIdInvestorQuery,
  useLazyGetBuildingsByIdInvestorQuery,
  useGetBuildingsByIdManagerQuery,
  useLazyGetBuildingsByIdManagerQuery,
  useGetBuildingsByIdOwnerQuery,
  useLazyGetBuildingsByIdOwnerQuery,
  useGetCompaniesAtBuildingAddressQuery,
  useLazyGetCompaniesAtBuildingAddressQuery,
  useGetCommercialSpacesByIdQuery,
  useLazyGetCommercialSpacesByIdQuery,
  useGetCommercialSpacesQuery,
  useLazyGetCommercialSpacesQuery,
  usePostCommonAreasMutation,
  useGetCommonAreasQuery,
  useLazyGetCommonAreasQuery,
  useGetCommonAreasByIdQuery,
  useLazyGetCommonAreasByIdQuery,
  usePutCommonAreasByIdMutation,
  usePostCompaniesMutation,
  useGetCompaniesQuery,
  useLazyGetCompaniesQuery,
  useDeleteCompaniesByIdMutation,
  useGetCompaniesByIdQuery,
  useLazyGetCompaniesByIdQuery,
  usePutCompaniesByIdMutation,
  useDeleteCompaniesByCompanyIdMembersInviteAndInvitationIdMutation,
  useGetCompaniesByCompanyIdContactPersonAssignmentsQuery,
  useLazyGetCompaniesByCompanyIdContactPersonAssignmentsQuery,
  useGetCompaniesByIdDepartmentsQuery,
  useLazyGetCompaniesByIdDepartmentsQuery,
  useGetCompaniesByCompanyIdMembersQuery,
  useLazyGetCompaniesByCompanyIdMembersQuery,
  useGetCompaniesRoleCountsQuery,
  useLazyGetCompaniesRoleCountsQuery,
  usePostCompaniesByCompanyIdMembersInviteAndInvitationIdResendMutation,
  useDeleteCompaniesByCompanyIdPersonsAndUserIdMutation,
  useGetCompaniesByCompanyIdPersonsQuery,
  useLazyGetCompaniesByCompanyIdPersonsQuery,
  usePostCompaniesByCompanyIdPersonsAndUserIdReactivateMutation,
  useDeleteContractsByIdSigningMutation,
  usePostContractsByIdSigningMutation,
  usePostContractsMutation,
  useGetContractsQuery,
  useLazyGetContractsQuery,
  useDeleteContractsByIdMutation,
  useGetContractsExpirationExportDetailsQuery,
  useLazyGetContractsExpirationExportDetailsQuery,
  useGetContractsExportDetailsQuery,
  useLazyGetContractsExportDetailsQuery,
  useGetContractsVatPercentageExportDetailsQuery,
  useLazyGetContractsVatPercentageExportDetailsQuery,
  usePostContractsAverageLengthDashboardMutation,
  useGetContractsAverageLengthQuery,
  useLazyGetContractsAverageLengthQuery,
  usePostContractsExpirationDashboardMutation,
  useGetContractsExpirationDetailsQuery,
  useLazyGetContractsExpirationDetailsQuery,
  useGetContractsExpirationSummaryQuery,
  useLazyGetContractsExpirationSummaryQuery,
  useGetContractsDetailsQuery,
  useLazyGetContractsDetailsQuery,
  useGetContractsVatPercentageDetailsQuery,
  useLazyGetContractsVatPercentageDetailsQuery,
  useGetContractsVatPercentageSummaryQuery,
  useLazyGetContractsVatPercentageSummaryQuery,
  usePostContractsByIdSignaturesMutation,
  useDeleteContractsByIdSignaturesMutation,
  usePutContractsByIdSignaturesMutation,
  useGetDataPortfolioQuery,
  useLazyGetDataPortfolioQuery,
  usePostDataPortfolioMutation,
  usePostDataPortfolioValidateMutation,
  usePostDebugFixturesMutation,
  useDeleteDebugConsumptionsByBuildingIdMutation,
  usePostDebugConsumptionsByBuildingIdMutation,
  useGetEconomySettingsChartOfAccountsQuery,
  useLazyGetEconomySettingsChartOfAccountsQuery,
  useGetEconomySettingsOverviewQuery,
  useLazyGetEconomySettingsOverviewQuery,
  useGetEconomySettingsSharedCostsQuery,
  useLazyGetEconomySettingsSharedCostsQuery,
  useGetEosAirQualityQuery,
  useLazyGetEosAirQualityQuery,
  useGetEosConsumptionByDeviceQuery,
  useLazyGetEosConsumptionByDeviceQuery,
  useGetEosConsumptionByEnergyCostQuery,
  useLazyGetEosConsumptionByEnergyCostQuery,
  useGetEosConsumptionByEnergyTypeQuery,
  useLazyGetEosConsumptionByEnergyTypeQuery,
  useGetEosConsumptionBySourceQuery,
  useLazyGetEosConsumptionBySourceQuery,
  useGetEosConsumptionSpacesQuery,
  useLazyGetEosConsumptionSpacesQuery,
  useGetEosConsumptionVsAverageQuery,
  useLazyGetEosConsumptionVsAverageQuery,
  useGetEosCorrelationQuery,
  useLazyGetEosCorrelationQuery,
  useGetEosEstimatedEnergyCostQuery,
  useLazyGetEosEstimatedEnergyCostQuery,
  useGetEosEstimatedEnergyCostSpacesQuery,
  useLazyGetEosEstimatedEnergyCostSpacesQuery,
  useGetEosTotalConsumptionQuery,
  useLazyGetEosTotalConsumptionQuery,
  useGetEosConsumptionSquareMeterQuery,
  useLazyGetEosConsumptionSquareMeterQuery,
  useGetEosTotalEnergyCostQuery,
  useLazyGetEosTotalEnergyCostQuery,
  usePostInvestmentsMutation,
  useGetInvestmentsQuery,
  useLazyGetInvestmentsQuery,
  useDeleteInvestmentsByIdMutation,
  useGetInvestmentsByIdQuery,
  useLazyGetInvestmentsByIdQuery,
  usePutInvestmentsByIdMutation,
  usePutInvestmentsByInvestmentIdSpacesMutation,
  useGetInvoicesExportOverdueDetailsQuery,
  useLazyGetInvoicesExportOverdueDetailsQuery,
  useGetInvoicesExportReceivableDetailsQuery,
  useLazyGetInvoicesExportReceivableDetailsQuery,
  usePostInvoicesDashboardMutation,
  useGetInvoicesByIdDocumentQuery,
  useLazyGetInvoicesByIdDocumentQuery,
  useGetInvoicesOverdueDetailsQuery,
  useLazyGetInvoicesOverdueDetailsQuery,
  useGetInvoicesOverdueSummaryQuery,
  useLazyGetInvoicesOverdueSummaryQuery,
  useGetInvoicesReceivableDetailsQuery,
  useLazyGetInvoicesReceivableDetailsQuery,
  useGetInvoicesReceivablesSummaryQuery,
  useLazyGetInvoicesReceivablesSummaryQuery,
  useGetKpiQuery,
  useLazyGetKpiQuery,
  useGetLegalPersonsByIdQuery,
  useLazyGetLegalPersonsByIdQuery,
  useGetLegalPersonsQuery,
  useLazyGetLegalPersonsQuery,
  usePostLegalPersonsByLegalPersonIdRepresentativesMutation,
  useGetLegalPersonsByLegalPersonIdRepresentativesQuery,
  useLazyGetLegalPersonsByLegalPersonIdRepresentativesQuery,
  useDeleteLegalPersonsByLegalPersonIdRepresentativesAndRepresentativeIdMutation,
  useGetMeterDataQuery,
  useLazyGetMeterDataQuery,
  useGetMetersQuery,
  useLazyGetMetersQuery,
  useGetOccupancyRatesExportDetailsQuery,
  useLazyGetOccupancyRatesExportDetailsQuery,
  usePostOccupancyRatesDashboardMutation,
  useGetOccupancyRatesDetailsQuery,
  useLazyGetOccupancyRatesDetailsQuery,
  useGetOccupancyRatesSummaryQuery,
  useLazyGetOccupancyRatesSummaryQuery,
  useGetOrganizationsQuery,
  useLazyGetOrganizationsQuery,
  usePutOrganizationsByOrganizationIdChildrenMutation,
  usePostOrganizationsByOrganizationIdPersonsMutation,
  useGetOrganizationsByOrganizationIdPersonsQuery,
  useLazyGetOrganizationsByOrganizationIdPersonsQuery,
  usePutOrganizationsByOrganizationIdPersonsMutation,
  useDeleteOrganizationsByOrganizationIdPersonsAndPersonIdMutation,
  usePostParkingSpotsMutation,
  useGetParkingSpotsQuery,
  useLazyGetParkingSpotsQuery,
  useGetParkingSpotsByIdQuery,
  useLazyGetParkingSpotsByIdQuery,
  usePutParkingSpotsByIdMutation,
  usePostPersonsMutation,
  useGetPersonsQuery,
  useLazyGetPersonsQuery,
  useDeletePersonsByIdMutation,
  useGetPersonsByIdQuery,
  useLazyGetPersonsByIdQuery,
  usePutPersonsByIdMutation,
  useDeletePersonsInviteByInvitationIdMutation,
  usePutPersonsAdminInviteMutation,
  usePutPersonsCompanyUserInviteMutation,
  usePutPersonsByIdInviteMutation,
  usePutPersonsTenantUserInviteMutation,
  usePutPersonsUserInviteMutation,
  usePostPersonsByIdReactivateMutation,
  usePostPersonsInviteByInvitationIdResendMutation,
  useCompletePortfolioOnboardingMutation,
  useCreatePortfolioOnboardingInvitationMutation,
  useGetCompaniesAtAddressQuery,
  useLazyGetCompaniesAtAddressQuery,
  useGetPendingPortfolioInvitationQuery,
  useLazyGetPendingPortfolioInvitationQuery,
  useSearchBuildingsQuery,
  useLazySearchBuildingsQuery,
  useGetPricesByIdQuery,
  useLazyGetPricesByIdQuery,
  useGetPricesQuery,
  useLazyGetPricesQuery,
  usePostProductsMutation,
  useGetProductsQuery,
  useLazyGetProductsQuery,
  usePostProductsByIdChildrenMutation,
  useGetProductsByIdChildrenQuery,
  useLazyGetProductsByIdChildrenQuery,
  useDeleteProductsByIdMutation,
  useGetProductsByIdQuery,
  useLazyGetProductsByIdQuery,
  usePutProductsByIdMutation,
  useDeleteProductsByIdChildrenAndChildIdMutation,
  usePutProductsByIdChildrenAndChildIdMutation,
  useGetProductsSubProductTemplatesQuery,
  useLazyGetProductsSubProductTemplatesQuery,
  useGetProductsTripletexQuery,
  useLazyGetProductsTripletexQuery,
  useGetRentalIncomesExportDetailsQuery,
  useLazyGetRentalIncomesExportDetailsQuery,
  usePostRentalIncomesDashboardMutation,
  useGetRentalIncomesDetailsQuery,
  useLazyGetRentalIncomesDetailsQuery,
  useGetRentalIncomesSummaryQuery,
  useLazyGetRentalIncomesSummaryQuery,
  useGetReportingFinancingQuery,
  useLazyGetReportingFinancingQuery,
  useGetReportingPortfolioDiversificationQuery,
  useLazyGetReportingPortfolioDiversificationQuery,
  useGetReportingPortfolioOverviewQuery,
  useLazyGetReportingPortfolioOverviewQuery,
  useGetResidentialUnitsByIdQuery,
  useLazyGetResidentialUnitsByIdQuery,
  useGetResidentialUnitsQuery,
  useLazyGetResidentialUnitsQuery,
  usePutResidentialUnitsByIdRoomsMutation,
  usePostRoomsMutation,
  useGetRoomsQuery,
  useLazyGetRoomsQuery,
  useGetRoomsByIdQuery,
  useLazyGetRoomsByIdQuery,
  usePutRoomsByIdMutation,
  useGetSourcesAddressesFilterQuery,
  useLazyGetSourcesAddressesFilterQuery,
  useGetSourcesBuildingsByIntegrationAndIdentifierQuery,
  useLazyGetSourcesBuildingsByIntegrationAndIdentifierQuery,
  useGetSourcesAddressesSearchQuery,
  useLazyGetSourcesAddressesSearchQuery,
  usePostSpacesByIdLoansMutation,
  useGetSpacesByIdLoansQuery,
  useLazyGetSpacesByIdLoansQuery,
  usePostSpacesByIdPortfolioTenantsMutation,
  useGetSpacesByIdPortfolioTenantsQuery,
  useLazyGetSpacesByIdPortfolioTenantsQuery,
  usePostSpacesMutation,
  useGetSpacesQuery,
  useLazyGetSpacesQuery,
  usePostSpacesByIdOccupanciesMutation,
  useGetSpacesByIdOccupanciesQuery,
  useLazyGetSpacesByIdOccupanciesQuery,
  useDeleteSpacesByIdBudgetsAndYearMutation,
  useGetSpacesByIdBudgetsAndYearQuery,
  useLazyGetSpacesByIdBudgetsAndYearQuery,
  usePutSpacesByIdBudgetsAndYearMutation,
  useDeleteSpacesByIdLoansAndLoanIdMutation,
  usePutSpacesByIdLoansAndLoanIdMutation,
  useDeleteSpacesByIdPortfolioTenantsAndTenantIdMutation,
  usePutSpacesByIdPortfolioTenantsAndTenantIdMutation,
  useDeleteSpacesByIdMutation,
  useGetSpacesByIdQuery,
  useLazyGetSpacesByIdQuery,
  usePutSpacesByIdMutation,
  useDeleteSpacesByIdOccupanciesAndOccupancyIdMutation,
  usePutSpacesByIdOccupanciesAndOccupancyIdMutation,
  useGetSpacesByIdFinancialReportsQuery,
  useLazyGetSpacesByIdFinancialReportsQuery,
  usePostSpacesByIdFinancialReportsAndYearMutation,
  useDeleteSpacesByIdFinancialReportsAndYearMutation,
  useGetSpacesByIdFinancialReportsAndYearFileQuery,
  useLazyGetSpacesByIdFinancialReportsAndYearFileQuery,
  useGetSpacesByIdBudgetsQuery,
  useLazyGetSpacesByIdBudgetsQuery,
  useGetSpacesByIdConsumptionQuery,
  useLazyGetSpacesByIdConsumptionQuery,
  useGetSpacesByIdConsumptionEnergyQuery,
  useLazyGetSpacesByIdConsumptionEnergyQuery,
  useGetSpacesByIdConsumptionOccupancyQuery,
  useLazyGetSpacesByIdConsumptionOccupancyQuery,
  useGetSpacesByIdConsumptionTenantsQuery,
  useLazyGetSpacesByIdConsumptionTenantsQuery,
  useGetSpacesByIdPortfolioFinancialsQuery,
  useLazyGetSpacesByIdPortfolioFinancialsQuery,
  usePutSpacesByIdPortfolioFinancialsMutation,
  useGetSpacesByIdAreaChangesQuery,
  useLazyGetSpacesByIdAreaChangesQuery,
  useGetSpacesByBuildingIdAssociationMatrixQuery,
  useLazyGetSpacesByBuildingIdAssociationMatrixQuery,
  usePutSpacesByBuildingIdAssociationMatrixMutation,
  useGetSpacesByIdAssociationsQuery,
  useLazyGetSpacesByIdAssociationsQuery,
  usePutSpacesByIdAssociationsMutation,
  useGetSpacesByIdHierarchyQuery,
  useLazyGetSpacesByIdHierarchyQuery,
  usePutSpacesByIdAreaChangesAndChangeIdTagMutation,
  usePutSpacesByIdChildrenMutation,
  usePutSpacesByIdTagsMutation,
  usePutSpacesByIdInvestorMutation,
  usePutSpacesByIdManagerMutation,
  usePutSpacesByIdOwnerMutation,
  usePutSpacesByIdFinancialsMutation,
  usePostSpacesByIdPortfolioFinancialsValuationReportsMutation,
  useGetSpacesByIdPortfolioFinancialsValuationReportsAndReportIdQuery,
  useLazyGetSpacesByIdPortfolioFinancialsValuationReportsAndReportIdQuery,
  useDeleteSpacesByIdPortfolioFinancialsValuationReportsAndReportIdMutation,
  useGetSpacesStakeholdersQuery,
  useLazyGetSpacesStakeholdersQuery,
  usePostSpacesBySpaceIdFilesMutation,
  useGetSpacesBySpaceIdFilesQuery,
  useLazyGetSpacesBySpaceIdFilesQuery,
  useDeleteSpacesBySpaceIdFilesAndFileIdMutation,
  useGetStatisticsNetYieldBuildingsExportQuery,
  useLazyGetStatisticsNetYieldBuildingsExportQuery,
  useGetStatisticsCitiesVacancyQuery,
  useLazyGetStatisticsCitiesVacancyQuery,
  useGetStatisticsSpacesEndingContractQuery,
  useLazyGetStatisticsSpacesEndingContractQuery,
  useGetStatisticsNetYieldBuildingsByIdQuery,
  useLazyGetStatisticsNetYieldBuildingsByIdQuery,
  useGetStatisticsNetYieldBuildingsQuery,
  useLazyGetStatisticsNetYieldBuildingsQuery,
  usePostStatisticsNetYieldDashboardMutation,
  useGetStatisticsNetYieldQuery,
  useLazyGetStatisticsNetYieldQuery,
  useGetStatisticsRentQuery,
  useLazyGetStatisticsRentQuery,
  useGetStatisticsSpacesVacancyQuery,
  useLazyGetStatisticsSpacesVacancyQuery,
  useGetStatisticsVacancyQuery,
  useLazyGetStatisticsVacancyQuery,
  useGetTagsQuery,
  useLazyGetTagsQuery,
  useGetTenantsCurrentCompanyQuery,
  useLazyGetTenantsCurrentCompanyQuery,
  useGetTenantsCurrentMembersQuery,
  useLazyGetTenantsCurrentMembersQuery,
  useGetTenantsByTenantIdPersonsQuery,
  useLazyGetTenantsByTenantIdPersonsQuery,
  usePostUsagesMutation,
  useGetUsagesQuery,
  useLazyGetUsagesQuery,
  useDeleteUsagesByIdMutation,
  useGetUsagesByIdQuery,
  useLazyGetUsagesByIdQuery,
  usePutUsagesByIdMutation,
  useGetUserPermissionsQuery,
  useLazyGetUserPermissionsQuery,
  usePostUserPermissionsSpacesMutation,
  useGetUserPermissionsSpacesByIdQuery,
  useLazyGetUserPermissionsSpacesByIdQuery,
  usePostUserPermissionsAgreementsMutation,
  useGetUserPermissionsAgreementsByIdQuery,
  useLazyGetUserPermissionsAgreementsByIdQuery,
  useGetUserPermissionsDefinitionsQuery,
  useLazyGetUserPermissionsDefinitionsQuery,
  useGetVacancyExportDetailsQuery,
  useLazyGetVacancyExportDetailsQuery,
  usePostVacancyDashboardMutation,
  useGetVacancyDetailsQuery,
  useLazyGetVacancyDetailsQuery,
  useGetVacancySummaryQuery,
  useLazyGetVacancySummaryQuery,
  usePostWebhooksDocumentSigningMutation,
} = injectedRtkApi;
